var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});

// src/companies/components/CompaniesSearchBox.tsx
import {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

// ../../node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// ../../node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// ../../node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string6) {
  var index2 = string6.length;
  while (index2-- && reWhitespace.test(string6.charAt(index2))) {
  }
  return index2;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string6) {
  return string6 ? string6.slice(0, trimmedEndIndex_default(string6) + 1).replace(reTrimStart, "") : string6;
}
var baseTrim_default = baseTrim;

// ../../node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject;

// ../../node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/lodash-es/now.js
var now = function() {
  return root_default.Date.now();
};
var now_default = now;

// ../../node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now_default();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time2 = now_default(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce;

// src/companies/components/CompaniesSearchBox.tsx
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Combobox as Combobox2 } from "@headlessui/react";

// src/companies/components/__generated__/CompaniesSearchOptionsQuery.graphql.ts
var node = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "page"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "term"
  }, v2 = [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "term",
          "variableName": "term"
        }
      ],
      "concreteType": "CompanySearchResult",
      "kind": "LinkedField",
      "name": "companiesCanonicalCompaniesSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanySearchResultItem",
          "kind": "LinkedField",
          "name": "results",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerified",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industry",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CompaniesSearchOptionsQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CompaniesSearchOptionsQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "918025f8c27fde126a6d049b7317e961",
      "id": null,
      "metadata": {},
      "name": "CompaniesSearchOptionsQuery",
      "operationKind": "query",
      "text": "query CompaniesSearchOptionsQuery(\n  $term: String!\n  $page: Int!\n) {\n  results: companiesCanonicalCompaniesSearch(term: $term, page: $page) {\n    total\n    results {\n      id\n      name\n      isVerified\n      industry\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "001e181598096633fd9b2d9bce2bedb6";
var CompaniesSearchOptionsQuery_graphql_default = node;

// src/companies/components/CompaniesSearchOptions.tsx
import { useLazyLoadQuery } from "react-relay";
import { Combobox } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/solid";
import { isNotNull } from "shared-lib";
import { classNames } from "shared-ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var queryDef = CompaniesSearchOptionsQuery_graphql_default;
var CompaniesSearchOptions = ({
  term,
  page,
  onNoResults
}) => {
  const query = useLazyLoadQuery(
    queryDef,
    { term, page: page || 1 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { results } = query;
  const rows = (results?.results ?? []).filter(isNotNull);
  if (term && rows && rows.length === 0) {
    onNoResults();
  }
  return /* @__PURE__ */ jsx(Combobox.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx(
    Combobox.Option,
    {
      "aria-label": result && result.name ? result.name : "Company Options",
      value: result,
      className: ({ active }) => classNames(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "flex", children: /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result && result.name ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/companies/components/CompaniesSearchBox.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var compareResults = (a, b) => a?.id === b?.id;
var CompaniesSearchBox = ({
  name,
  onSelected,
  onNoResults,
  value,
  disabled,
  placeholder
}) => {
  const [selected, setSelected] = useState(value);
  const [searchTerm, setSearchTerm] = useState("");
  const onQueryChangeHandler = useMemo(
    () => debounce_default((q) => setSearchTerm(q), 500),
    []
  );
  useEffect(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx2(Suspense, { fallback: /* @__PURE__ */ jsx2("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx2(
    Combobox2,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      disabled,
      by: compareResults,
      children: /* @__PURE__ */ jsxs2("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx2(
          Combobox2.Input,
          {
            "aria-label": placeholder || "Search Companies",
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result || !result.name) {
                return "";
              }
              return result.name;
            },
            placeholder: placeholder || "Search Companies",
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx2(
          Combobox2.Button,
          {
            className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
            "aria-label": "Company Search Box",
            children: /* @__PURE__ */ jsx2(
              ChevronUpDownIcon,
              {
                className: "h-5 w-5 text-gray-600",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx2(Suspense, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx2(
          CompaniesSearchOptions,
          {
            term: searchTerm,
            page: 1,
            onNoResults: () => onNoResults(searchTerm)
          }
        ) })
      ] })
    }
  ) });
};

// src/companies/components/CompaniesSearchBoxInput.tsx
import { useCallback as useCallback2 } from "react";
import { Controller } from "react-hook-form";
import { useToggle } from "shared-lib";
import { Button, Input, Size } from "shared-ui";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CompaniesSearchBoxInput = ({
  name,
  control,
  onSelected,
  showCreate
}) => {
  const onNoResults = useCallback2((term) => {
    console.log(term);
  }, []);
  const [isNewCompany, toggleIsNewCompany] = useToggle(false);
  if (showCreate === void 0) {
    showCreate = true;
  }
  return /* @__PURE__ */ jsxs3("div", { className: "flex flex-col gap-2", children: [
    isNewCompany ? /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsx3(
      Controller,
      {
        control,
        name,
        render: ({ field: { onChange: onControllerChange, value } }) => {
          return /* @__PURE__ */ jsx3(
            Input,
            {
              "aria-label": "Search company",
              name,
              onChange: (newValue) => {
                onControllerChange(newValue);
              },
              value: typeof value == "string" ? value : ""
            }
          );
        }
      }
    ) }) : /* @__PURE__ */ jsx3(
      Controller,
      {
        control,
        name,
        render: ({ field: { onChange: onControllerChange, value } }) => {
          return /* @__PURE__ */ jsx3(
            CompaniesSearchBox,
            {
              name,
              onSelected: (result) => {
                onControllerChange(result);
                if (onSelected) {
                  onSelected(result);
                }
              },
              onNoResults,
              value: value ?? null
            }
          );
        }
      }
    ),
    showCreate && /* @__PURE__ */ jsx3("div", { className: "self-end", children: /* @__PURE__ */ jsx3(
      Button,
      {
        "aria-label": isNewCompany ? "Search existing companies" : "Add new company",
        size: Size.sm,
        color: "primary",
        onClick: (e) => {
          e.preventDefault();
          toggleIsNewCompany();
        },
        children: isNewCompany ? "Search existing companies" : "Add new company"
      }
    ) })
  ] });
};

// src/companies/components/CompaniesSearchContainer.tsx
import { useCallback as useCallback3, useState as useState2 } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var CompaniesSearchContainer = ({
  name,
  onSearchCompleted,
  value,
  disabled
}) => {
  const [selectedResult, setSelectedResult] = useState2();
  const onSetSelected = useCallback3(
    (r) => {
      setSelectedResult(r);
      onSearchCompleted(r);
    },
    [selectedResult]
  );
  const onNoResults = useCallback3((term) => {
    console.log(term);
  }, []);
  return /* @__PURE__ */ jsx4(
    CompaniesSearchBox,
    {
      name: name || "geo-countries-search",
      onSelected: onSetSelected,
      onNoResults,
      value,
      disabled
    }
  );
};

// src/companies/components/CompaniesRoute.tsx
import { Suspense as Suspense5 } from "react";
import { Navigate, Outlet as Outlet2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary2 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback2, OutletRoute } from "app-core";

// src/companies/components/__generated__/CompaniesListContainerQuery.graphql.ts
var node2 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }, v2 = {
    "alias": "industryCounts",
    "args": null,
    "concreteType": "IndustryCount",
    "kind": "LinkedField",
    "name": "companiesIndustryCount",
    "plural": true,
    "selections": [
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industry",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "alias": "companyTypeCounts",
    "args": null,
    "concreteType": "TypeCount",
    "kind": "LinkedField",
    "name": "companiesTypeCount",
    "plural": true,
    "selections": [
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  }, v5 = {
    "alias": "companyCountryCounts",
    "args": null,
    "concreteType": "CountryCount",
    "kind": "LinkedField",
    "name": "companiesCountryCount",
    "plural": true,
    "selections": [
      v1,
      v4
    ],
    "storageKey": null
  }, v6 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v7 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v6
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompaniesListContainerQuery",
      "selections": [
        v2,
        v3,
        v5,
        {
          "args": [
            v6
          ],
          "kind": "FragmentSpread",
          "name": "CompaniesListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompaniesListContainerQuery",
      "selections": [
        v2,
        v3,
        v5,
        {
          "alias": "list",
          "args": v7,
          "concreteType": "CompaniesCanonicalCompaniesConnection",
          "kind": "LinkedField",
          "name": "companiesCanonicalCompanies",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompaniesCanonicalCompaniesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CanonicalCompany",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v7,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CompaniesListContainer_list",
          "kind": "LinkedHandle",
          "name": "companiesCanonicalCompanies"
        }
      ]
    },
    "params": {
      "cacheID": "05edcfe4574e8ec8cde060643a52d695",
      "id": null,
      "metadata": {},
      "name": "CompaniesListContainerQuery",
      "operationKind": "query",
      "text": "query CompaniesListContainerQuery(\n  $where: CanonicalCompanyFilter!\n) {\n  industryCounts: companiesIndustryCount {\n    count\n    industry\n  }\n  companyTypeCounts: companiesTypeCount {\n    count\n    companyType\n  }\n  companyCountryCounts: companiesCountryCount {\n    count\n    country\n  }\n  ...CompaniesListContainer_list_3FC4Qo\n}\n\nfragment CompaniesListContainer_list_3FC4Qo on Query {\n  list: companiesCanonicalCompanies(first: 25, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        companyId\n        code\n        createdAt\n        updatedAt\n        name\n        country\n        isVerified\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node2.hash = "4c0dd6bccf592fe1aeedbcf2706efd2b";
var CompaniesListContainerQuery_graphql_default = node2;

// src/companies/components/__generated__/CompaniessListContainerPaginationQuery.graphql.ts
var node3 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompaniessListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "CompaniesListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompaniessListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "CompaniesCanonicalCompaniesConnection",
          "kind": "LinkedField",
          "name": "companiesCanonicalCompanies",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompaniesCanonicalCompaniesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CanonicalCompany",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "country",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isVerified",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "CompaniesListContainer_list",
          "kind": "LinkedHandle",
          "name": "companiesCanonicalCompanies"
        }
      ]
    },
    "params": {
      "cacheID": "f83f26b2ead7f017684fe08f3e4be15f",
      "id": null,
      "metadata": {},
      "name": "CompaniessListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query CompaniessListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: CanonicalCompanyFilter!\n) {\n  ...CompaniesListContainer_list_3sueo6\n}\n\nfragment CompaniesListContainer_list_3sueo6 on Query {\n  list: companiesCanonicalCompanies(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        companyId\n        code\n        createdAt\n        updatedAt\n        name\n        country\n        isVerified\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "ed99a842fe6db152242785c264b908b4";
var CompaniessListContainerPaginationQuery_graphql_default = node3;

// src/companies/components/__generated__/CompaniesListContainer_list.graphql.ts
var node4 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": CompaniessListContainerPaginationQuery_graphql_default
      }
    },
    "name": "CompaniesListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CompaniesCanonicalCompaniesConnection",
        "kind": "LinkedField",
        "name": "__CompaniesListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompaniesCanonicalCompaniesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CanonicalCompany",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node4.hash = "ed99a842fe6db152242785c264b908b4";
var CompaniesListContainer_list_graphql_default = node4;

// src/companies/components/CompaniesListContainer.tsx
import { useCallback as useCallback7, useState as useState3 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2, usePaginationFragment } from "react-relay";
import { useLocalStorage } from "react-use";
import { formatDistanceToNow, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Suspense as Suspense2 } from "shared-ui";
import {
  Button as Button2,
  ButtonList,
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  EdListHeader,
  EdSkeleton,
  Input as Input2,
  ListLayout,
  PageHeading
} from "shared-ui";
import { isNotNullOrUndefined, useDebounce } from "shared-lib";

// src/companies/components/CompanyIndustryList.tsx
import { useCallback as useCallback4, useMemo as useMemo2 } from "react";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var CompanyIndustryList = ({
  industry,
  industryCounts,
  onSelect
}) => {
  const onChange = useCallback4(
    (e) => {
      onSelect(e.target.value);
    },
    [onSelect]
  );
  const industryOptions = useMemo2(() => {
    return industryCounts.map((d) => {
      return /* @__PURE__ */ jsxs4("option", { "aria-label": d.industry, value: d.industry, children: [
        d.industry,
        " (",
        d.count,
        ")"
      ] }, d.industry);
    });
  }, [industryCounts]);
  return /* @__PURE__ */ jsxs4(
    "select",
    {
      "aria-label": "Industry",
      id: "industryOptions",
      name: "industryOptions",
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange,
      value: industry,
      children: [
        /* @__PURE__ */ jsx5("option", { value: "", children: "--Select--" }, ""),
        industryOptions
      ]
    }
  );
};

// src/companies/components/CompanyTypeList.tsx
import { useCallback as useCallback5, useMemo as useMemo3 } from "react";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var CompanyTypeList = ({
  companyType,
  companyTypeCounts,
  onSelect
}) => {
  const onChange = useCallback5(
    (e) => {
      onSelect(e.target.value);
    },
    [onSelect]
  );
  const companyTypeOptions = useMemo3(() => {
    return companyTypeCounts.map((d) => {
      const name = d.companyType;
      return /* @__PURE__ */ jsxs5("option", { "aria-label": name, value: name, children: [
        name,
        " (",
        d.count,
        ")"
      ] }, `CompanyTypeList-${name}`);
    });
  }, [companyTypeCounts]);
  return /* @__PURE__ */ jsxs5(
    "select",
    {
      "aria-label": "Company Type",
      id: "companyTypeOptions",
      name: "companyTypeOptions",
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange,
      value: companyType,
      children: [
        /* @__PURE__ */ jsx6("option", { value: "", children: "--Select--" }, ""),
        companyTypeOptions
      ]
    }
  );
};

// src/companies/components/CompanyCountryList.tsx
import { useCallback as useCallback6, useMemo as useMemo4 } from "react";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var CompanyCountryList = ({
  country,
  countryCounts,
  onSelect
}) => {
  const onChange = useCallback6(
    (e) => {
      onSelect(e.target.value);
    },
    [onSelect]
  );
  const countryOptions = useMemo4(() => {
    return countryCounts.map((d) => {
      const name = d.country;
      return /* @__PURE__ */ jsxs6(
        "option",
        {
          "aria-label": name,
          value: name,
          children: [
            name,
            " (",
            d.count,
            ")"
          ]
        },
        `CompanyCountryList-${name}`
      );
    });
  }, [countryCounts]);
  return /* @__PURE__ */ jsxs6(
    "select",
    {
      "aria-label": "Select Country",
      id: "countryOptions",
      name: "countryOptions",
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange,
      value: country,
      children: [
        /* @__PURE__ */ jsx7("option", { value: "", children: "--Select--" }, ""),
        countryOptions
      ]
    }
  );
};

// src/companies/components/CompaniesListContainer.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var queryDef2 = CompaniesListContainerQuery_graphql_default;
var fragmentDef = CompaniesListContainer_list_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List = ({ fragmentRef }) => {
  const paging = usePaginationFragment(fragmentDef, fragmentRef);
  const { data, loadNext } = paging;
  const onLoadNext = useCallback7(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined).map((company) => {
    const name = `${company.name}`;
    return {
      key: company.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx8("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx8("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx8("div", { className: "text-md text-blue-700", children: company.code })
      ] }) }),
      description: /* @__PURE__ */ jsx8("div", { className: "pt-2 text-sm", children: company.createdAt && /* @__PURE__ */ jsxs7("span", { children: [
        "Created ",
        formatDistanceToNow(parseISO(company.createdAt))
      ] }) }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: company.code
      },
      element: /* @__PURE__ */ jsx8(DefaultListLayoutSectionElement, { children: /* @__PURE__ */ jsx8("div", { className: "grid", children: /* @__PURE__ */ jsx8("div", { children: company.code }) }) })
    };
  });
  return /* @__PURE__ */ jsxs7(Suspense2, { fallback: /* @__PURE__ */ jsx8(EdSkeleton, {}), children: [
    /* @__PURE__ */ jsx8(EdListHeader, { total: data.list?.totalCount, paging }),
    /* @__PURE__ */ jsx8(
      ListLayout,
      {
        sections,
        itemHeader: (s) => /* @__PURE__ */ jsx8(
          DefaultListLayoutItemHeader,
          {
            title: "Tenants",
            to: createLinkTo,
            section: s
          }
        ),
        loadMore: onLoadNext,
        isLoading: false
      }
    )
  ] });
};
var CompaniesListContainer = () => {
  const navigate = useNavigate();
  const [industry, setIndustry] = useLocalStorage(
    "companies-list-industry",
    ""
  );
  const [type, setType] = useLocalStorage("companies-list-type", "");
  const [country, setCountry] = useLocalStorage(
    "companies-list-country",
    ""
  );
  const [filter2, setFilter] = useState3(null);
  const searchTerm = useDebounce(filter2, 500);
  const and = [];
  if (searchTerm && searchTerm != "") {
    and.push({ name: { startsWith: filter2 } });
  }
  if (industry && industry != "") {
    and.push({ industry: { eq: industry } });
  }
  if (country && country != "") {
    if (country !== "--Unknown--") {
      and.push({ country: { eq: country } });
    }
  }
  if (type && type != "") {
    if (type !== "--Unknown--") {
      and.push({ type: { eq: type } });
    }
  }
  const where = { and };
  const query = useLazyLoadQuery2(
    queryDef2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const onCreate = useCallback7(() => {
    navigate(`../../create`);
  }, [navigate]);
  const { industryCounts, companyTypeCounts, companyCountryCounts } = query;
  return /* @__PURE__ */ jsxs7("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx8(Suspense2, { fallback: /* @__PURE__ */ jsx8(EdSkeleton, {}), children: /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs7("div", { className: "flex items-center gap-2 space-x-4 border-b", children: [
        /* @__PURE__ */ jsx8(PageHeading, { children: "Companies" }),
        /* @__PURE__ */ jsxs7("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx8("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx8("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx8(
            Input2,
            {
              "aria-label": "Name",
              placeholder: " Name ",
              name: "filter",
              onValueChange: (filter3) => setFilter(filter3)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs7("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx8("label", { className: "text-gray-700", htmlFor: "industryOptions", children: "Industry" }),
          /* @__PURE__ */ jsx8("div", { className: "", children: /* @__PURE__ */ jsx8(
            CompanyIndustryList,
            {
              industry,
              industryCounts,
              onSelect: setIndustry
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs7("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx8("label", { className: "text-gray-700", htmlFor: "companyTypeOptions", children: "Type" }),
          /* @__PURE__ */ jsx8("div", { className: "", children: /* @__PURE__ */ jsx8(
            CompanyTypeList,
            {
              companyType: type,
              companyTypeCounts,
              onSelect: setType
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs7("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx8("label", { className: "text-gray-700", htmlFor: "countryOptions", children: "Country" }),
          /* @__PURE__ */ jsx8("div", { className: "", children: /* @__PURE__ */ jsx8(
            CompanyCountryList,
            {
              country,
              countryCounts: companyCountryCounts,
              onSelect: setCountry
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx8("div", { className: "flex items-center gap-2 space-x-4 border-b", children: /* @__PURE__ */ jsx8(ButtonList, { children: /* @__PURE__ */ jsx8(Button2, { "aria-label": "Create", color: "primary", clicked: onCreate, children: "Create" }) }) })
    ] }) }),
    /* @__PURE__ */ jsx8("div", { className: "flex-1", children: /* @__PURE__ */ jsx8(Suspense2, { fallback: /* @__PURE__ */ jsx8(EdSkeleton, {}), children: /* @__PURE__ */ jsx8(List, { fragmentRef: query }) }) })
  ] });
};

// src/companies/components/__generated__/CompanyRouteQuery.graphql.ts
var node5 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "companyCode"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "code",
      "variableName": "companyCode"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "updatedAt",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVerified",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "CanonicalCompany",
    "kind": "LinkedField",
    "name": "substituteCompany",
    "plural": false,
    "selections": [
      v2,
      v10,
      v3,
      v7,
      v8
    ],
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "CompaniesStrongPattern",
    "kind": "LinkedField",
    "name": "strongPatterns",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pattern",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "CompanyRouteQuery",
      "selections": [
        {
          "alias": "company",
          "args": v1,
          "concreteType": "CanonicalCompany",
          "kind": "LinkedField",
          "name": "companiesCanonicalCompanyByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CompanyUpdateContainer_company"
            },
            v13
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "CompanyRouteQuery",
      "selections": [
        {
          "alias": "company",
          "args": v1,
          "concreteType": "CanonicalCompany",
          "kind": "LinkedField",
          "name": "companiesCanonicalCompanyByCode",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "substituteVectorCompanyId",
              "storageKey": null
            },
            v13
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "a0cfc1737b1c330f1da1cad0f0083255",
      "id": null,
      "metadata": {},
      "name": "CompanyRouteQuery",
      "operationKind": "query",
      "text": "query CompanyRouteQuery(\n  $companyCode: Int!\n) {\n  company: companiesCanonicalCompanyByCode(code: $companyCode) {\n    id\n    companyId\n    code\n    createdAt\n    updatedAt\n    name\n    industry\n    country\n    isVerified\n    substituteCompany {\n      id\n      isVerified\n      companyId\n      name\n      industry\n    }\n    strongPatterns {\n      pattern\n    }\n    ...CompanyUpdateContainer_company\n  }\n}\n\nfragment CompanyUpdateContainer_company on CanonicalCompany {\n  id\n  companyId\n  code\n  createdAt\n  updatedAt\n  substituteVectorCompanyId\n  name\n  industry\n  substituteCompany {\n    id\n    isVerified\n    companyId\n    name\n    industry\n  }\n  strongPatterns {\n    pattern\n  }\n}\n"
    }
  };
}();
node5.hash = "431e4be9a5005a13bba77a6abb17e0cd";
var CompanyRouteQuery_graphql_default = node5;

// src/companies/components/CompanyRoute.tsx
import { Suspense as Suspense4 } from "react";
import {
  loadQuery,
  usePreloadedQuery
} from "react-relay";
import {
  Outlet,
  useRouteLoaderData,
  Link
} from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import {
  Button as Button5,
  EdLink,
  EdSkeleton as EdSkeleton3,
  EdTextLink,
  ErrorContainer,
  PageHeading as PageHeading2
} from "shared-ui";
import { ErrorBoundaryFallback } from "app-core";

// src/companies/components/CompanyContainer.tsx
import { useCallback as useCallback11 } from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { Button as Button4, ButtonList as ButtonList2, EdSkeleton as EdSkeleton2, MynPageTitle, Size as Size2 } from "shared-ui";
import { useToggle as useToggle3 } from "shared-lib";

// src/companies/components/__generated__/CompanyUpdateContainer_company.graphql.ts
var node6 = /* @__PURE__ */ function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyUpdateContainer_company",
    "selections": [
      v0,
      v1,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "substituteVectorCompanyId",
        "storageKey": null
      },
      v2,
      v3,
      {
        "alias": null,
        "args": null,
        "concreteType": "CanonicalCompany",
        "kind": "LinkedField",
        "name": "substituteCompany",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isVerified",
            "storageKey": null
          },
          v1,
          v2,
          v3
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CompaniesStrongPattern",
        "kind": "LinkedField",
        "name": "strongPatterns",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pattern",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "CanonicalCompany",
    "abstractKey": null
  };
}();
node6.hash = "392c286fefae40c9c2e119bd3a861d4f";
var CompanyUpdateContainer_company_graphql_default = node6;

// src/companies/components/CompanyUpdateContainer.tsx
import { useCallback as useCallback9, useMemo as useMemo6 } from "react";
import { useFragment } from "react-relay";
import * as zod from "zod";
import { useForm, useFieldArray, Controller as Controller2 } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  createClientMutationId,
  useSetUserErrorCodes,
  useToggle as useToggle2,
  useUserErrorCode
} from "shared-lib";
import {
  ActionContainer,
  Button as Button3,
  ErrorField,
  FormErrorCodes,
  FormInputRow,
  InputField,
  LinkButton
} from "shared-ui";

// src/companies/mutations/__generated__/UseCompanyCreateMutation.graphql.ts
var node7 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCanonicalCompany",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CanonicalCompany",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCompanyCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyCreatePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCompanyCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyCreatePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ecb01772fe60a6849801f6e65191d16b",
      "id": null,
      "metadata": {},
      "name": "UseCompanyCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseCompanyCreateMutation(\n  $input: CompaniesCompanyCreateInput!\n) {\n  data: companiesCompanyCreate(input: $input) {\n    payload {\n      node {\n        id\n        companyId\n        code\n        name\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "5202d593d39bfeb5560a23cfab5b3821";
var UseCompanyCreateMutation_graphql_default = node7;

// src/companies/mutations/UseCompanyCreate.ts
import { useAsyncMutation } from "shared-lib";
var mutationDef = UseCompanyCreateMutation_graphql_default;
function useUseCompanyCreate() {
  const [commit, isBusy] = useAsyncMutation(mutationDef);
  return [commit, isBusy];
}

// src/companies/mutations/__generated__/UseCompanyMergeMutation.graphql.ts
var node8 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVerified",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCanonicalCompany",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CanonicalCompany",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alsoMapsTo",
            "storageKey": null
          },
          v6,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wikipediaUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duedilUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "crunchbaseUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openCorporatesUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sicCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overview",
            "storageKey": null
          },
          v7,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "founded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "specialties",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "country",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hq",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street3",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinNumFollowers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alsoViewed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketCompaniesId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUpdatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ordinal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "substituteVectorCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CanonicalCompany",
            "kind": "LinkedField",
            "name": "substituteCompany",
            "plural": false,
            "selections": [
              v2,
              v6,
              v3,
              v5,
              v7
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompaniesStrongPattern",
            "kind": "LinkedField",
            "name": "strongPatterns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canonicalCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pattern",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCompanyMergeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyMergePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyMerge",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCompanyMergeMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyMergePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyMerge",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "d074b869351c651b7e10f234be69858d",
      "id": null,
      "metadata": {},
      "name": "UseCompanyMergeMutation",
      "operationKind": "mutation",
      "text": "mutation UseCompanyMergeMutation(\n  $input: CompaniesCompanyMergeInput!\n) {\n  data: companiesCompanyMerge(input: $input) {\n    payload {\n      node {\n        id\n        companyId\n        code\n        name\n        alsoMapsTo\n        isVerified\n        wikipediaUrl\n        duedilUrl\n        crunchbaseUrl\n        openCorporatesUrl\n        sicCode\n        website\n        slug\n        updatedAt\n        updatedBy\n        createdAt\n        createdBy\n        isDeleted\n        overview\n        industry\n        size\n        founded\n        type\n        specialties\n        country\n        city\n        state\n        postal\n        hq\n        street1\n        street2\n        street3\n        linkedinId\n        linkedinUrl\n        imageUrl\n        linkedinNumFollowers\n        alsoViewed\n        marketCompaniesId\n        linkedinUpdatedAt\n        ordinal\n        substituteVectorCompanyId\n        substituteCompany {\n          id\n          isVerified\n          companyId\n          name\n          industry\n        }\n        strongPatterns {\n          canonicalCompanyId\n          pattern\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "9d5e20f81e9204fd0b57a1df6cb8abb8";
var UseCompanyMergeMutation_graphql_default = node8;

// src/companies/mutations/UseCompanyMerge.ts
import { useAsyncMutation as useAsyncMutation2 } from "shared-lib";
var mutationDef2 = UseCompanyMergeMutation_graphql_default;
function useUseCompanyMerge() {
  const [commit, isBusy] = useAsyncMutation2(mutationDef2);
  return [commit, isBusy];
}

// src/companies/mutations/__generated__/UseCompanyUpdateMutation.graphql.ts
var node9 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isVerified",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "industry",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCanonicalCompany",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CanonicalCompany",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v2,
          v3,
          v4,
          v5,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alsoMapsTo",
            "storageKey": null
          },
          v6,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wikipediaUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duedilUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "crunchbaseUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openCorporatesUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sicCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overview",
            "storageKey": null
          },
          v7,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "founded",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "specialties",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "country",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hq",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street3",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinNumFollowers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alsoViewed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketCompaniesId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUpdatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ordinal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "substituteVectorCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CanonicalCompany",
            "kind": "LinkedField",
            "name": "substituteCompany",
            "plural": false,
            "selections": [
              v2,
              v6,
              v3,
              v5,
              v7
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompaniesStrongPattern",
            "kind": "LinkedField",
            "name": "strongPatterns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canonicalCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pattern",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "kind": "InlineFragment",
    "selections": [
      v4,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseCompanyUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyUpdatePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseCompanyUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "CompaniesCompanyUpdatePayload",
          "kind": "LinkedField",
          "name": "companiesCompanyUpdate",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v9
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5ee637e1cc60da5f9334f0123c5a54c2",
      "id": null,
      "metadata": {},
      "name": "UseCompanyUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseCompanyUpdateMutation(\n  $input: CompaniesCompanyUpdateInput!\n) {\n  data: companiesCompanyUpdate(input: $input) {\n    payload {\n      node {\n        id\n        companyId\n        code\n        name\n        alsoMapsTo\n        isVerified\n        wikipediaUrl\n        duedilUrl\n        crunchbaseUrl\n        openCorporatesUrl\n        sicCode\n        website\n        slug\n        updatedAt\n        updatedBy\n        createdAt\n        createdBy\n        isDeleted\n        overview\n        industry\n        size\n        founded\n        type\n        specialties\n        country\n        city\n        state\n        postal\n        hq\n        street1\n        street2\n        street3\n        linkedinId\n        linkedinUrl\n        imageUrl\n        linkedinNumFollowers\n        alsoViewed\n        marketCompaniesId\n        linkedinUpdatedAt\n        ordinal\n        substituteVectorCompanyId\n        substituteCompany {\n          id\n          isVerified\n          companyId\n          name\n          industry\n        }\n        strongPatterns {\n          canonicalCompanyId\n          pattern\n        }\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "e948c51095a5098fae12fef923eec144";
var UseCompanyUpdateMutation_graphql_default = node9;

// src/companies/mutations/UseCompanyUpdate.ts
import { useAsyncMutation as useAsyncMutation3 } from "shared-lib";
var mutationDef3 = UseCompanyUpdateMutation_graphql_default;
function useUseCompanyUpdate() {
  const [commit, isBusy] = useAsyncMutation3(mutationDef3);
  return [commit, isBusy];
}

// src/companies/components/IndustrySearchBox.tsx
import {
  Suspense as Suspense3,
  useCallback as useCallback8,
  useEffect as useEffect2,
  useMemo as useMemo5,
  useState as useState4
} from "react";
import { ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/24/solid";
import { Combobox as Combobox4 } from "@headlessui/react";

// src/companies/components/__generated__/IndustrySearchOptionsQuery.graphql.ts
var node10 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        },
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "IndustriesConnection",
      "kind": "LinkedField",
      "name": "industries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IndustriesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Industry",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "industryId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IndustrySearchOptionsQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IndustrySearchOptionsQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "512f8727a54303d3a2fabf68be3d0b8e",
      "id": null,
      "metadata": {},
      "name": "IndustrySearchOptionsQuery",
      "operationKind": "query",
      "text": "query IndustrySearchOptionsQuery(\n  $where: IndustryFilter!\n) {\n  results: industries(where: $where, first: 50) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        name\n        industryId\n        companyCount\n        description\n        profileCount\n      }\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "9f830486856ad21b3edaebd98c09525e";
var IndustrySearchOptionsQuery_graphql_default = node10;

// src/companies/components/IndustrySearchOptions.tsx
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";
import { Combobox as Combobox3 } from "@headlessui/react";
import { CheckIcon as CheckIcon2 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull2 } from "shared-lib";
import { classNames as classNames2 } from "shared-ui";
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var queryDef3 = IndustrySearchOptionsQuery_graphql_default;
var IndustrySearchOptions = ({ term, onNoResults }) => {
  const where = {
    name: {
      startsWith: term
    }
  };
  const query = useLazyLoadQuery3(
    queryDef3,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { results } = query;
  const rows = (results?.edges ?? []).map((e) => e.node).filter(isNotNull2);
  if (term && rows && rows.length === 0) {
    if (onNoResults) {
      onNoResults();
    }
  }
  return /* @__PURE__ */ jsx9(Combobox3.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx9(
    Combobox3.Option,
    {
      "aria-label": result && result.name ? result.name : "",
      value: result,
      className: ({ active }) => classNames2(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs8(Fragment2, { children: [
        /* @__PURE__ */ jsx9("div", { className: "flex", children: /* @__PURE__ */ jsx9(
          "span",
          {
            className: classNames2(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result && result.name ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx9(
          "span",
          {
            className: classNames2(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx9(CheckIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/companies/components/IndustrySearchBox.tsx
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var compareResults2 = (a, b) => a?.id === b?.id;
var IndustrySearchBox = ({
  name,
  onSelected,
  value,
  disabled,
  placeholder
}) => {
  const [selected, setSelected] = useState4(value);
  const [searchTerm, setSearchTerm] = useState4("");
  const onQueryChangeHandler = useMemo5(
    () => debounce_default((q) => setSearchTerm(q), 500),
    []
  );
  useEffect2(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback8(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx10(Suspense3, { fallback: /* @__PURE__ */ jsx10("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx10(
    Combobox4,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      disabled,
      by: compareResults2,
      children: /* @__PURE__ */ jsxs9("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx10(
          Combobox4.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result || !result.name) {
                return "";
              }
              return result.name;
            },
            placeholder: placeholder || "Search Industries",
            "aria-label": placeholder || "Search Industries",
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx10(
          Combobox4.Button,
          {
            "aria-label": "Industry Search Box",
            className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
            children: /* @__PURE__ */ jsx10(
              ChevronUpDownIcon2,
              {
                className: "h-5 w-5 text-gray-600",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx10(Suspense3, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx10(IndustrySearchOptions, { term: searchTerm }) })
      ] })
    }
  ) });
};

// src/companies/components/CompanyUpdateContainer.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var fragmentDef2 = CompanyUpdateContainer_company_graphql_default;
var formSchema = zod.object({
  name: zod.string().min(1, { message: "Name is required" }),
  industry: zod.string().optional(),
  strongPatterns: zod.array(zod.string()).optional(),
  pattern: zod.string().optional(),
  substituteCompany: zod.object({
    id: zod.string(),
    name: zod.string(),
    isVerified: zod.boolean(),
    industry: zod.string().optional().nullable()
  }).optional()
});
var CompanyUpdateContainer = ({
  fragmentRef,
  onDone,
  onCancel
}) => {
  const data = useFragment(fragmentDef2, fragmentRef);
  let substituteCompany = void 0;
  if (data.substituteCompany) {
    substituteCompany = {
      id: data.substituteCompany.companyId,
      industry: data.substituteCompany.industry,
      isVerified: data.substituteCompany.isVerified,
      name: data.substituteCompany.name || ""
    };
  }
  const defaultIndustry = data.industry || "";
  const defaultValues = useMemo6(() => {
    return {
      name: data.name || "",
      industry: defaultIndustry,
      strongPatterns: data.strongPatterns.map((s) => s.pattern),
      substituteCompany
    };
  }, [defaultIndustry, data.name, data.strongPatterns, substituteCompany]);
  const [isEditingIndustry, toggleIsEditingIndustry] = useToggle2();
  const setErrorCode = useSetUserErrorCodes();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState,
    control
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: "onChange"
  });
  const { fields, append, remove } = useFieldArray({
    control,
    // @ts-expect-error error
    name: "strongPatterns"
  });
  const userErrorCode = useUserErrorCode();
  const [createCompany, isCreatingCompany] = useUseCompanyUpdate();
  const currentItem = watch("pattern");
  const onSave = useCallback9(
    async (form) => {
      setErrorCode(null);
      if (!data || !form.name) {
        return;
      }
      let input = {
        clientMutationId: createClientMutationId(),
        companyId: data.companyId,
        name: form.name,
        industry: form.industry,
        strongPatterns: form?.strongPatterns
      };
      if (form.substituteCompany) {
        input = {
          ...input,
          substituteVectorCompanyId: form.substituteCompany.id
        };
      }
      if (form.substituteCompany) {
        input = {
          ...input,
          substituteVectorCompanyId: form.substituteCompany.id
        };
      }
      const response = await createCompany({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [createCompany]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const addItem = useCallback9(() => {
    if (!currentItem || currentItem === "") {
      return;
    }
    append(currentItem);
    setValue("pattern", "");
  }, [append, setValue, currentItem]);
  const onIndustrySelected = useCallback9(
    (result) => {
      setValue("industry", result.name);
      toggleIsEditingIndustry();
    },
    [setValue, toggleIsEditingIndustry]
  );
  const { errors, isValid, isDirty } = formState;
  const errorDisplay = /* @__PURE__ */ jsx11(FormErrorCodes, {});
  return /* @__PURE__ */ jsxs10("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx11("form", { onSubmit, className: "w-full md:w-2/3 lg:w-2/3", children: /* @__PURE__ */ jsxs10(
      ActionContainer,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isSaving: isCreatingCompany,
        isDisabled: !isValid,
        submitText: "Update Company",
        titleTop: `Update Company`,
        children: [
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "name", title: "Name *", children: [
            /* @__PURE__ */ jsx11(
              InputField,
              {
                "aria-label": "Name",
                register,
                name: "name",
                required: true,
                placeholder: "Company Name"
              }
            ),
            /* @__PURE__ */ jsx11(ErrorField, { field: errors.name })
          ] }),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "industry", title: "Industry *", children: [
            isEditingIndustry ? /* @__PURE__ */ jsx11("div", { className: "flex items-center justify-between gap-2", children: /* @__PURE__ */ jsx11(
              IndustrySearchBox,
              {
                name: "industry",
                onSelected: onIndustrySelected
              }
            ) }) : /* @__PURE__ */ jsxs10("div", { className: "flex items-center justify-between gap-2", children: [
              /* @__PURE__ */ jsx11(
                InputField,
                {
                  "aria-label": "Industry",
                  register,
                  name: "industry",
                  required: true,
                  placeholder: "Industry"
                }
              ),
              /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
                LinkButton,
                {
                  label: "Edit",
                  clicked: toggleIsEditingIndustry
                }
              ) })
            ] }),
            /* @__PURE__ */ jsx11(ErrorField, { field: errors.industry })
          ] }),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "substituteCompany", title: "Substitute Company", children: [
            /* @__PURE__ */ jsx11(
              CompaniesSearchBoxInput,
              {
                name: "substituteCompany",
                control,
                showCreate: false
              }
            ),
            /* @__PURE__ */ jsx11(ErrorField, { field: errors.substituteCompany })
          ] }),
          /* @__PURE__ */ jsxs10(FormInputRow, { name: "strongPatterns", title: "Strong Patterns", children: [
            /* @__PURE__ */ jsx11("div", { className: "flex flex-col gap-2", children: fields.map((field, index2) => /* @__PURE__ */ jsxs10("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx11(
                "input",
                {
                  "aria-label": "remove",
                  type: "text",
                  className: "bg-primary-500 appearance-none rounded-lg px-4 py-2 leading-tight text-white",
                  ...register(`strongPatterns.${index2}`, {
                    required: true
                  })
                }
              ),
              /* @__PURE__ */ jsx11("div", { className: "bg-primary-500 rounded-lg px-4 py-2 font-medium text-white", children: /* @__PURE__ */ jsx11(
                "button",
                {
                  className: "",
                  type: "button",
                  onClick: () => remove(index2),
                  children: "x"
                }
              ) })
            ] }, field.id)) }),
            /* @__PURE__ */ jsxs10("div", { className: "mt-2 flex items-center justify-between border-t py-4", children: [
              /* @__PURE__ */ jsx11(
                Controller2,
                {
                  name: "pattern",
                  control,
                  render: ({ field }) => /* @__PURE__ */ jsx11("input", { ...field })
                }
              ),
              /* @__PURE__ */ jsx11(
                Button3,
                {
                  "aria-label": "Add Pattern",
                  type: "button",
                  outline: true,
                  color: "primary",
                  clicked: addItem,
                  children: "Add Pattern"
                }
              )
            ] })
          ] })
        ]
      }
    ) })
  ] });
};

// src/companies/components/CompanyMergeContainer.tsx
import { useCallback as useCallback10 } from "react";
import * as zod2 from "zod";
import { useForm as useForm2 } from "react-hook-form";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import {
  createClientMutationId as createClientMutationId2,
  useSetUserErrorCodes as useSetUserErrorCodes2,
  useUserErrorCode as useUserErrorCode2
} from "shared-lib";
import {
  ActionContainer as ActionContainer2,
  ErrorField as ErrorField2,
  FormErrorCodes as FormErrorCodes2,
  FormInputRow as FormInputRow2
} from "shared-ui";
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var formSchema2 = zod2.object({
  company: zod2.object({
    id: zod2.string(),
    name: zod2.string(),
    isVerified: zod2.boolean(),
    industry: zod2.string().optional().nullable()
  }).optional()
});
var CompanyMergeContainer = ({
  fromCompanyId,
  onDone,
  onCancel
}) => {
  const setErrorCode = useSetUserErrorCodes2();
  const { handleSubmit, formState, control } = useForm2({
    resolver: zodResolver2(formSchema2),
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode2();
  const [mergeCompany, isMergingCompany] = useUseCompanyMerge();
  const onSave = useCallback10(
    async (form) => {
      setErrorCode(null);
      if (!form.company) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId2(),
        fromCompanyId,
        toCompanyId: form.company.id
      };
      const response = await mergeCompany({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [mergeCompany]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  const errorDisplay = /* @__PURE__ */ jsx12(FormErrorCodes2, {});
  return /* @__PURE__ */ jsxs11("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    errorDisplay,
    /* @__PURE__ */ jsx12("form", { onSubmit, children: /* @__PURE__ */ jsx12(
      ActionContainer2,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        isSaving: isMergingCompany,
        isDisabled: !isValid,
        submitText: "Merge Company",
        onCancel,
        titleTop: `Merge Company`,
        children: /* @__PURE__ */ jsxs11(FormInputRow2, { name: "company", title: "Company", children: [
          /* @__PURE__ */ jsx12(
            CompaniesSearchBoxInput,
            {
              name: "company",
              control,
              showCreate: false
            }
          ),
          /* @__PURE__ */ jsx12(ErrorField2, { field: errors.company })
        ] })
      }
    ) })
  ] });
};

// src/companies/components/CompanyContainer.tsx
import { Fragment as Fragment3, jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var CompanyContainer = ({ companyRouteId }) => {
  const data = useCompanyRouteData(companyRouteId);
  const { company } = data;
  if (!company) {
    return /* @__PURE__ */ jsx13(EdSkeleton2, {});
  }
  return /* @__PURE__ */ jsx13(CompanyView, { company }, company.companyId);
};
var CompanyView = ({ company }) => {
  const navigate = useNavigate2();
  const [isEditing, toggleIsEditing] = useToggle3(false);
  const [isMerging, toggleIsMerging] = useToggle3(false);
  const onMergeDone = useCallback11(
    (company2) => {
      toggleIsMerging();
      navigate(`../../${company2.code}`);
    },
    [toggleIsMerging]
  );
  const onMergeCancel = useCallback11(() => {
    toggleIsMerging();
  }, [toggleIsMerging]);
  const onEditDone = useCallback11(
    (company2) => {
      toggleIsEditing();
      navigate(`../../${company2.code}`);
    },
    [toggleIsEditing]
  );
  const onEditCancel = useCallback11(() => {
    toggleIsEditing();
  }, [toggleIsEditing]);
  if (!company) {
    return /* @__PURE__ */ jsx13(EdSkeleton2, {});
  }
  let strongPatterns = null;
  if (company.strongPatterns) {
    const strongPatternsList = company.strongPatterns.map((p) => {
      return /* @__PURE__ */ jsx13("div", { className: "py-2 text-gray-500", children: p.pattern }, p.pattern);
    });
    strongPatterns = /* @__PURE__ */ jsx13("div", { className: "flex", children: /* @__PURE__ */ jsxs12("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx13("div", { className: "border-b py-2 text-xl font-medium text-gray-900", children: "Strong Patterns" }),
      /* @__PURE__ */ jsx13("div", { className: "flex flex-col gap-2 divide-y py-2", children: strongPatternsList })
    ] }) });
  }
  return /* @__PURE__ */ jsxs12("div", { className: "flex flex-col gap-2 bg-white px-4 py-2", children: [
    /* @__PURE__ */ jsx13(MynPageTitle, { title: "Company Details" }),
    !isMerging && !isEditing && /* @__PURE__ */ jsxs12(Fragment3, { children: [
      /* @__PURE__ */ jsxs12("div", { className: "flex items-center justify-between border-b py-2", children: [
        /* @__PURE__ */ jsx13("div", { className: "text-primary-700 m-2 flex items-center gap-2 text-xl", children: /* @__PURE__ */ jsx13("div", { className: "font-medium", children: "Details" }) }),
        /* @__PURE__ */ jsxs12(ButtonList2, { children: [
          /* @__PURE__ */ jsx13(
            Button4,
            {
              "aria-label": "Edit Details",
              color: "primary",
              size: Size2.md,
              clicked: toggleIsEditing,
              children: "Edit"
            }
          ),
          /* @__PURE__ */ jsx13(
            Button4,
            {
              "aria-label": "Merge",
              color: "primary",
              size: Size2.md,
              clicked: toggleIsMerging,
              children: "Merge"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx13("div", { className: "flex p-2", children: /* @__PURE__ */ jsxs12("div", { className: "flex items-center gap-2 text-xl text-gray-900", children: [
        /* @__PURE__ */ jsx13("div", { className: "w-32 font-medium", children: "Industry" }),
        /* @__PURE__ */ jsx13("div", { children: company.industry })
      ] }) }),
      company.substituteCompany && /* @__PURE__ */ jsx13("div", { className: "flex p-2", children: /* @__PURE__ */ jsxs12("div", { className: "flex items-center gap-2 text-xl text-gray-900", children: [
        /* @__PURE__ */ jsx13("div", { className: "w-32 font-medium", children: "Substitute Company" }),
        /* @__PURE__ */ jsx13("div", { children: company.substituteCompany.name })
      ] }) }),
      strongPatterns
    ] }),
    isMerging && /* @__PURE__ */ jsx13("div", { className: "", children: /* @__PURE__ */ jsx13(
      CompanyMergeContainer,
      {
        fromCompanyId: company.companyId,
        onDone: onMergeDone,
        onCancel: onMergeCancel
      },
      company.companyId
    ) }),
    isEditing && /* @__PURE__ */ jsx13("div", { className: "", children: /* @__PURE__ */ jsx13(
      CompanyUpdateContainer,
      {
        fragmentRef: company,
        onDone: onEditDone,
        onCancel: onEditCancel
      },
      company.companyId
    ) })
  ] });
};

// src/companies/components/CompanyRoute.tsx
import { Fragment as Fragment4, jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var companyRouteQueryDef = CompanyRouteQuery_graphql_default;
function useCompanyRouteData(routeId) {
  const queryRef = useRouteLoaderData(
    routeId
  );
  const data = usePreloadedQuery(
    companyRouteQueryDef,
    queryRef
  );
  return data;
}
async function loader(environment, params) {
  const code = params.companyCode;
  const companyCode = parseInt(code);
  return loadQuery(environment, companyRouteQueryDef, {
    companyCode
  });
}
var Layout = ({ routeId }) => {
  const data = useCompanyRouteData(routeId);
  const { company } = data;
  if (!company) {
    return /* @__PURE__ */ jsx14(EdSkeleton3, {});
  }
  return /* @__PURE__ */ jsx14(Suspense4, { fallback: "Loading Tenant...", children: /* @__PURE__ */ jsx14(ErrorBoundary, { FallbackComponent: ErrorBoundaryFallback, children: /* @__PURE__ */ jsxs13("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs13("div", { className: "flex items-center justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs13("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx14(EdLink, { href: "../../", name: "Tenants", children: /* @__PURE__ */ jsx14(Button5, { color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx14(PageHeading2, { children: company.name })
      ] }),
      /* @__PURE__ */ jsx14("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx14(
        EdTextLink,
        {
          id: "tenant-view-link",
          to: `../../../${company.code}`,
          label: "View"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx14("div", { children: /* @__PURE__ */ jsx14(Outlet, {}) })
  ] }) }) });
};
var CompanyLink = ({ routeId, label }) => {
  const data = useCompanyRouteData(routeId);
  const { company } = data;
  if (!company) {
    return /* @__PURE__ */ jsx14(Fragment4, {});
  }
  return /* @__PURE__ */ jsx14(Suspense4, { fallback: "Loading...", children: /* @__PURE__ */ jsx14(Link, { to: ".", children: label || company.name }) });
};
var buildCompanyRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-company`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx14(Layout, { routeId }),
      errorElement: /* @__PURE__ */ jsx14(ErrorContainer, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx14(CompanyLink, { routeId })
      },
      loader: ({ params }) => {
        return loader(environment, params);
      },
      children: [
        {
          path: "*",
          element: /* @__PURE__ */ jsx14(CompanyContainer, { companyRouteId: routeId })
        }
      ]
    }
  ];
};

// src/companies/components/CompanyCreateContainer.tsx
import { useCallback as useCallback12 } from "react";
import * as zod3 from "zod";
import { useForm as useForm3 } from "react-hook-form";
import { zodResolver as zodResolver3 } from "@hookform/resolvers/zod";
import { useNavigate as useNavigate3 } from "react-router-dom";
import {
  createClientMutationId as createClientMutationId3,
  useSetUserErrorCodes as useSetUserErrorCodes3,
  useUserErrorCode as useUserErrorCode3
} from "shared-lib";
import {
  ActionContainer as ActionContainer3,
  ErrorField as ErrorField3,
  FormErrorCodes as FormErrorCodes3,
  FormInputRow as FormInputRow3,
  InputField as InputField2,
  MynPageTitle as MynPageTitle2,
  SwitchInput
} from "shared-ui";
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var formSchema3 = zod3.object({
  name: zod3.string().min(1, { message: "Name is required" }),
  isVerified: zod3.boolean()
});
var CompanyCreateContainer = () => {
  const navigate = useNavigate3();
  const defaultValues = {
    name: "",
    isVerified: true
  };
  const setErrorCode = useSetUserErrorCodes3();
  const { register, handleSubmit, getValues, formState, control } = useForm3({
    resolver: zodResolver3(formSchema3),
    defaultValues,
    mode: "onChange"
  });
  const userErrorCode = useUserErrorCode3();
  const [createCompany, isCreatingCompany] = useUseCompanyCreate();
  const onDone = useCallback12(
    (company) => {
      navigate(`../list/${company.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback12(() => {
    navigate(`../list`);
  }, [navigate]);
  const onSave = useCallback12(
    async (form) => {
      setErrorCode(null);
      if (!form.name) {
        return;
      }
      const input = {
        clientMutationId: createClientMutationId3(),
        name: form.name,
        isVerified: form.isVerified
      };
      const response = await createCompany({ input });
      if (response.data.userErrors && response.data.userErrors.length > 0) {
        setErrorCode(response.data.userErrors);
      }
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    [createCompany, onDone]
  );
  const onSubmit = handleSubmit(
    async (form) => {
      await onSave(form);
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  const { errors, isValid, isDirty } = formState;
  const errorDisplay = /* @__PURE__ */ jsx15(FormErrorCodes3, {});
  return /* @__PURE__ */ jsxs14("div", { className: "m-4 flex flex-col items-center justify-center", children: [
    /* @__PURE__ */ jsx15(MynPageTitle2, { title: "Create Companies" }),
    errorDisplay,
    /* @__PURE__ */ jsx15("form", { onSubmit, children: /* @__PURE__ */ jsxs14(
      ActionContainer3,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isSaving: isCreatingCompany,
        isDisabled: !isValid,
        submitText: "Create Identity",
        titleTop: `Create Identity`,
        children: [
          /* @__PURE__ */ jsxs14(FormInputRow3, { name: "name", title: "Name *", children: [
            /* @__PURE__ */ jsx15(
              InputField2,
              {
                "aria-label": "Name",
                register,
                name: "name",
                required: true,
                placeholder: "Company Name"
              }
            ),
            /* @__PURE__ */ jsx15(ErrorField3, { field: errors.name })
          ] }),
          /* @__PURE__ */ jsxs14(FormInputRow3, { name: "isVerified", title: "Verified *", children: [
            /* @__PURE__ */ jsx15(
              SwitchInput,
              {
                control,
                name: "isVerified",
                defaultChecked: false,
                label: "isVerified"
              }
            ),
            /* @__PURE__ */ jsx15(ErrorField3, { field: errors.isVerified })
          ] })
        ]
      }
    ) })
  ] });
};

// src/companies/components/CompaniesRoute.tsx
import { MynPageTitle as MynPageTitle3 } from "shared-ui";
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var Layout2 = () => {
  return /* @__PURE__ */ jsx16(Suspense5, { fallback: "Loading Skill Groups...", children: /* @__PURE__ */ jsxs15(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: [
    /* @__PURE__ */ jsx16(MynPageTitle3, { title: "Companies" }),
    /* @__PURE__ */ jsx16("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(Outlet2, {}) }) })
  ] }) });
};
var CompaniesListRoute = () => {
  return /* @__PURE__ */ jsx16(Suspense5, { fallback: "Loading Companies...", children: /* @__PURE__ */ jsx16(ErrorBoundary2, { FallbackComponent: ErrorBoundaryFallback2, children: /* @__PURE__ */ jsx16(CompaniesListContainer, {}) }) });
};
var createCompaniesRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-companies`;
  const createRouteId = `${routeId}-create`;
  const listRouteId = `${routeId}-list`;
  const listCompanyRouteId = `${listRouteId}-company`;
  const companyRouteId = `${routeId}-company`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx16(Layout2, {}),
      children: [
        {
          id: createRouteId,
          path: "create/*",
          element: /* @__PURE__ */ jsx16(CompanyCreateContainer, {})
        },
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx16(CompaniesListRoute, {}),
          children: [
            {
              id: listCompanyRouteId,
              path: ":companyCode/*",
              element: /* @__PURE__ */ jsx16(OutletRoute, {}),
              children: buildCompanyRoute(
                listCompanyRouteId,
                environment,
                context
              )
            }
          ]
        },
        {
          id: companyRouteId,
          path: ":companyCode/*",
          element: /* @__PURE__ */ jsx16(OutletRoute, {}),
          children: buildCompanyRoute(companyRouteId, environment, context)
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx16(Navigate, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/core/components/Layout.tsx
import { useMemo as useMemo9 } from "react";
import { Navigate as Navigate8, Outlet as Outlet6, useLocation as useLocation2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary11 } from "react-error-boundary";
import {
  HomeIcon,
  BuildingStorefrontIcon,
  AcademicCapIcon,
  BookmarkIcon,
  DocumentTextIcon,
  BuildingOfficeIcon,
  InformationCircleIcon
} from "@heroicons/react/24/outline";
import { MynPageTitle as MynPageTitle14, Suspense as Suspense18 } from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback11, OutletRoute as OutletRoute9 } from "app-core";
import { createLinkState as createLinkState2, TabUnderline as TabUnderline2 } from "shared-ui";

// src/skill-groups/components/SkillGroupsList.tsx
import { Suspense as Suspense6 } from "react";
import { Navigate as Navigate2 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary3 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback3, OutletRoute as OutletRoute2 } from "app-core";
import { MynPageTitle as MynPageTitle4 } from "shared-ui";
import { jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var ListRoute = () => {
  return /* @__PURE__ */ jsx17(Suspense6, { fallback: "Loading Skill Groups...", children: /* @__PURE__ */ jsxs16(ErrorBoundary3, { FallbackComponent: ErrorBoundaryFallback3, children: [
    /* @__PURE__ */ jsx17(MynPageTitle4, { title: "Skill Groups" }),
    /* @__PURE__ */ jsx17("div", { className: "text-primary-700 m-8 font-bold", children: "TODO" })
  ] }) });
};
var createSkillGroupsRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-skill-groups`;
  const listRouteId = `${routeId}-list`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx17(OutletRoute2, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx17(ListRoute, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx17(Navigate2, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/ref-data/components/RefDataRoute.tsx
import { Suspense as Suspense12 } from "react";
import { Navigate as Navigate5, Outlet as Outlet4 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary7 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback7, OutletRoute as OutletRoute5 } from "app-core";

// src/ref-data/components/__generated__/RefDataTenantListContainerQuery.graphql.ts
var node11 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataTenantListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RefDataTenantListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataTenantListContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v1,
          "concreteType": "RefDataTenantsConnection",
          "kind": "LinkedField",
          "name": "refDataTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refDataTenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "RefDataTenantListContainer_list",
          "kind": "LinkedHandle",
          "name": "refDataTenants"
        }
      ]
    },
    "params": {
      "cacheID": "50f4aa9033ce9c9fb8db04fc28bac621",
      "id": null,
      "metadata": {},
      "name": "RefDataTenantListContainerQuery",
      "operationKind": "query",
      "text": "query RefDataTenantListContainerQuery(\n  $where: RefDataTenantFilter!\n) {\n  ...RefDataTenantListContainer_list\n}\n\nfragment RefDataTenantListContainer_list on Query {\n  list: refDataTenants(first: 25, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        refDataTenantId\n        code\n        createdAt\n        updatedAt\n        name\n        employerId\n        employerName\n        isActive\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node11.hash = "00cdc8d4113e93663ab8d3b4389e13f1";
var RefDataTenantListContainerQuery_graphql_default = node11;

// src/ref-data/components/__generated__/RefDataTenantsListContainerPaginationQuery.graphql.ts
var node12 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataTenantsListContainerPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "RefDataTenantListContainer_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataTenantsListContainerPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RefDataTenantsConnection",
          "kind": "LinkedField",
          "name": "refDataTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refDataTenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isActive",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "RefDataTenantListContainer_list",
          "kind": "LinkedHandle",
          "name": "refDataTenants"
        }
      ]
    },
    "params": {
      "cacheID": "b8bc3cff8a6542a3e8129f0ce5d496e8",
      "id": null,
      "metadata": {},
      "name": "RefDataTenantsListContainerPaginationQuery",
      "operationKind": "query",
      "text": "query RefDataTenantsListContainerPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: RefDataTenantFilter\n) {\n  ...RefDataTenantListContainer_list_2HEEH6\n}\n\nfragment RefDataTenantListContainer_list_2HEEH6 on Query {\n  list: refDataTenants(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        refDataTenantId\n        code\n        createdAt\n        updatedAt\n        name\n        employerId\n        employerName\n        isActive\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "d9b9c64b8b600620ddae67c572c53d49";
var RefDataTenantsListContainerPaginationQuery_graphql_default = node12;

// src/ref-data/components/__generated__/RefDataTenantListContainer_list.graphql.ts
var node13 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RefDataTenantsListContainerPaginationQuery_graphql_default
      }
    },
    "name": "RefDataTenantListContainer_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RefDataTenantsConnection",
        "kind": "LinkedField",
        "name": "__RefDataTenantListContainer_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefDataTenantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefDataTenant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refDataTenantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node13.hash = "d9b9c64b8b600620ddae67c572c53d49";
var RefDataTenantListContainer_list_graphql_default = node13;

// src/ref-data/components/RefDataTenantListContainer.tsx
import { useCallback as useCallback13, useState as useState5 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4, usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { Link as Link2 } from "react-router-dom";
import { formatDistanceToNow as formatDistanceToNow2, parseISO as parseISO2 } from "date-fns";
import { Suspense as Suspense7 } from "shared-ui";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader2,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement2,
  EdSkeleton as EdSkeleton4,
  Input as Input3,
  ListLayout as ListLayout2,
  PageHeading as PageHeading3
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined2, useDebounce as useDebounce2 } from "shared-lib";
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var queryDef4 = RefDataTenantListContainerQuery_graphql_default;
var fragmentDef3 = RefDataTenantListContainer_list_graphql_default;
function createLinkTo2(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List2 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment2(fragmentDef3, fragmentRef);
  const onLoadNext = useCallback13(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined2).map((tenant) => {
    const name = `${tenant.name}`;
    return {
      key: tenant.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx18("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx18("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx18("div", { className: "text-md text-blue-700", children: tenant.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs17("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow2(parseISO2(tenant.createdAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: tenant.code
      },
      element: /* @__PURE__ */ jsx18(DefaultListLayoutSectionElement2, { children: /* @__PURE__ */ jsx18("div", { className: "grid", children: /* @__PURE__ */ jsx18("div", { children: tenant.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx18(Suspense7, { fallback: /* @__PURE__ */ jsx18(EdSkeleton4, {}), children: /* @__PURE__ */ jsx18(
    ListLayout2,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx18(
        DefaultListLayoutItemHeader2,
        {
          title: "Tenants",
          to: createLinkTo2,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  ) });
};
var RefDataTenantsListContainer = () => {
  const [filter2, setFilter] = useState5(null);
  const searchTerm = useDebounce2(filter2, 500);
  const where = {};
  if (searchTerm) {
    where.or = [
      { name: { startsWith: filter2 } },
      { employerName: { startsWith: filter2 } }
    ];
  }
  const query = useLazyLoadQuery4(
    queryDef4,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsxs17("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between gap-2 border-b", children: [
      /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx18(PageHeading3, { children: "Employers" }),
        /* @__PURE__ */ jsxs17("div", { className: "flex items-center space-x-4 py-2", children: [
          /* @__PURE__ */ jsx18("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx18("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx18(
            Input3,
            {
              "aria-label": "Name",
              placeholder: " Name ",
              name: "filter",
              onValueChange: (filter3) => setFilter(filter3)
            },
            "filter"
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx18("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx18(
        Link2,
        {
          className: "text-primary-700 p-2 text-lg",
          to: "../../create-tenant",
          children: "Create"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx18("div", { className: "flex-1", children: /* @__PURE__ */ jsx18(List2, { fragmentRef: query }) })
  ] });
};

// src/ref-data/components/__generated__/RefDataTenantRouteQuery.graphql.ts
var node14 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantCode"
    }
  ], v1 = [
    {
      "alias": "tenant",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "tenantCode"
        }
      ],
      "concreteType": "RefDataTenant",
      "kind": "LinkedField",
      "name": "refDataTenantByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refDataTenantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataTenantRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataTenantRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "2da8ea70404be058c0863a2110a954ea",
      "id": null,
      "metadata": {},
      "name": "RefDataTenantRouteQuery",
      "operationKind": "query",
      "text": "query RefDataTenantRouteQuery(\n  $tenantCode: Int!\n) {\n  tenant: refDataTenantByCode(code: $tenantCode) {\n    id\n    refDataTenantId\n    code\n    createdAt\n    updatedAt\n    name\n    employerId\n    employerName\n    isActive\n  }\n}\n"
    }
  };
}();
node14.hash = "dc0926f69cd24e5a10ed2a17e301bb42";
var RefDataTenantRouteQuery_graphql_default = node14;

// src/ref-data/components/RefDataTenantRoute.tsx
import { useMemo as useMemo8 } from "react";
import {
  loadQuery as loadQuery4,
  usePreloadedQuery as usePreloadedQuery4
} from "react-relay";
import {
  Navigate as Navigate4,
  Outlet as Outlet3,
  useRouteLoaderData as useRouteLoaderData4,
  Link as Link4,
  useLocation
} from "react-router-dom";
import { ErrorBoundary as ErrorBoundary6 } from "react-error-boundary";
import { Suspense as Suspense11 } from "shared-ui";
import {
  Button as Button9,
  createLinkState,
  EdLink as EdLink4,
  EdSkeleton as EdSkeleton9,
  EdTextLink as EdTextLink3,
  ErrorContainer as ErrorContainer4,
  PageHeading as PageHeading6,
  TabUnderline
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback6, OutletRoute as OutletRoute4 } from "app-core";

// src/ref-data/components/RefDataTenantContainer.tsx
import { EdSkeleton as EdSkeleton5, MynPageTitle as MynPageTitle5 } from "shared-ui";
import { jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var RefDataTenantContainer = ({ tenantRouteId }) => {
  const data = useRefDataTenantRouteData(tenantRouteId);
  const { tenant } = data;
  if (!tenant) {
    return /* @__PURE__ */ jsx19(EdSkeleton5, {});
  }
  return /* @__PURE__ */ jsxs18("div", { className: "flex flex-col gap-2 bg-white px-4 py-8", children: [
    /* @__PURE__ */ jsx19(MynPageTitle5, { title: "Ref Data Tenant Details" }),
    /* @__PURE__ */ jsx19("div", { className: "flex", children: /* @__PURE__ */ jsxs18("div", { className: "text-primary-700 flex items-center gap-2 text-xl", children: [
      /* @__PURE__ */ jsx19("div", { className: "w-32", children: "Tenant" }),
      /* @__PURE__ */ jsx19("div", { children: tenant.name })
    ] }) }),
    /* @__PURE__ */ jsx19("div", { className: "flex", children: /* @__PURE__ */ jsxs18("div", { className: "flex items-center gap-2 text-xl text-gray-900", children: [
      /* @__PURE__ */ jsx19("div", { className: "w-32", children: "Employer" }),
      /* @__PURE__ */ jsx19("div", { children: tenant.employerName })
    ] }) })
  ] });
};

// src/ref-data/components/RefDataItemsRoute.tsx
import { Navigate as Navigate3 } from "react-router-dom";
import { OutletRoute as OutletRoute3 } from "app-core";

// src/ref-data/components/__generated__/RefDataItemRouteQuery.graphql.ts
var node15 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemCode"
    }
  ], v1 = [
    {
      "alias": "item",
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "itemCode"
        }
      ],
      "concreteType": "RefDataItem",
      "kind": "LinkedField",
      "name": "refDataItemByCode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "refDataItemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "display",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discriminator",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scalarValue",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataItemRouteQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataItemRouteQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "489ae03ded097c9cfff6bb3e58b7294a",
      "id": null,
      "metadata": {},
      "name": "RefDataItemRouteQuery",
      "operationKind": "query",
      "text": "query RefDataItemRouteQuery(\n  $itemCode: Int!\n) {\n  item: refDataItemByCode(code: $itemCode) {\n    id\n    refDataItemId\n    code\n    createdAt\n    updatedAt\n    display\n    discriminator\n    tenantId\n    displayOrder\n    scalarValue\n  }\n}\n"
    }
  };
}();
node15.hash = "707f99a86e6c2fd53b55075db46c8a8e";
var RefDataItemRouteQuery_graphql_default = node15;

// src/ref-data/components/RefDataItemRoute.tsx
import { useCallback as useCallback15 } from "react";
import {
  loadQuery as loadQuery2,
  usePreloadedQuery as usePreloadedQuery2
} from "react-relay";
import {
  useRouteLoaderData as useRouteLoaderData2,
  Link as Link3
} from "react-router-dom";
import { ErrorBoundary as ErrorBoundary4 } from "react-error-boundary";
import { MynPageTitle as MynPageTitle6, Suspense as Suspense8 } from "shared-ui";
import {
  Button as Button6,
  EdLink as EdLink2,
  EdSkeleton as EdSkeleton6,
  EdTextLink as EdTextLink2,
  ErrorContainer as ErrorContainer2,
  PageHeading as PageHeading4
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback4 } from "app-core";
import { useToggle as useToggle4 } from "shared-lib";

// src/ref-data/components/RefDataItemEditor.tsx
import { useCallback as useCallback14 } from "react";
import * as zod4 from "zod";
import { useForm as useForm4 } from "react-hook-form";
import { zodResolver as zodResolver4 } from "@hookform/resolvers/zod";
import {
  ActionContainer as ActionContainer4,
  ErrorField as ErrorField4,
  FormErrorCodes as FormErrorCodes4,
  FormInputRow as FormInputRow4,
  InputField as InputField3
} from "shared-ui";
import { createClientMutationId as createClientMutationId4 } from "shared-lib";

// src/ref-data/mutations/__generated__/UseRefDataItemCreateMutation.graphql.ts
var node16 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfReferenceDataItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RefDataItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refDataItemId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "display",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discriminator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scalarValue",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRefDataItemCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemCreatePayload",
          "kind": "LinkedField",
          "name": "refDataItemCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRefDataItemCreateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemCreatePayload",
          "kind": "LinkedField",
          "name": "refDataItemCreate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "05ad863332f28a150bbc45d9ded233b5",
      "id": null,
      "metadata": {},
      "name": "UseRefDataItemCreateMutation",
      "operationKind": "mutation",
      "text": "mutation UseRefDataItemCreateMutation(\n  $input: RefDataItemCreateInput!\n) {\n  data: refDataItemCreate(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        refDataItemId\n        code\n        createdAt\n        updatedAt\n        display\n        discriminator\n        tenantId\n        displayOrder\n        scalarValue\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node16.hash = "0606c158b418f1cf45aa7c001d845f8e";
var UseRefDataItemCreateMutation_graphql_default = node16;

// src/ref-data/mutations/UseRefDataItemCreate.ts
import { useAsyncMutation as useAsyncMutation4 } from "shared-lib";
var mutationDef4 = UseRefDataItemCreateMutation_graphql_default;
function useRefDataItemCreate() {
  const [commit, isBusy] = useAsyncMutation4(mutationDef4);
  return [commit, isBusy];
}

// src/ref-data/mutations/__generated__/UseRefDataItemCreateTenantMutation.graphql.ts
var node17 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfReferenceDataTenant",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RefDataTenant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refDataTenantId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRefDataItemCreateTenantMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemCreateTenantPayload",
          "kind": "LinkedField",
          "name": "refDataItemCreateTenant",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRefDataItemCreateTenantMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemCreateTenantPayload",
          "kind": "LinkedField",
          "name": "refDataItemCreateTenant",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "fc9a7108472346f2698c7577bf12697e",
      "id": null,
      "metadata": {},
      "name": "UseRefDataItemCreateTenantMutation",
      "operationKind": "mutation",
      "text": "mutation UseRefDataItemCreateTenantMutation(\n  $input: RefDataItemCreateTenantInput!\n) {\n  data: refDataItemCreateTenant(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        refDataTenantId\n        code\n        createdAt\n        updatedAt\n        name\n        employerId\n        employerName\n        isActive\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node17.hash = "dfd60725e2941cd84c8d2c5682513289";
var UseRefDataItemCreateTenantMutation_graphql_default = node17;

// src/ref-data/mutations/UseRefDataItemCreateTenant.ts
import { useAsyncMutation as useAsyncMutation5 } from "shared-lib";
var mutationDef5 = UseRefDataItemCreateTenantMutation_graphql_default;
function useRefDataItemCreateTenant() {
  const [commit, isBusy] = useAsyncMutation5(mutationDef5);
  return [commit, isBusy];
}

// src/ref-data/mutations/__generated__/UseRefDataItemUpdateMutation.graphql.ts
var node18 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfReferenceDataItem",
    "kind": "LinkedField",
    "name": "payload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RefDataItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "refDataItemId",
            "storageKey": null
          },
          v2,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "display",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discriminator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scalarValue",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "kind": "InlineFragment",
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "type": "ElevateUserError",
    "abstractKey": "__isElevateUserError"
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "UseRefDataItemUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemUpdatePayload",
          "kind": "LinkedField",
          "name": "refDataItemUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "UseRefDataItemUpdateMutation",
      "selections": [
        {
          "alias": "data",
          "args": v1,
          "concreteType": "RefDataItemUpdatePayload",
          "kind": "LinkedField",
          "name": "refDataItemUpdate",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "70e561e2a04676f05e102626e15318e3",
      "id": null,
      "metadata": {},
      "name": "UseRefDataItemUpdateMutation",
      "operationKind": "mutation",
      "text": "mutation UseRefDataItemUpdateMutation(\n  $input: RefDataItemUpdateInput!\n) {\n  data: refDataItemUpdate(input: $input) {\n    payload {\n      cursor\n      node {\n        id\n        refDataItemId\n        code\n        createdAt\n        updatedAt\n        display\n        discriminator\n        tenantId\n        displayOrder\n        scalarValue\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node18.hash = "770912fbaf7b78725e21fac6403b6e64";
var UseRefDataItemUpdateMutation_graphql_default = node18;

// src/ref-data/mutations/UseRefDataItemUpdate.ts
import { useAsyncMutation as useAsyncMutation6 } from "shared-lib";
var mutationDef6 = UseRefDataItemUpdateMutation_graphql_default;
function useRefDataItemUpdate() {
  const [commit, isBusy] = useAsyncMutation6(mutationDef6);
  return [commit, isBusy];
}

// src/ref-data/components/RefDataItemEditor.tsx
import { jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
var formSchema4 = zod4.object({
  display: zod4.string().min(1, { message: "Display is required" }),
  displayOrder: zod4.string().optional().transform(
    (value) => value === "" || value === void 0 ? null : parseFloat(value)
  ).nullable(),
  scalarValue: zod4.number().optional().nullable()
});
var RefDataItemEditor = ({
  refDataItemId,
  display,
  displayOrder,
  scalarValue,
  onDone,
  onCancel
}) => {
  const defaultValues = {
    display,
    displayOrder,
    scalarValue
  };
  const [update, isUpdating] = useRefDataItemUpdate();
  const { register, handleSubmit, watch, formState, control } = useForm4({
    resolver: zodResolver4(formSchema4),
    defaultValues,
    mode: "onChange"
  });
  const onUpdate = useCallback14(
    async (form) => {
      const input = {
        clientMutationId: createClientMutationId4(),
        id: refDataItemId,
        display: form.display,
        displayOrder: form.displayOrder === void 0 || form.displayOrder === null ? 0 : Number(form.displayOrder),
        scalarValue: form.scalarValue
      };
      return await update({ input });
    },
    [update]
  );
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    async (form) => {
      const response = await onUpdate(form);
      if (response.data.payload) {
        onDone();
      }
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  return /* @__PURE__ */ jsxs19("div", { className: "w-full p-4", children: [
    /* @__PURE__ */ jsx20(FormErrorCodes4, {}),
    /* @__PURE__ */ jsx20("form", { onSubmit, children: /* @__PURE__ */ jsxs19(
      ActionContainer4,
      {
        isDirty,
        showSubmit: true,
        showCancel: true,
        onCancel,
        isDisabled: isUpdating,
        titleTop: `Update Ref Data Item`,
        children: [
          /* @__PURE__ */ jsxs19(FormInputRow4, { name: "display", title: "Display *", children: [
            /* @__PURE__ */ jsx20(
              InputField3,
              {
                "aria-label": "Display ",
                register,
                name: "display",
                required: true,
                placeholder: "Display"
              }
            ),
            /* @__PURE__ */ jsx20(ErrorField4, { field: errors.display })
          ] }),
          /* @__PURE__ */ jsxs19(FormInputRow4, { name: "displayOrder", title: "Display Order", children: [
            /* @__PURE__ */ jsx20(
              InputField3,
              {
                "aria-label": "Display Order",
                register,
                type: "number",
                name: "displayOrder",
                required: false,
                min: 0
              }
            ),
            /* @__PURE__ */ jsx20(ErrorField4, { field: errors.displayOrder })
          ] }),
          /* @__PURE__ */ jsxs19(FormInputRow4, { name: "scalarValue", title: "Scalar Value", children: [
            /* @__PURE__ */ jsx20(
              InputField3,
              {
                "aria-label": "Scalar Value",
                register,
                type: "number",
                name: "scalarValue",
                required: false
              }
            ),
            /* @__PURE__ */ jsx20(ErrorField4, { field: errors.scalarValue })
          ] })
        ]
      }
    ) })
  ] });
};

// src/ref-data/components/RefDataItemRoute.tsx
import { Fragment as Fragment5, jsx as jsx21, jsxs as jsxs20 } from "react/jsx-runtime";
var refDataItemRouteQueryDef = RefDataItemRouteQuery_graphql_default;
function useRefDataItemRouteData(routeId) {
  const queryRef = useRouteLoaderData2(
    routeId
  );
  const data = usePreloadedQuery2(
    refDataItemRouteQueryDef,
    queryRef
  );
  return data;
}
async function loader2(environment, params) {
  const code = params.itemCode;
  const itemCode = parseInt(code);
  return loadQuery2(
    environment,
    refDataItemRouteQueryDef,
    {
      itemCode
    }
  );
}
var Layout3 = ({ routeId }) => {
  const [isEditing, toggleIsEditing] = useToggle4();
  const data = useRefDataItemRouteData(routeId);
  const onEditCompleted = useCallback15(() => {
    toggleIsEditing();
  }, [toggleIsEditing]);
  const { item } = data;
  if (!item) {
    return /* @__PURE__ */ jsx21(EdSkeleton6, {});
  }
  return /* @__PURE__ */ jsx21(Suspense8, { fallback: "Loading Item...", children: /* @__PURE__ */ jsxs20(ErrorBoundary4, { FallbackComponent: ErrorBoundaryFallback4, children: [
    /* @__PURE__ */ jsx21(MynPageTitle6, { title: "Ref Data Item Details" }),
    /* @__PURE__ */ jsxs20("div", { className: "flex flex-1 flex-col", children: [
      /* @__PURE__ */ jsxs20("div", { className: "flex items-center justify-between border-b bg-white p-4", children: [
        /* @__PURE__ */ jsxs20("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx21(EdLink2, { href: "../../", name: "Items", children: /* @__PURE__ */ jsx21(Button6, { "aria-label": "Back", color: "primary", children: "Back" }) }),
          /* @__PURE__ */ jsx21(PageHeading4, { children: item.discriminator })
        ] }),
        /* @__PURE__ */ jsxs20("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx21(
            Button6,
            {
              "aria-label": "Edit",
              color: "primary",
              clicked: toggleIsEditing,
              children: "Edit"
            }
          ),
          /* @__PURE__ */ jsx21(
            EdTextLink2,
            {
              id: "tenant-data-view-link",
              to: `../../../${item.code}`,
              label: "View"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx21("div", { className: "flex-1 bg-white", children: /* @__PURE__ */ jsx21("div", { className: "m-auto w-1/3", children: isEditing ? /* @__PURE__ */ jsx21("div", { className: "p-4", children: /* @__PURE__ */ jsx21(
        RefDataItemEditor,
        {
          refDataItemId: item.refDataItemId,
          display: item.display,
          displayOrder: item.displayOrder,
          scalarValue: item.scalarValue,
          onDone: onEditCompleted,
          onCancel: onEditCompleted
        }
      ) }) : /* @__PURE__ */ jsx21("div", { className: "flex flex-col p-4", children: /* @__PURE__ */ jsx21("div", { className: "border border-gray-100", children: /* @__PURE__ */ jsxs20("dl", { className: "divide-y divide-gray-100", children: [
        /* @__PURE__ */ jsxs20("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
          /* @__PURE__ */ jsx21("dt", { className: "text-sm font-medium text-gray-900", children: "Display" }),
          /* @__PURE__ */ jsx21("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: item.display })
        ] }),
        /* @__PURE__ */ jsxs20("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
          /* @__PURE__ */ jsx21("dt", { className: "text-sm font-medium text-gray-900", children: "Display Order" }),
          /* @__PURE__ */ jsx21("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: item.displayOrder })
        ] }),
        /* @__PURE__ */ jsxs20("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
          /* @__PURE__ */ jsx21("dt", { className: "text-sm font-medium text-gray-900", children: "Discriminator" }),
          /* @__PURE__ */ jsx21("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: item.discriminator })
        ] }),
        /* @__PURE__ */ jsxs20("div", { className: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
          /* @__PURE__ */ jsx21("dt", { className: "text-sm font-medium text-gray-900", children: "Scalar Value" }),
          /* @__PURE__ */ jsx21("dd", { className: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0", children: item.scalarValue })
        ] })
      ] }) }) }) }) })
    ] })
  ] }) });
};
var ItemLink = ({ routeId, label }) => {
  const data = useRefDataItemRouteData(routeId);
  const { item } = data;
  if (!item) {
    return /* @__PURE__ */ jsx21(Fragment5, {});
  }
  return /* @__PURE__ */ jsx21(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(Link3, { to: ".", children: label || item.display }) });
};
var createRefDataItemRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-ref-data-item`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx21(Layout3, { routeId }),
      errorElement: /* @__PURE__ */ jsx21(ErrorContainer2, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx21(ItemLink, { routeId })
      },
      loader: ({ params }) => {
        return loader2(environment, params);
      }
    }
  ];
};

// src/ref-data/components/__generated__/RefDataItemsTableQuery.graphql.ts
var node19 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "alias": "discriminators",
    "args": null,
    "kind": "ScalarField",
    "name": "refRefDataItemDiscriminators",
    "storageKey": null
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataItemsTableQuery",
      "selections": [
        v1,
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RefDataItemsTable_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataItemsTableQuery",
      "selections": [
        v1,
        {
          "alias": "list",
          "args": v2,
          "concreteType": "RefDataItemsConnection",
          "kind": "LinkedField",
          "name": "refDataItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refDataItemId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "display",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discriminator",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayOrder",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scalarValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "RefDataItemsTable_list",
          "kind": "LinkedHandle",
          "name": "refDataItems"
        }
      ]
    },
    "params": {
      "cacheID": "22f6f66d8a677fc622f4a23fb8282b3c",
      "id": null,
      "metadata": {},
      "name": "RefDataItemsTableQuery",
      "operationKind": "query",
      "text": "query RefDataItemsTableQuery(\n  $where: RefDataItemFilter!\n) {\n  discriminators: refRefDataItemDiscriminators\n  ...RefDataItemsTable_list\n}\n\nfragment RefDataItemRow_refDataItem on RefDataItem {\n  id\n  refDataItemId\n  code\n  createdAt\n  updatedAt\n  display\n  discriminator\n  tenantId\n  displayOrder\n  scalarValue\n}\n\nfragment RefDataItemsTable_list on Query {\n  list: refDataItems(first: 10, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        createdAt\n        updatedAt\n        refDataItemId\n        display\n        discriminator\n        tenantId\n        displayOrder\n        scalarValue\n        ...RefDataItemRow_refDataItem\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node19.hash = "ff19d3fb24d34f724bd89acd65ef83ba";
var RefDataItemsTableQuery_graphql_default = node19;

// src/ref-data/components/__generated__/RefDataItemsTablePaginationQuery.graphql.ts
var node20 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdAt": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataItemsTablePaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "RefDataItemsTable_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "RefDataItemsTablePaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v3,
          "concreteType": "RefDataItemsConnection",
          "kind": "LinkedField",
          "name": "refDataItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefDataItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RefDataItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "refDataItemId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "display",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discriminator",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayOrder",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scalarValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "RefDataItemsTable_list",
          "kind": "LinkedHandle",
          "name": "refDataItems"
        }
      ]
    },
    "params": {
      "cacheID": "344998cb51c54dbfdae6109f8904cd32",
      "id": null,
      "metadata": {},
      "name": "RefDataItemsTablePaginationQuery",
      "operationKind": "query",
      "text": "query RefDataItemsTablePaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: RefDataItemFilter\n) {\n  ...RefDataItemsTable_list_2HEEH6\n}\n\nfragment RefDataItemRow_refDataItem on RefDataItem {\n  id\n  refDataItemId\n  code\n  createdAt\n  updatedAt\n  display\n  discriminator\n  tenantId\n  displayOrder\n  scalarValue\n}\n\nfragment RefDataItemsTable_list_2HEEH6 on Query {\n  list: refDataItems(first: $first, after: $after, order: [{createdAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        createdAt\n        updatedAt\n        refDataItemId\n        display\n        discriminator\n        tenantId\n        displayOrder\n        scalarValue\n        ...RefDataItemRow_refDataItem\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node20.hash = "46be53b53935d2e38c40438676797eba";
var RefDataItemsTablePaginationQuery_graphql_default = node20;

// src/ref-data/components/__generated__/RefDataItemsTable_list.graphql.ts
var node21 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": RefDataItemsTablePaginationQuery_graphql_default
      }
    },
    "name": "RefDataItemsTable_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "createdAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "RefDataItemsConnection",
        "kind": "LinkedField",
        "name": "__RefDataItemsTable_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefDataItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefDataItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refDataItemId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "display",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "discriminator",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tenantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayOrder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scalarValue",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RefDataItemRow_refDataItem"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node21.hash = "46be53b53935d2e38c40438676797eba";
var RefDataItemsTable_list_graphql_default = node21;

// src/ref-data/components/RefDataItemsTable.tsx
import { useCallback as useCallback18, useState as useState6 } from "react";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery5, usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { MynPageTitle as MynPageTitle7, Suspense as Suspense9 } from "shared-ui";
import { useDebounce as useDebounce3 } from "shared-lib";
import { Button as Button7, EdSkeleton as EdSkeleton7, EdTable, Input as Input4 } from "shared-ui";

// src/ref-data/components/__generated__/RefDataItemRow_refDataItem.graphql.ts
var node22 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RefDataItemRow_refDataItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "refDataItemId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "display",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discriminator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenantId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scalarValue",
      "storageKey": null
    }
  ],
  "type": "RefDataItem",
  "abstractKey": null
};
node22.hash = "cef03598617f80495bc67563a0db1268";
var RefDataItemRow_refDataItem_graphql_default = node22;

// src/ref-data/components/RefDataItemRow.tsx
import { useCallback as useCallback16 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { EdColumnCell, EdRow } from "shared-ui";
import { timeAgo } from "shared-lib";
import { jsx as jsx22, jsxs as jsxs21 } from "react/jsx-runtime";
var fragmentDef4 = RefDataItemRow_refDataItem_graphql_default;
var refDataItemColumns = [
  { id: "createdAt", name: "Created" },
  { id: "updatedAt", name: "Updated" },
  { id: "discriminator", name: "Discriminator" },
  { id: "display", name: "Display" },
  { id: "displayOrder", name: "Display Order" },
  { id: "scalarValue", name: "Scalar Value" }
];
var RefDataItemRow = ({
  fragmentRef,
  onSelect
}) => {
  const data = useFragment2(
    fragmentDef4,
    fragmentRef
  );
  const onClick = useCallback16(() => {
    onSelect(data);
  }, [onSelect]);
  return /* @__PURE__ */ jsxs21(EdRow, { rowKey: data.refDataItemId, clicked: onClick, children: [
    /* @__PURE__ */ jsx22(EdColumnCell, { children: timeAgo(data.createdAt) }),
    /* @__PURE__ */ jsx22(EdColumnCell, { children: timeAgo(data.updatedAt) }),
    /* @__PURE__ */ jsx22(EdColumnCell, { children: data.discriminator }),
    /* @__PURE__ */ jsx22(EdColumnCell, { children: data.display }),
    /* @__PURE__ */ jsx22(EdColumnCell, { children: data.displayOrder }),
    /* @__PURE__ */ jsx22(EdColumnCell, { children: data.scalarValue })
  ] });
};

// src/ref-data/components/RefDataDiscriminatorsList.tsx
import { useCallback as useCallback17, useMemo as useMemo7 } from "react";
import { jsx as jsx23, jsxs as jsxs22 } from "react/jsx-runtime";
var RefDataDiscriminatorsList = ({
  discriminators,
  onSelect
}) => {
  const onChange = useCallback17(
    (e) => {
      onSelect(e.target.value);
    },
    [onSelect]
  );
  const discriminatorOptions = useMemo7(() => {
    return discriminators.map((d) => {
      return /* @__PURE__ */ jsx23("option", { value: d, children: d }, d);
    });
  }, [discriminators]);
  return /* @__PURE__ */ jsxs22(
    "select",
    {
      "aria-label": "Select discriminator type",
      id: "discriminatorTypes",
      name: "discriminatorTypes",
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      onChange,
      children: [
        /* @__PURE__ */ jsx23("option", { value: "", children: "--Select--" }, ""),
        discriminatorOptions
      ]
    }
  );
};
var RefDataDiscriminatorsInput = ({
  name,
  defaultValue,
  register,
  required,
  discriminators
}) => {
  const discriminatorOptions = useMemo7(() => {
    return discriminators.map((d) => {
      return /* @__PURE__ */ jsx23("option", { value: d, children: d }, d);
    });
  }, [discriminators]);
  return /* @__PURE__ */ jsxs22(
    "select",
    {
      "aria-label": "Select Discriminator",
      className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
      defaultValue,
      ...register(name, { required }),
      children: [
        /* @__PURE__ */ jsx23("option", { value: "", children: "--Select--" }, ""),
        discriminatorOptions
      ]
    }
  );
};

// src/ref-data/components/RefDataItemsTable.tsx
import { jsx as jsx24, jsxs as jsxs23 } from "react/jsx-runtime";
var queryDef5 = RefDataItemsTableQuery_graphql_default;
var fragmentDef5 = RefDataItemsTable_list_graphql_default;
var Table = ({ fragmentRef, onSelect }) => {
  const { data, loadNext } = usePaginationFragment3(fragmentDef5, fragmentRef);
  const onLoadNext = useCallback18(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const refDataItemRows = (list?.edges || []).map((e) => e.node).map((n) => {
    return /* @__PURE__ */ jsx24(
      RefDataItemRow,
      {
        fragmentRef: n,
        onSelect
      },
      n.refDataItemId
    );
  });
  return /* @__PURE__ */ jsx24(Suspense9, { fallback: /* @__PURE__ */ jsx24(EdSkeleton7, {}), children: /* @__PURE__ */ jsx24(
    EdTable,
    {
      hasActionsColumn: false,
      defaultColumns: refDataItemColumns,
      rows: refDataItemRows
    }
  ) });
};
var RefDataItemsTable = ({ tenantRouteId }) => {
  const navigate = useNavigate4();
  const data = useRefDataTenantRouteData(tenantRouteId);
  const [filter2, setFilter] = useState6(null);
  const [discriminator, setDiscriminator] = useState6(null);
  const searchTerm = useDebounce3(filter2, 500);
  const onSelect = useCallback18(
    (item) => {
      navigate(`../${item.code}`);
    },
    [navigate]
  );
  const onCreate = useCallback18(() => {
    navigate(`../create`);
  }, [navigate]);
  const { tenant } = data;
  const and = [
    { tenantId: { eq: tenant.refDataTenantId } }
  ];
  if (searchTerm && searchTerm !== "") {
    and.push({ display: { startsWith: searchTerm } });
  }
  if (discriminator && discriminator !== "") {
    and.push({ discriminator: { startsWith: discriminator } });
  }
  const where = {
    and
  };
  const query = useLazyLoadQuery5(
    queryDef5,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { discriminators } = query;
  if (!tenant) {
    return /* @__PURE__ */ jsx24(EdSkeleton7, {});
  }
  return /* @__PURE__ */ jsxs23("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx24(MynPageTitle7, { title: "Ref Data Items" }),
    /* @__PURE__ */ jsxs23("div", { className: "flex items-center justify-between border-b bg-white px-4", children: [
      /* @__PURE__ */ jsxs23("div", { className: "flex items-center gap-2 space-x-4", children: [
        /* @__PURE__ */ jsxs23("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx24("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
          /* @__PURE__ */ jsx24("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx24(
            Input4,
            {
              "aria-label": "Name",
              placeholder: " Name ",
              name: "filter",
              onValueChange: (filter3) => setFilter(filter3)
            },
            "filter"
          ) })
        ] }),
        /* @__PURE__ */ jsxs23("div", { className: "flex items-center space-x-4 p-2", children: [
          /* @__PURE__ */ jsx24("label", { className: "text-gray-700", htmlFor: "discriminatorTypes", children: "Discriminator" }),
          /* @__PURE__ */ jsx24("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx24(
            RefDataDiscriminatorsList,
            {
              discriminators,
              onSelect: (d) => setDiscriminator(d)
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsx24("div", { children: /* @__PURE__ */ jsx24(Button7, { "aria-label": "Create", color: "primary", clicked: onCreate, children: "Create" }) })
    ] }),
    /* @__PURE__ */ jsx24("div", { className: "m-8 flex-1", children: /* @__PURE__ */ jsx24(Table, { fragmentRef: query, onSelect }) })
  ] });
};

// src/ref-data/components/__generated__/RefDataItemCreateRouteQuery.graphql.ts
var node23 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "discriminators",
      "args": null,
      "kind": "ScalarField",
      "name": "refRefDataItemDiscriminators",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "RefDataItemCreateRouteQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "RefDataItemCreateRouteQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "887d72ff198633b0159e40262c4e9321",
      "id": null,
      "metadata": {},
      "name": "RefDataItemCreateRouteQuery",
      "operationKind": "query",
      "text": "query RefDataItemCreateRouteQuery {\n  discriminators: refRefDataItemDiscriminators\n}\n"
    }
  };
}();
node23.hash = "a9240c5b54b2d24e75edc9cea587402e";
var RefDataItemCreateRouteQuery_graphql_default = node23;

// src/ref-data/components/RefDataItemCreateRoute.tsx
import { useCallback as useCallback20 } from "react";
import {
  loadQuery as loadQuery3,
  usePreloadedQuery as usePreloadedQuery3
} from "react-relay";
import {
  useNavigate as useNavigate5,
  useRouteLoaderData as useRouteLoaderData3
} from "react-router-dom";
import { ErrorBoundary as ErrorBoundary5 } from "react-error-boundary";
import { MynPageTitle as MynPageTitle8, Suspense as Suspense10 } from "shared-ui";
import {
  Button as Button8,
  EdLink as EdLink3,
  EdSkeleton as EdSkeleton8,
  ErrorContainer as ErrorContainer3,
  PageHeading as PageHeading5
} from "shared-ui";
import { ErrorBoundaryFallback as ErrorBoundaryFallback5 } from "app-core";

// src/ref-data/components/RefDataItemCreate.tsx
import { useCallback as useCallback19 } from "react";
import * as zod5 from "zod";
import { useForm as useForm5 } from "react-hook-form";
import { zodResolver as zodResolver5 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId5 } from "shared-lib";
import {
  ActionContainer as ActionContainer5,
  ErrorField as ErrorField5,
  FormErrorCodes as FormErrorCodes5,
  FormInputRow as FormInputRow5,
  InputField as InputField4
} from "shared-ui";
import { jsx as jsx25, jsxs as jsxs24 } from "react/jsx-runtime";
var formSchema5 = zod5.object({
  discriminator: zod5.string().min(1, { message: "Discriminator is required" }),
  display: zod5.string().min(1, { message: "Display is required" }),
  displayOrder: zod5.number().optional().nullable(),
  scalarValue: zod5.number().optional().nullable()
});
var RefDataItemCreate = ({
  tenant,
  discriminators,
  onDone,
  onCancel
}) => {
  const defaultValues = {
    display: "",
    displayOrder: 0,
    scalarValue: null
  };
  const [create, isCreating] = useRefDataItemCreate();
  const { register, handleSubmit, watch, formState, control } = useForm5({
    resolver: zodResolver5(formSchema5),
    defaultValues,
    mode: "onChange"
  });
  const onUpdate = useCallback19(
    async (form) => {
      const input = {
        clientMutationId: createClientMutationId5(),
        cultureName: "en-GB",
        discriminator: form.discriminator,
        display: form.display,
        displayOrder: form.displayOrder,
        scalarValue: form.scalarValue,
        tenant
      };
      return await create({ input });
    },
    [create]
  );
  const { errors, isValid, isDirty } = formState;
  const onSubmit = handleSubmit(
    async (form) => {
      const response = await onUpdate(form);
      if (response.data.payload?.node) {
        onDone(response.data.payload.node);
      }
    },
    (invalid) => {
      console.error(invalid);
    }
  );
  return /* @__PURE__ */ jsxs24("div", { className: "w-full p-4", children: [
    /* @__PURE__ */ jsx25(FormErrorCodes5, {}),
    /* @__PURE__ */ jsx25("form", { onSubmit, children: /* @__PURE__ */ jsxs24(
      ActionContainer5,
      {
        submitText: "Create",
        isDirty,
        showSubmit: true,
        showCancel: true,
        isDisabled: isCreating,
        titleTop: `Update Ref Data Item`,
        children: [
          /* @__PURE__ */ jsxs24(FormInputRow5, { name: "discriminator", title: "Discriminator *", children: [
            /* @__PURE__ */ jsx25(
              RefDataDiscriminatorsInput,
              {
                name: "discriminator",
                discriminators,
                register,
                required: true
              }
            ),
            /* @__PURE__ */ jsx25(ErrorField5, { field: errors.discriminator })
          ] }),
          /* @__PURE__ */ jsxs24(FormInputRow5, { name: "display", title: "Display *", children: [
            /* @__PURE__ */ jsx25(
              InputField4,
              {
                "aria-label": "Display",
                register,
                name: "display",
                required: true,
                placeholder: "Display"
              }
            ),
            /* @__PURE__ */ jsx25(ErrorField5, { field: errors.display })
          ] }),
          /* @__PURE__ */ jsxs24(FormInputRow5, { name: "displayOrder", title: "Display Order", children: [
            /* @__PURE__ */ jsx25(
              InputField4,
              {
                "aria-label": "Display Order",
                register,
                type: "number",
                name: "displayOrder",
                required: false
              }
            ),
            /* @__PURE__ */ jsx25(ErrorField5, { field: errors.displayOrder })
          ] }),
          /* @__PURE__ */ jsxs24(FormInputRow5, { name: "scalarValue", title: "Scalar Value", children: [
            /* @__PURE__ */ jsx25(
              InputField4,
              {
                "aria-label": "Scalar Value",
                register,
                type: "number",
                name: "scalarValue",
                required: false
              }
            ),
            /* @__PURE__ */ jsx25(ErrorField5, { field: errors.scalarValue })
          ] })
        ]
      }
    ) })
  ] });
};

// src/ref-data/components/RefDataItemCreateRoute.tsx
import { jsx as jsx26, jsxs as jsxs25 } from "react/jsx-runtime";
var refDataItemCreateRouteQueryDef = RefDataItemCreateRouteQuery_graphql_default;
function useRefDataItemCreateRouteData(routeId) {
  const queryRef = useRouteLoaderData3(
    routeId
  );
  const data = usePreloadedQuery3(
    refDataItemCreateRouteQueryDef,
    queryRef
  );
  return data;
}
async function loader3(environment, params) {
  return loadQuery3(
    environment,
    refDataItemCreateRouteQueryDef,
    {}
  );
}
var Layout4 = ({ tenantRouteId, routeId }) => {
  const navigate = useNavigate5();
  const tenantData = useRefDataTenantRouteData(tenantRouteId);
  const data = useRefDataItemCreateRouteData(routeId);
  const onCreated = useCallback20(
    (created) => {
      navigate(`../../list/${created.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback20(() => {
    navigate(`../list`);
  }, [navigate]);
  const { discriminators } = data;
  const { tenant } = tenantData;
  if (!tenant || !discriminators) {
    return /* @__PURE__ */ jsx26(EdSkeleton8, {});
  }
  return /* @__PURE__ */ jsx26(Suspense10, { fallback: "Loading Item...", children: /* @__PURE__ */ jsxs25(ErrorBoundary5, { FallbackComponent: ErrorBoundaryFallback5, children: [
    /* @__PURE__ */ jsx26(MynPageTitle8, { title: "Create Ref Data Items" }),
    /* @__PURE__ */ jsxs25("div", { className: "flex flex-1 flex-col", children: [
      /* @__PURE__ */ jsx26("div", { className: "flex items-center justify-between border-b bg-white p-4", children: /* @__PURE__ */ jsxs25("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx26(EdLink3, { href: "../../", name: "Tenants", children: /* @__PURE__ */ jsx26(Button8, { "aria-label": "Back", color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx26(PageHeading5, { children: tenant.name })
      ] }) }),
      /* @__PURE__ */ jsx26("div", { className: "flex-1 bg-white", children: /* @__PURE__ */ jsx26("div", { className: "m-auto w-1/3", children: /* @__PURE__ */ jsx26(
        RefDataItemCreate,
        {
          tenant: tenant.refDataTenantId,
          discriminators,
          onDone: onCreated,
          onCancel
        }
      ) }) })
    ] })
  ] }) });
};
var createRefDataItemCreateRoute = (tenantRouteId, environment, context) => {
  const routeId = `${tenantRouteId}-create-ref-data-item`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx26(Layout4, { tenantRouteId, routeId }),
      errorElement: /* @__PURE__ */ jsx26(ErrorContainer3, {}),
      loader: ({ params }) => {
        return loader3(environment, params);
      }
    }
  ];
};

// src/ref-data/components/RefDataItemsRoute.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var createRefDataItemsRoute = (tenantRouteId, environment, context) => {
  const routeId = `${tenantRouteId}-items`;
  const listRouteId = `${routeId}-list`;
  const itemListRouteId = `${listRouteId}-item`;
  const createRouteId = `${listRouteId}-create`;
  const itemRouteId = `${routeId}-item`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx27(OutletRoute3, {}),
      children: [
        {
          id: createRouteId,
          path: "create",
          element: /* @__PURE__ */ jsx27(OutletRoute3, {}),
          children: createRefDataItemCreateRoute(
            tenantRouteId,
            environment,
            context
          )
        },
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx27(RefDataItemsTable, { tenantRouteId }),
          children: [
            {
              id: itemListRouteId,
              path: ":itemCode/*",
              element: /* @__PURE__ */ jsx27(OutletRoute3, {}),
              children: createRefDataItemRoute(
                itemListRouteId,
                environment,
                context
              )
            }
          ]
        },
        {
          id: itemRouteId,
          path: ":itemCode/*",
          element: /* @__PURE__ */ jsx27(OutletRoute3, {}),
          children: createRefDataItemRoute(routeId, environment, context)
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx27(Navigate3, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/ref-data/components/RefDataTenantRoute.tsx
import { Fragment as Fragment6, jsx as jsx28, jsxs as jsxs26 } from "react/jsx-runtime";
var refDataTenantRouteQueryDef = RefDataTenantRouteQuery_graphql_default;
function useRefDataTenantRouteData(routeId) {
  const queryRef = useRouteLoaderData4(
    routeId
  );
  const data = usePreloadedQuery4(
    refDataTenantRouteQueryDef,
    queryRef
  );
  return data;
}
async function loader4(environment, params) {
  const code = params.tenantCode;
  const tenantCode = parseInt(code);
  return loadQuery4(
    environment,
    refDataTenantRouteQueryDef,
    {
      tenantCode
    }
  );
}
var Layout5 = ({ routeId }) => {
  const location = useLocation();
  const tabs = useMemo8(() => {
    return [
      createLinkState(location, "Details", `../details`),
      createLinkState(location, "Data Items", `../data-items`)
    ];
  }, [location]);
  const data = useRefDataTenantRouteData(routeId);
  const { tenant } = data;
  if (!tenant) {
    return /* @__PURE__ */ jsx28(EdSkeleton9, {});
  }
  return /* @__PURE__ */ jsx28(Suspense11, { fallback: "Loading Tenant...", children: /* @__PURE__ */ jsx28(ErrorBoundary6, { FallbackComponent: ErrorBoundaryFallback6, children: /* @__PURE__ */ jsxs26("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ jsxs26("div", { className: "flex items-center justify-between border-b bg-white p-4", children: [
      /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx28(EdLink4, { href: "../../", name: "Tenants", children: /* @__PURE__ */ jsx28(Button9, { "aria-label": "Back", color: "primary", children: "Back" }) }),
        /* @__PURE__ */ jsx28(PageHeading6, { children: tenant.name })
      ] }),
      /* @__PURE__ */ jsx28("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx28(
        EdTextLink3,
        {
          id: "tenant-data-item-view-link",
          to: `../../../${tenant.code}`,
          label: "View"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx28("div", { className: "border-b bg-white p-2", children: /* @__PURE__ */ jsx28(TabUnderline, { tabs }) }),
    /* @__PURE__ */ jsx28("div", { children: /* @__PURE__ */ jsx28(Outlet3, {}) })
  ] }) }) });
};
var TenantLink = ({ routeId, label }) => {
  const data = useRefDataTenantRouteData(routeId);
  const { tenant } = data;
  if (!tenant) {
    return /* @__PURE__ */ jsx28(Fragment6, {});
  }
  return /* @__PURE__ */ jsx28(Suspense11, { fallback: "Loading...", children: /* @__PURE__ */ jsx28(Link4, { to: ".", children: label || tenant.name }) });
};
var createRefDataTenantRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-tenant`;
  const itemsRouteId = `${routeId}-items-parent`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx28(Layout5, { routeId }),
      errorElement: /* @__PURE__ */ jsx28(ErrorContainer4, {}),
      handle: {
        crumb: () => /* @__PURE__ */ jsx28(TenantLink, { routeId })
      },
      loader: ({ params }) => {
        return loader4(environment, params);
      },
      children: [
        {
          id: `${routeId}-details`,
          path: "details/*",
          element: /* @__PURE__ */ jsx28(RefDataTenantContainer, { tenantRouteId: routeId })
        },
        {
          id: itemsRouteId,
          path: "data-items/*",
          element: /* @__PURE__ */ jsx28(OutletRoute4, {}),
          children: createRefDataItemsRoute(routeId, environment, context)
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx28(Navigate4, { to: "details", replace: true })
        }
      ]
    }
  ];
};

// src/ref-data/components/RefDataTenantCreateRoute.tsx
import { useCallback as useCallback22 } from "react";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { ErrorContainer as ErrorContainer5 } from "shared-ui";

// src/ref-data/components/RefDataTenantCreate.tsx
import { useCallback as useCallback21, useState as useState7 } from "react";
import { Button as Button10, ButtonList as ButtonList3, Input as Input5, MynPageTitle as MynPageTitle9 } from "shared-ui";
import { createClientMutationId as createClientMutationId6 } from "shared-lib";
import {
  EmployerSearchContainer
} from "feature-employer-accounts";
import { jsx as jsx29, jsxs as jsxs27 } from "react/jsx-runtime";
var RefDataTenantCreate = ({ onDone, onCancel }) => {
  const [name, setName] = useState7(null);
  const [employer, setEmployer] = useState7(null);
  const onSelectEmployer = useCallback21(
    (e) => {
      setEmployer(e);
      if (!name) {
        setName(e.name);
      }
    },
    [name, setName, setEmployer]
  );
  const [create, isCreating] = useRefDataItemCreateTenant();
  const onCreate = useCallback21(async () => {
    if (!employer || !name || name === "") {
      return;
    }
    const input = {
      clientMutationId: createClientMutationId6(),
      employerId: employer.employerId,
      name
    };
    const response = await create({ input });
    if (response.data.payload?.node) {
      onDone(response.data.payload.node);
    }
  }, [create]);
  return /* @__PURE__ */ jsxs27("div", { className: "mx-auto border bg-white p-8 md:my-8 md:w-2/3 lg:w-1/3", children: [
    /* @__PURE__ */ jsx29(MynPageTitle9, { title: "Create Ref Data Tenant" }),
    /* @__PURE__ */ jsxs27("div", { className: "flex flex-col gap-2 px-4 py-8", children: [
      /* @__PURE__ */ jsxs27("div", { className: "flex flex-col gap-2 p-2", children: [
        /* @__PURE__ */ jsx29("div", { className: "text-primary-700 border-b p-2 text-lg", children: "Search for Employer" }),
        /* @__PURE__ */ jsx29("div", { className: "px-2 py-4", children: /* @__PURE__ */ jsx29(EmployerSearchContainer, { onSearchCompleted: onSelectEmployer }) })
      ] }),
      /* @__PURE__ */ jsxs27("div", { className: "flex flex-col gap-2 p-2", children: [
        /* @__PURE__ */ jsx29("div", { className: "text-primary-700 border-b p-2 text-lg", children: "Name" }),
        /* @__PURE__ */ jsx29("div", { className: "px-2 py-4", children: /* @__PURE__ */ jsx29(
          Input5,
          {
            "aria-label": "Name",
            placeholder: " Name ",
            name: "name",
            value: name ?? "",
            onValueChange: (n) => setName(n)
          },
          "name"
        ) })
      ] }),
      /* @__PURE__ */ jsx29("div", { className: "mt-4 py-4", children: /* @__PURE__ */ jsxs27(ButtonList3, { children: [
        /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29(
          Button10,
          {
            "aria-label": "Create",
            color: "primary",
            disabled: !employer || !name || name === "" || isCreating,
            clicked: onCreate,
            children: "Create"
          }
        ) }),
        /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29(
          Button10,
          {
            "aria-label": "Cancel",
            color: "gray",
            clicked: onCancel,
            disabled: isCreating,
            children: "Cancel"
          }
        ) })
      ] }) })
    ] })
  ] });
};

// src/ref-data/components/RefDataTenantCreateRoute.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var Layout6 = () => {
  const navigate = useNavigate6();
  const onDone = useCallback22(
    (data) => {
      navigate(`../../${data.code}`);
    },
    [navigate]
  );
  const onCancel = useCallback22(() => {
    navigate(`../../tenants`);
  }, [navigate]);
  return /* @__PURE__ */ jsx30(RefDataTenantCreate, { onDone, onCancel });
};
var createRefDataTenantCreateRoute = (tenantRouteId, environment, context) => {
  const routeId = `${tenantRouteId}-create-ref-data-tenant`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx30(Layout6, {}),
      errorElement: /* @__PURE__ */ jsx30(ErrorContainer5, {})
    }
  ];
};

// src/ref-data/components/RefDataRoute.tsx
import { MynPageTitle as MynPageTitle10 } from "shared-ui";
import { jsx as jsx31, jsxs as jsxs28 } from "react/jsx-runtime";
var Layout7 = () => {
  return /* @__PURE__ */ jsx31(Suspense12, { fallback: "Loading Tenants...", children: /* @__PURE__ */ jsx31(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: /* @__PURE__ */ jsx31("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx31("div", { children: /* @__PURE__ */ jsx31(Outlet4, {}) }) }) }) });
};
var ListRoute2 = () => {
  return /* @__PURE__ */ jsx31(Suspense12, { fallback: "Loading Employers...", children: /* @__PURE__ */ jsxs28(ErrorBoundary7, { FallbackComponent: ErrorBoundaryFallback7, children: [
    /* @__PURE__ */ jsx31(MynPageTitle10, { title: "Ref Data Tenants" }),
    /* @__PURE__ */ jsx31(RefDataTenantsListContainer, {})
  ] }) });
};
var createRefDataRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-ref-data`;
  const listRouteId = `${routeId}-list`;
  const tenantListRouteId = `${routeId}-tenant-list`;
  const tenantRouteId = `${routeId}-tenant`;
  const createTenantRouteId = `${routeId}-create-tenant`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx31(Layout7, {}),
      children: [
        {
          id: createTenantRouteId,
          path: "create-tenant",
          element: /* @__PURE__ */ jsx31(OutletRoute5, {}),
          children: createRefDataTenantCreateRoute(
            createTenantRouteId,
            environment,
            context
          )
        },
        {
          id: listRouteId,
          path: "tenants/*",
          element: /* @__PURE__ */ jsx31(ListRoute2, {}),
          children: [
            {
              id: tenantListRouteId,
              path: ":tenantCode/*",
              element: /* @__PURE__ */ jsx31(OutletRoute5, {}),
              children: createRefDataTenantRoute(
                tenantListRouteId,
                environment,
                context
              )
            }
          ]
        },
        {
          id: tenantRouteId,
          path: ":tenantCode/*",
          element: /* @__PURE__ */ jsx31(OutletRoute5, {}),
          children: createRefDataTenantRoute(
            tenantRouteId,
            environment,
            context
          )
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx31(Navigate5, { to: "tenants", replace: true })
        }
      ]
    }
  ];
};

// src/event-tracker/components/EventTrackingRoute.tsx
import { Suspense as Suspense15 } from "react";
import { Navigate as Navigate6, Outlet as Outlet5 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary9 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback9, OutletRoute as OutletRoute7 } from "app-core";

// src/event-tracker/components/EmployerEventTrackingRoute.tsx
import { useNavigate as useNavigate7 } from "react-router-dom";
import { ErrorContainer as ErrorContainer6, MynPageTitle as MynPageTitle11 } from "shared-ui";
import { jsx as jsx32, jsxs as jsxs29 } from "react/jsx-runtime";
var Layout8 = () => {
  const navigate = useNavigate7();
  return /* @__PURE__ */ jsxs29("div", { children: [
    /* @__PURE__ */ jsx32(MynPageTitle11, { title: "Event Tracking Event Details" }),
    /* @__PURE__ */ jsx32("div", { children: "Employer" })
  ] });
};
var createEmployerEventTrackingRoute = (parentRouteId, environment, context) => {
  const routeId = `${parentRouteId}-events`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx32(Layout8, {}),
      errorElement: /* @__PURE__ */ jsx32(ErrorContainer6, {})
    }
  ];
};

// src/event-tracker/components/EmployerEventTrackingListLayout.tsx
import { Suspense as Suspense14 } from "react";
import { ErrorBoundary as ErrorBoundary8 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback8 } from "app-core";

// src/event-tracker/components/__generated__/EmployerEventTrackingListQuery.graphql.ts
var node24 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "eventEndTimestamp": "DESC"
        }
      ]
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerEventTrackingListQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "EmployerEventTrackingList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerEventTrackingListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "EventsEmployerEventsConnection",
          "kind": "LinkedField",
          "name": "eventsEmployerEvents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventsEmployerEventsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerEventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "clientName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "clientVersion",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "environmentId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventStartTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventEndTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "data",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "metadata",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referrer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userAgent",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ipAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sessionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerEventTrackingList_list",
          "kind": "LinkedHandle",
          "name": "eventsEmployerEvents"
        }
      ]
    },
    "params": {
      "cacheID": "259e03e73eed1ef3e5af6a2b750bdc08",
      "id": null,
      "metadata": {},
      "name": "EmployerEventTrackingListQuery",
      "operationKind": "query",
      "text": "query EmployerEventTrackingListQuery(\n  $where: EmployerEventFilter!\n) {\n  ...EmployerEventTrackingList_list_3FC4Qo\n}\n\nfragment EmployerEventTrackingList_list_3FC4Qo on Query {\n  list: eventsEmployerEvents(first: 25, order: [{eventEndTimestamp: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerEventId\n        code\n        clientName\n        clientVersion\n        environmentId\n        eventType\n        eventStartTimestamp\n        eventEndTimestamp\n        data\n        metadata\n        referrer\n        userAgent\n        ipAddress\n        sessionId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node24.hash = "d72a6c76f25afa019b79349d5aeb7105";
var EmployerEventTrackingListQuery_graphql_default = node24;

// src/event-tracker/components/__generated__/EmployerEventTrackingListPaginationQuery.graphql.ts
var node25 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "eventEndTimestamp": "DESC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerEventTrackingListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "EmployerEventTrackingList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerEventTrackingListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "EventsEmployerEventsConnection",
          "kind": "LinkedField",
          "name": "eventsEmployerEvents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventsEmployerEventsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmployerEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerEventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "clientName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "clientVersion",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "environmentId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventStartTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventEndTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "data",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "metadata",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referrer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "userAgent",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ipAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sessionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "EmployerEventTrackingList_list",
          "kind": "LinkedHandle",
          "name": "eventsEmployerEvents"
        }
      ]
    },
    "params": {
      "cacheID": "7a195868083ca29532ffd2d417f2ecd9",
      "id": null,
      "metadata": {},
      "name": "EmployerEventTrackingListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerEventTrackingListPaginationQuery(\n  $after: String\n  $first: Int = 25\n  $where: EmployerEventFilter!\n) {\n  ...EmployerEventTrackingList_list_3sueo6\n}\n\nfragment EmployerEventTrackingList_list_3sueo6 on Query {\n  list: eventsEmployerEvents(first: $first, after: $after, order: [{eventEndTimestamp: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerEventId\n        code\n        clientName\n        clientVersion\n        environmentId\n        eventType\n        eventStartTimestamp\n        eventEndTimestamp\n        data\n        metadata\n        referrer\n        userAgent\n        ipAddress\n        sessionId\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node25.hash = "ed1d7c899d6afeaba31fccb280526d0c";
var EmployerEventTrackingListPaginationQuery_graphql_default = node25;

// src/event-tracker/components/__generated__/EmployerEventTrackingList_list.graphql.ts
var node26 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerEventTrackingListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerEventTrackingList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "eventEndTimestamp": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "EventsEmployerEventsConnection",
        "kind": "LinkedField",
        "name": "__EmployerEventTrackingList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventsEmployerEventsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployerEvent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerEventId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientVersion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "environmentId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventStartTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventEndTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "data",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metadata",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referrer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userAgent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ipAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node26.hash = "ed1d7c899d6afeaba31fccb280526d0c";
var EmployerEventTrackingList_list_graphql_default = node26;

// src/event-tracker/components/EmployerEventTrackingList.tsx
import { useCallback as useCallback23, useState as useState8 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6, usePaginationFragment as usePaginationFragment4 } from "react-relay";
import { formatDistanceToNow as formatDistanceToNow3, parseISO as parseISO3 } from "date-fns";
import { Suspense as Suspense13 } from "shared-ui";
import {
  DefaultListLayoutItemHeader as DefaultListLayoutItemHeader3,
  DefaultListLayoutSectionElement as DefaultListLayoutSectionElement3,
  EdSkeleton as EdSkeleton10,
  Input as Input6,
  ListLayout as ListLayout3,
  PageHeading as PageHeading7
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined3, useDebounce as useDebounce4 } from "shared-lib";
import { jsx as jsx33, jsxs as jsxs30 } from "react/jsx-runtime";
var queryDef6 = EmployerEventTrackingListQuery_graphql_default;
var fragmentDef6 = EmployerEventTrackingList_list_graphql_default;
function createLinkTo3(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List3 = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment4(fragmentDef6, fragmentRef);
  const onLoadNext = useCallback23(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined3).map((e) => {
    const name = `${e.eventType}`;
    return {
      key: e.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx33("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs30("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx33("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx33("div", { className: "text-md text-blue-700", children: e.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs30("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow3(parseISO3(e.eventStartTimestamp))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: e.code
      },
      element: /* @__PURE__ */ jsx33(DefaultListLayoutSectionElement3, { children: /* @__PURE__ */ jsx33("div", { className: "grid", children: /* @__PURE__ */ jsx33("div", { children: e.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx33(Suspense13, { fallback: /* @__PURE__ */ jsx33(EdSkeleton10, {}), children: /* @__PURE__ */ jsx33(
    ListLayout3,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx33(
        DefaultListLayoutItemHeader3,
        {
          title: "Tenants",
          to: createLinkTo3,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  ) });
};
var EmployerEventTrackingListLoader = ({ where }) => {
  const query = useLazyLoadQuery6(
    queryDef6,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx33("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx33("div", { className: "flex-1", children: /* @__PURE__ */ jsx33(Suspense13, { fallback: /* @__PURE__ */ jsx33(EdSkeleton10, {}), children: /* @__PURE__ */ jsx33(List3, { fragmentRef: query }) }) }) });
};
var EmployerEventTrackingList = ({
  employerId
}) => {
  const [filter2, setFilter] = useState8(null);
  const searchTerm = useDebounce4(filter2, 500);
  let where = null;
  if (employerId) {
    where = {
      employerId: { eq: employerId }
    };
  }
  if (searchTerm) {
    if (!where) {
      where = { eventType: { startsWith: filter2 } };
    } else {
      where.and = [{ eventType: { startsWith: filter2 } }];
    }
  }
  return /* @__PURE__ */ jsxs30("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx33("div", { className: "flex items-center justify-between gap-2 border-b", children: /* @__PURE__ */ jsxs30("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx33(PageHeading7, { children: "Events" }),
      /* @__PURE__ */ jsxs30("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx33("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx33("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx33(
          Input6,
          {
            placeholder: " Name ",
            name: "filter",
            onValueChange: (filter3) => setFilter(filter3)
          },
          "filter"
        ) })
      ] })
    ] }) }),
    where && /* @__PURE__ */ jsx33(EmployerEventTrackingListLoader, { where })
  ] });
};

// src/event-tracker/components/EmployerEventTrackingListLayout.tsx
import { MynPageTitle as MynPageTitle12 } from "shared-ui";
import { jsx as jsx34, jsxs as jsxs31 } from "react/jsx-runtime";
var EmployerEventTrackingListLayout = () => {
  return /* @__PURE__ */ jsx34(Suspense14, { fallback: "Loading Event Tracking...", children: /* @__PURE__ */ jsxs31(ErrorBoundary8, { FallbackComponent: ErrorBoundaryFallback8, children: [
    /* @__PURE__ */ jsx34(MynPageTitle12, { title: "Event Tracking Events" }),
    /* @__PURE__ */ jsx34("div", { children: /* @__PURE__ */ jsx34(EmployerEventTrackingList, {}) })
  ] }) });
};

// src/event-tracker/components/EventTrackingRoute.tsx
import { MynPageTitle as MynPageTitle13 } from "shared-ui";
import { jsx as jsx35, jsxs as jsxs32 } from "react/jsx-runtime";
var Layout9 = () => {
  return /* @__PURE__ */ jsx35(Suspense15, { fallback: "Loading Event Tracking...", children: /* @__PURE__ */ jsxs32(ErrorBoundary9, { FallbackComponent: ErrorBoundaryFallback9, children: [
    /* @__PURE__ */ jsx35(MynPageTitle13, { title: "Event Tracking" }),
    /* @__PURE__ */ jsx35("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx35("div", { children: /* @__PURE__ */ jsx35(Outlet5, {}) }) })
  ] }) });
};
var createEventTrackingRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}-event-tracking`;
  const employersRouteId = `${routeId}-employers`;
  const employerListRouteId = `${employersRouteId}-list`;
  const employerListEmployerRouteId = `${employerListRouteId}-employer`;
  const employerRouteId = `${employersRouteId}-employer`;
  const candidateListRouteId = `${routeId}-candidates-list`;
  const candidateRouteId = `${routeId}-candidate`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx35(Layout9, {}),
      children: [
        {
          id: employersRouteId,
          path: "employers/*",
          element: /* @__PURE__ */ jsx35(Layout9, {}),
          children: [
            {
              id: employerRouteId,
              path: ":employerCode/*",
              element: /* @__PURE__ */ jsx35(OutletRoute7, {}),
              children: createEmployerEventTrackingRoute(
                employerRouteId,
                environment,
                context
              )
            },
            {
              id: employerListRouteId,
              path: "list/*",
              element: /* @__PURE__ */ jsx35(EmployerEventTrackingListLayout, {}),
              children: [
                {
                  id: employerListEmployerRouteId,
                  path: ":employerCode/*",
                  element: /* @__PURE__ */ jsx35(OutletRoute7, {}),
                  children: createEmployerEventTrackingRoute(
                    employerListEmployerRouteId,
                    environment,
                    context
                  )
                }
              ]
            },
            {
              path: "*",
              element: /* @__PURE__ */ jsx35(Navigate6, { to: "list", replace: true })
            }
          ]
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx35(Navigate6, { to: "employers", replace: true })
        }
      ]
    }
  ];
};

// src/recommendation-runs/components/createProfileRecommendationRunsRoute.tsx
import { Suspense as Suspense17 } from "react";
import { Navigate as Navigate7 } from "react-router-dom";
import { ErrorBoundary as ErrorBoundary10 } from "react-error-boundary";
import { ErrorBoundaryFallback as ErrorBoundaryFallback10, OutletRoute as OutletRoute8 } from "app-core";

// src/recommendation-runs/components/__generated__/ProfileRecommendationRunsContainerQuery.graphql.ts
var node27 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    v1
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileRecommendationRunsContainerQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "ProfileRecommendationRunsList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileRecommendationRunsContainerQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "RecruitCandidateRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitCandidateRecommendationRunsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateRecommendationRun",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusLog",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "newRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "expiredRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notRecommendedButAlreadySentCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitCandidateRecommendationRunId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateRecommendationParameters",
                      "kind": "LinkedField",
                      "name": "parameters",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sendEnabled",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recommendEnabled",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maxVacancyOpenDays",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "combinedScoreThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchScoreThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "experienceSimilarityThreshold",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "ProfileRecommendationRunsList_list",
          "kind": "LinkedHandle",
          "name": "recruitCandidateRecommendationRuns"
        }
      ]
    },
    "params": {
      "cacheID": "846a8f5ab1befee02e0da759b6d0b6dd",
      "id": null,
      "metadata": {},
      "name": "ProfileRecommendationRunsContainerQuery",
      "operationKind": "query",
      "text": "query ProfileRecommendationRunsContainerQuery(\n  $where: RecruitCandidateRecommendationRunFilter\n) {\n  ...ProfileRecommendationRunsList_list_3FC4Qo\n}\n\nfragment ProfileRecommendationRunsList_list_3FC4Qo on Query {\n  list: recruitCandidateRecommendationRuns(first: 25, order: [{createdOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        status\n        statusLog\n        createdAt\n        newRecommendationsCount\n        updatedRecommendationsCount\n        expiredRecommendationsCount\n        notRecommendedButAlreadySentCount\n        recruitCandidateRecommendationRunId\n        parameters {\n          sendEnabled\n          recommendEnabled\n          maxVacancyOpenDays\n          combinedScoreThreshold\n          jobMatchScoreThreshold\n          experienceSimilarityThreshold\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node27.hash = "155da179274e2de09afb372e7f74b5c9";
var ProfileRecommendationRunsContainerQuery_graphql_default = node27;

// src/recommendation-runs/components/ProfileRecommendationRunsContainer.tsx
import { Suspense as Suspense16 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { EdSkeleton as EdSkeleton11 } from "shared-ui";

// src/recommendation-runs/components/__generated__/ProfileRecommendationRunsListQuery.graphql.ts
var node28 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 25,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    v3
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "ProfileRecommendationRunsListQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "ProfileRecommendationRunsList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "ProfileRecommendationRunsListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "RecruitCandidateRecommendationRunsConnection",
          "kind": "LinkedField",
          "name": "recruitCandidateRecommendationRuns",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RecruitCandidateRecommendationRunsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecruitCandidateRecommendationRun",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusLog",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "newRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "expiredRecommendationsCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notRecommendedButAlreadySentCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitCandidateRecommendationRunId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecruitCandidateRecommendationParameters",
                      "kind": "LinkedField",
                      "name": "parameters",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sendEnabled",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recommendEnabled",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "maxVacancyOpenDays",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "combinedScoreThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "jobMatchScoreThreshold",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "experienceSimilarityThreshold",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [],
          "handle": "connection",
          "key": "ProfileRecommendationRunsList_list",
          "kind": "LinkedHandle",
          "name": "recruitCandidateRecommendationRuns"
        }
      ]
    },
    "params": {
      "cacheID": "1d4e3af187bbfcb9d659bd903b916386",
      "id": null,
      "metadata": {},
      "name": "ProfileRecommendationRunsListQuery",
      "operationKind": "query",
      "text": "query ProfileRecommendationRunsListQuery(\n  $after: String\n  $first: Int = 25\n  $where: RecruitCandidateRecommendationRunFilter\n) {\n  ...ProfileRecommendationRunsList_list_3sueo6\n}\n\nfragment ProfileRecommendationRunsList_list_3sueo6 on Query {\n  list: recruitCandidateRecommendationRuns(first: $first, after: $after, order: [{createdOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        code\n        status\n        statusLog\n        createdAt\n        newRecommendationsCount\n        updatedRecommendationsCount\n        expiredRecommendationsCount\n        notRecommendedButAlreadySentCount\n        recruitCandidateRecommendationRunId\n        parameters {\n          sendEnabled\n          recommendEnabled\n          maxVacancyOpenDays\n          combinedScoreThreshold\n          jobMatchScoreThreshold\n          experienceSimilarityThreshold\n        }\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "2af9f4f080adb4ef8b95335c185c80b7";
var ProfileRecommendationRunsListQuery_graphql_default = node28;

// src/recommendation-runs/components/__generated__/ProfileRecommendationRunsList_list.graphql.ts
var node29 = /* @__PURE__ */ function() {
  var v0 = [
    "list"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 25,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": ProfileRecommendationRunsListQuery_graphql_default
      }
    },
    "name": "ProfileRecommendationRunsList_list",
    "selections": [
      {
        "alias": "list",
        "args": null,
        "concreteType": "RecruitCandidateRecommendationRunsConnection",
        "kind": "LinkedField",
        "name": "__ProfileRecommendationRunsList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitCandidateRecommendationRunsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitCandidateRecommendationRun",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusLog",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newRecommendationsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedRecommendationsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expiredRecommendationsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notRecommendedButAlreadySentCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitCandidateRecommendationRunId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitCandidateRecommendationParameters",
                    "kind": "LinkedField",
                    "name": "parameters",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sendEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recommendEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxVacancyOpenDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "combinedScoreThreshold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobMatchScoreThreshold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "experienceSimilarityThreshold",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node29.hash = "2af9f4f080adb4ef8b95335c185c80b7";
var ProfileRecommendationRunsList_list_graphql_default = node29;

// src/recommendation-runs/components/ProfileRecommendationRunsList.tsx
import { usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { isNotNull as isNotNull3, timeAgo as timeAgo2 } from "shared-lib";
import {
  EdColumnCell as EdColumnCell2,
  EdListHeader as EdListHeader2,
  EdRow as EdRow2,
  EdTable as EdTable2,
  Tag
} from "shared-ui";
import { jsx as jsx36, jsxs as jsxs33 } from "react/jsx-runtime";
var fragmentDef7 = ProfileRecommendationRunsList_list_graphql_default;
var RecommendationRunsTableColumns = [
  { id: "runOn", name: "Run On" },
  { id: "status", name: "Status" },
  { id: "enabledSettings", name: "Enabled Settings" },
  { id: "thresholds", name: "Thresholds" },
  { id: "maxVacancyOpenDays", name: "Max Vacancy Open Days" },
  { id: "total", name: "Total" },
  { id: "ofWhichNew", name: "(of which new)" },
  { id: "ofWhichUpdated", name: "(of which updated)" },
  { id: "ofWhichExpired", name: "(of which expired)" },
  { id: "ofWhichAlreadySent", name: "(of which already sent)" },
  { id: "log", name: "Log" }
];
var ProfileRecommendationRunsList = ({ fragmentRef }) => {
  const paging = usePaginationFragment5(fragmentDef7, fragmentRef);
  const { data } = paging;
  const tagColors = {
    PENDING: "bg-primary-200",
    ACTIVE: "bg-green-200",
    COMPLETED: "bg-orange-200",
    FAILED: "bg-red-200"
  };
  const rows = data.list?.edges?.map((e) => e.node).filter(isNotNull3).map((data2) => {
    return /* @__PURE__ */ jsxs33(EdRow2, { rowKey: data2.id, children: [
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: timeAgo2(data2.createdAt) }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: /* @__PURE__ */ jsx36(Tag, { color: tagColors[data2.status.toUpperCase()], children: data2.status }) }),
      /* @__PURE__ */ jsxs33(EdColumnCell2, { children: [
        "Send Enabled: ",
        data2.parameters.sendEnabled ? "Yes" : "No",
        " ",
        /* @__PURE__ */ jsx36("br", {}),
        "Recommend Enabled: ",
        data2.parameters.recommendEnabled ? "Yes" : "No"
      ] }),
      /* @__PURE__ */ jsxs33(EdColumnCell2, { children: [
        "Combined Score: ",
        data2.parameters.combinedScoreThreshold,
        " ",
        /* @__PURE__ */ jsx36("br", {}),
        "Job Match Score: ",
        data2.parameters.jobMatchScoreThreshold,
        " ",
        /* @__PURE__ */ jsx36("br", {}),
        "Experience Similarity:",
        " ",
        data2.parameters.experienceSimilarityThreshold
      ] }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.parameters.maxVacancyOpenDays }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.newRecommendationsCount + data2.updatedRecommendationsCount + data2.expiredRecommendationsCount + data2.notRecommendedButAlreadySentCount }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.newRecommendationsCount }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.updatedRecommendationsCount }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.expiredRecommendationsCount }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.notRecommendedButAlreadySentCount }),
      /* @__PURE__ */ jsx36(EdColumnCell2, { children: data2.statusLog.map((log) => log).join(", ") })
    ] });
  });
  return /* @__PURE__ */ jsxs33("div", { className: "flex flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsx36(EdListHeader2, { paging }),
    /* @__PURE__ */ jsx36("div", { className: "flex ", children: /* @__PURE__ */ jsx36("div", { className: "w-full p-4", children: /* @__PURE__ */ jsx36(
      EdTable2,
      {
        defaultColumns: RecommendationRunsTableColumns,
        rows
      }
    ) }) })
  ] });
};

// src/recommendation-runs/components/ProfileRecommendationRunsContainer.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var queryDef7 = ProfileRecommendationRunsContainerQuery_graphql_default;
var RecommendationRunsContainer = () => {
  const data = useLazyLoadQuery7(
    queryDef7,
    {
      where: {}
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!data) {
    return /* @__PURE__ */ jsx37(EdSkeleton11, {});
  }
  return /* @__PURE__ */ jsx37(Suspense16, { fallback: /* @__PURE__ */ jsx37(EdSkeleton11, {}), children: /* @__PURE__ */ jsx37(ProfileRecommendationRunsList, { fragmentRef: data }) });
};

// src/recommendation-runs/components/createProfileRecommendationRunsRoute.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var ListRoute3 = () => {
  return /* @__PURE__ */ jsx38(Suspense17, { fallback: "Loading Skill Groups...", children: /* @__PURE__ */ jsx38(ErrorBoundary10, { FallbackComponent: ErrorBoundaryFallback10, children: /* @__PURE__ */ jsx38(RecommendationRunsContainer, {}) }) });
};
var createProfileRecommendationRunsRoute = (routePrefix, environment, context) => {
  const routeId = `${routePrefix}profile-recommendation-runs`;
  const listRouteId = `${routeId}-list`;
  return [
    {
      id: routeId,
      path: "*",
      element: /* @__PURE__ */ jsx38(OutletRoute8, {}),
      children: [
        {
          id: listRouteId,
          path: "list/*",
          element: /* @__PURE__ */ jsx38(ListRoute3, {})
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx38(Navigate7, { to: "list", replace: true })
        }
      ]
    }
  ];
};

// src/core/components/Layout.tsx
import { jsx as jsx39, jsxs as jsxs34 } from "react/jsx-runtime";
var Layout10 = () => {
  const location = useLocation2();
  const tabs = useMemo9(() => {
    return [
      createLinkState2(location, "Home", `../home`, HomeIcon),
      createLinkState2(
        location,
        "Ref Data",
        `../ref-data`,
        InformationCircleIcon
      ),
      createLinkState2(
        location,
        "Companies",
        `../companies`,
        BuildingStorefrontIcon
      ),
      createLinkState2(
        location,
        "Event Tracking",
        `../event-tracking`,
        BookmarkIcon
      ),
      createLinkState2(
        location,
        "Profile Recommendation Runs",
        `../profile-recommendation-runs`,
        DocumentTextIcon
      ),
      createLinkState2(
        location,
        "Skill Groups",
        `../skill-groups`,
        AcademicCapIcon
      ),
      createLinkState2(location, "Geo", `../geo`, BuildingOfficeIcon)
    ];
  }, [location]);
  return /* @__PURE__ */ jsx39(Suspense18, { fallback: "Loading Data Management...", children: /* @__PURE__ */ jsxs34(ErrorBoundary11, { FallbackComponent: ErrorBoundaryFallback11, children: [
    /* @__PURE__ */ jsx39(MynPageTitle14, { title: "Data Management" }),
    /* @__PURE__ */ jsxs34("div", { className: "bg-white", children: [
      /* @__PURE__ */ jsxs34("div", { className: "flex-col gap-2 border-b", children: [
        /* @__PURE__ */ jsx39("div", { className: "border-b", children: /* @__PURE__ */ jsx39("div", { className: "text-primary-700 p-4 font-medium", children: "Data Management" }) }),
        /* @__PURE__ */ jsx39("div", { className: "p-2", children: /* @__PURE__ */ jsx39(TabUnderline2, { tabs }) })
      ] }),
      /* @__PURE__ */ jsx39("div", { className: "", children: /* @__PURE__ */ jsx39(Outlet6, {}) })
    ] })
  ] }) });
};
var Home = () => {
  return /* @__PURE__ */ jsx39("div", { className: "text-primary-700 p-4 text-2xl font-bold", children: "Data Management" });
};
var createDataManagementRoutes = (environment, context) => {
  const parentRouteId = "data-management";
  return [
    {
      path: "*",
      element: /* @__PURE__ */ jsx39(Layout10, {}),
      children: [
        {
          path: "home/*",
          element: /* @__PURE__ */ jsx39(Home, {})
        },
        {
          path: "skill-groups/*",
          element: /* @__PURE__ */ jsx39(OutletRoute9, {}),
          children: createSkillGroupsRoute(parentRouteId, environment, context)
        },
        {
          path: "ref-data/*",
          element: /* @__PURE__ */ jsx39(OutletRoute9, {}),
          children: createRefDataRoute(parentRouteId, environment, context)
        },
        {
          path: "event-tracking/*",
          element: /* @__PURE__ */ jsx39(OutletRoute9, {}),
          children: createEventTrackingRoute(
            parentRouteId,
            environment,
            context
          )
        },
        {
          path: "companies/*",
          element: /* @__PURE__ */ jsx39(OutletRoute9, {}),
          children: createCompaniesRoute(parentRouteId, environment, context)
        },
        {
          path: "profile-recommendation-runs/*",
          element: /* @__PURE__ */ jsx39(OutletRoute9, {}),
          children: createProfileRecommendationRunsRoute(
            parentRouteId,
            environment,
            context
          )
        },
        {
          path: "geo/*",
          element: /* @__PURE__ */ jsxs34("div", { children: [
            /* @__PURE__ */ jsx39(MynPageTitle14, { title: "Geo" }),
            /* @__PURE__ */ jsx39("div", { className: "text-primary-700 m-8 font-bold", children: "TODO" }),
            ","
          ] })
        },
        {
          path: "*",
          element: /* @__PURE__ */ jsx39(Navigate8, { to: "home", replace: true })
        }
      ]
    }
  ];
};

// src/core/components/SearchErrorBoundaryFallback.tsx
import { jsx as jsx40, jsxs as jsxs35 } from "react/jsx-runtime";
var SearchErrorBoundaryFallback = ({
  error
}) => {
  return /* @__PURE__ */ jsxs35("div", { className: "mt-4 rounded-lg border border bg-white p-4", role: "alert", children: [
    /* @__PURE__ */ jsx40("div", { className: "text-info-500 mb-2 border-b border-gray-100 pb-2 font-medium", children: /* @__PURE__ */ jsx40("h1", { children: "Something went wrong" }) }),
    /* @__PURE__ */ jsxs35("div", { className: "flex flex-wrap gap-2", children: [
      /* @__PURE__ */ jsxs35("p", { className: "text-danger-500", children: [
        "There's a problem with the search service,",
        " ",
        /* @__PURE__ */ jsx40("span", { className: "font-medium", children: "please try again" })
      ] }),
      /* @__PURE__ */ jsx40("p", { className: "text-danger-500", children: "If it persists please contact support" })
    ] })
  ] });
};

// src/industries/components/__generated__/IndustrySearchBoxQuery.graphql.ts
var node30 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "name"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "startsWith",
              "variableName": "name"
            }
          ],
          "kind": "ObjectValue",
          "name": "name"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IndustrySearchBoxQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "name"
            }
          ],
          "kind": "FragmentSpread",
          "name": "IndustrySearchOptions_industries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IndustrySearchBoxQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IndustriesConnection",
          "kind": "LinkedField",
          "name": "industries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IndustriesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Industry",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "IndustrySearchOptions_industries",
          "kind": "LinkedHandle",
          "name": "industries"
        }
      ]
    },
    "params": {
      "cacheID": "143bd6e7de097c0be98cd3b673867521",
      "id": null,
      "metadata": {},
      "name": "IndustrySearchBoxQuery",
      "operationKind": "query",
      "text": "query IndustrySearchBoxQuery(\n  $name: String!\n) {\n  ...IndustrySearchOptions_industries_2aiVTE\n}\n\nfragment IndustrySearchOptions_industries_2aiVTE on Query {\n  industries(first: 10, order: [{name: ASC}], where: {name: {startsWith: $name}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        industryId\n        name\n        description\n        companyCount\n        profileCount\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node30.hash = "092d4685910f24b7bbd86e2851822e77";
var IndustrySearchBoxQuery_graphql_default = node30;

// src/industries/components/IndustrySearchBox.tsx
import { useCallback as useCallback24, useEffect as useEffect3, useMemo as useMemo10, useState as useState9 } from "react";
import { useQueryLoader } from "react-relay";
import { ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/24/solid";
import { Combobox as Combobox6 } from "@headlessui/react";
import { Suspense as Suspense19 } from "shared-ui";

// src/industries/components/__generated__/IndustrySearchOptionsPaginationQuery.graphql.ts
var node31 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "name"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "name": "ASC"
        }
      ]
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "startsWith",
              "variableName": "name"
            }
          ],
          "kind": "ObjectValue",
          "name": "name"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IndustrySearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "name"
            }
          ],
          "kind": "FragmentSpread",
          "name": "IndustrySearchOptions_industries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IndustrySearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IndustriesConnection",
          "kind": "LinkedField",
          "name": "industries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IndustriesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Industry",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "industryId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "IndustrySearchOptions_industries",
          "kind": "LinkedHandle",
          "name": "industries"
        }
      ]
    },
    "params": {
      "cacheID": "47039b51da86d0816d473b7b541a9dae",
      "id": null,
      "metadata": {},
      "name": "IndustrySearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": 'query IndustrySearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $name: String = ""\n) {\n  ...IndustrySearchOptions_industries_3cTRis\n}\n\nfragment IndustrySearchOptions_industries_3cTRis on Query {\n  industries(first: $first, after: $after, order: [{name: ASC}], where: {name: {startsWith: $name}}) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        industryId\n        name\n        description\n        companyCount\n        profileCount\n        __typename\n      }\n    }\n  }\n}\n'
    }
  };
}();
node31.hash = "01c0204045a3002d63862371ca6a7042";
var IndustrySearchOptionsPaginationQuery_graphql_default = node31;

// src/industries/components/__generated__/IndustrySearchOptions_industries.graphql.ts
var node32 = /* @__PURE__ */ function() {
  var v0 = [
    "industries"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "name"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": IndustrySearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "IndustrySearchOptions_industries",
    "selections": [
      {
        "alias": "industries",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "name": "ASC"
              }
            ]
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "startsWith",
                    "variableName": "name"
                  }
                ],
                "kind": "ObjectValue",
                "name": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "IndustriesConnection",
        "kind": "LinkedField",
        "name": "__IndustrySearchOptions_industries_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustriesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Industry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "industryId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node32.hash = "01c0204045a3002d63862371ca6a7042";
var IndustrySearchOptions_industries_graphql_default = node32;

// src/industries/components/IndustrySearchOptions.tsx
import {
  usePaginationFragment as usePaginationFragment6,
  usePreloadedQuery as usePreloadedQuery5
} from "react-relay";
import { Combobox as Combobox5 } from "@headlessui/react";
import { CheckIcon as CheckIcon3 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull4 } from "shared-lib";
import { classNames as classNames3 } from "shared-ui";
import { Fragment as Fragment7, jsx as jsx41, jsxs as jsxs36 } from "react/jsx-runtime";
var fragmentDef8 = IndustrySearchOptions_industries_graphql_default;
var IndustrySearchOptionsLoader = ({ queryRef }) => {
  const data = usePreloadedQuery5(
    industrySearchBoxQueryDef,
    queryRef
  );
  return /* @__PURE__ */ jsx41(IndustrySearchOptions2, { fragmentRef: data });
};
var IndustrySearchOptions2 = ({ fragmentRef }) => {
  const { data, refetch } = usePaginationFragment6(fragmentDef8, fragmentRef);
  const { industries } = data;
  const items = industries?.edges?.map((e) => e.node);
  const rows = items ?? [].filter(isNotNull4);
  return /* @__PURE__ */ jsx41(Combobox5.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx41(
    Combobox5.Option,
    {
      value: result,
      className: ({ active }) => classNames3(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs36(Fragment7, { children: [
        /* @__PURE__ */ jsx41("div", { className: "flex", children: /* @__PURE__ */ jsx41(
          "span",
          {
            className: classNames3(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result && result.name ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx41(
          "span",
          {
            className: classNames3(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx41(CheckIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.id
  )) });
};

// src/industries/components/IndustrySearchBox.tsx
import { jsx as jsx42, jsxs as jsxs37 } from "react/jsx-runtime";
var compareResults3 = (a, b) => a?.id === b?.id;
var industrySearchBoxQueryDef = IndustrySearchBoxQuery_graphql_default;
var IndustrySearchBox2 = ({ name, onSelected, value, placeholder }) => {
  const [queryReference, loadQuery5, disposeQuery] = useQueryLoader(industrySearchBoxQueryDef);
  const [selected, setSelected] = useState9(value);
  const [searchTerm, setSearchTerm] = useState9("");
  const onQueryChangeHandler = useMemo10(
    () => debounce_default((q) => setSearchTerm(q), 500),
    []
  );
  useEffect3(() => {
    if (!searchTerm) {
      return;
    }
    loadQuery5({ name: searchTerm });
  }, [searchTerm, loadQuery5]);
  useEffect3(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback24(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected, setSelected]
  );
  return /* @__PURE__ */ jsx42(Suspense19, { fallback: /* @__PURE__ */ jsx42("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx42(
    Combobox6,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      by: compareResults3,
      children: /* @__PURE__ */ jsxs37("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx42(
          Combobox6.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            displayValue: (result) => {
              if (!result || !result.name) {
                return "";
              }
              return result.name;
            },
            autoComplete: "off",
            placeholder: placeholder || "Search or select an industry",
            "aria-label": "Industry select list"
          }
        ),
        /* @__PURE__ */ jsx42(
          Combobox6.Button,
          {
            className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
            "aria-label": "Industry select",
            children: /* @__PURE__ */ jsx42(
              ChevronUpDownIcon3,
              {
                className: "h-5 w-5 text-gray-600",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx42(Suspense19, { fallback: "Searching...", children: queryReference && /* @__PURE__ */ jsx42(IndustrySearchOptionsLoader, { queryRef: queryReference }) })
      ] })
    }
  ) });
};

// src/industries/components/IndustrySearchBoxInput.tsx
import { Controller as Controller3 } from "react-hook-form";
import { jsx as jsx43 } from "react/jsx-runtime";
var IndustrySearchBoxInput = ({
  name,
  control,
  onSelected
}) => {
  return /* @__PURE__ */ jsx43(
    Controller3,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        return /* @__PURE__ */ jsx43(
          IndustrySearchBox2,
          {
            name,
            onSelected: (result) => {
              onControllerChange(result);
              if (onSelected) {
                onSelected(result);
              }
            },
            value: value ?? null
          }
        );
      }
    }
  );
};

// src/industries/components/IndustrySearchContainer.tsx
import { useCallback as useCallback25, useState as useState10 } from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var IndustrySearchContainer = ({
  name,
  onSearchCompleted,
  defaultValue = null
}) => {
  const [selectedResult, setSelectedResult] = useState10(defaultValue);
  const onSetSelected = useCallback25(
    (r) => {
      setSelectedResult(r);
      onSearchCompleted(r);
    },
    [selectedResult]
  );
  return /* @__PURE__ */ jsx44("div", { children: /* @__PURE__ */ jsx44(
    IndustrySearchBox2,
    {
      value: selectedResult,
      name: name || "industry-search",
      onSelected: onSetSelected
    }
  ) });
};

// src/industries/components/IndustrySearchListModal.tsx
import { Fragment as Fragment8, Suspense as Suspense21 } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { EdSkeleton as EdSkeleton12 } from "shared-ui";

// src/industries/components/__generated__/IndustrySearchListQuery.graphql.ts
var node33 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "alias": "list",
      "args": null,
      "concreteType": "Industry",
      "kind": "LinkedField",
      "name": "industriesAll",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "industryId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "IndustrySearchListQuery",
      "selections": v0,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "IndustrySearchListQuery",
      "selections": v0
    },
    "params": {
      "cacheID": "5dff12880dd980c26911c7f56e6c2df8",
      "id": null,
      "metadata": {},
      "name": "IndustrySearchListQuery",
      "operationKind": "query",
      "text": "query IndustrySearchListQuery {\n  list: industriesAll {\n    id\n    industryId\n    name\n    description\n    companyCount\n    profileCount\n  }\n}\n"
    }
  };
}();
node33.hash = "dc1afa4674172bae8718b00f940eb31a";
var IndustrySearchListQuery_graphql_default = node33;

// src/industries/components/IndustrySearchList.tsx
import { useCallback as useCallback26, useState as useState11 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay";
import { Suspense as Suspense20 } from "shared-ui";
import { classNames as classNames4 } from "shared-ui";
import { jsx as jsx45 } from "react/jsx-runtime";
var industrySearchListQueryDef = IndustrySearchListQuery_graphql_default;
var IndustrySearchItem = ({ item, onSelected, selected }) => {
  const isSelected = selected && selected.id === item.id;
  const onClick = useCallback26(() => {
    onSelected(item);
  }, [item, onSelected]);
  return /* @__PURE__ */ jsx45(
    "div",
    {
      onClick,
      className: classNames4(
        "cursor-pointer p-2",
        isSelected ? "bg-primary-500 text-white" : "bg-white text-gray-900"
      ),
      children: item.name
    },
    item.id
  );
};
var IndustrySearchList = ({ name, onSelected, value }) => {
  const query = useLazyLoadQuery8(
    industrySearchListQueryDef,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [selected, setSelected] = useState11(() => {
    return value;
  });
  const onSetSelected = useCallback26(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected, setSelected]
  );
  const { list } = query;
  return /* @__PURE__ */ jsx45(Suspense20, { fallback: /* @__PURE__ */ jsx45("div", { children: "Searching...." }), children: /* @__PURE__ */ jsx45("div", { className: "flex h-96 flex-col gap-2 divide-y overflow-y-scroll", children: list.map((result) => {
    return /* @__PURE__ */ jsx45(
      IndustrySearchItem,
      {
        item: result,
        onSelected: onSetSelected,
        selected
      },
      result.id
    );
  }) }) });
};

// src/industries/components/IndustrySearchListModal.tsx
import { jsx as jsx46, jsxs as jsxs38 } from "react/jsx-runtime";
var IndustrySearchListModal = ({
  defaultValue,
  onSearchCompleted,
  onBack
}) => {
  return /* @__PURE__ */ jsxs38("div", { children: [
    /* @__PURE__ */ jsx46("div", { className: "flex items-center justify-between gap-2", children: defaultValue && /* @__PURE__ */ jsx46("div", { className: "p-2", children: defaultValue.name }) }),
    /* @__PURE__ */ jsx46(Transition.Root, { show: true, as: Fragment8, children: /* @__PURE__ */ jsxs38(Dialog, { as: "div", className: "relative z-10", onClose: onBack, children: [
      /* @__PURE__ */ jsx46(
        Transition.Child,
        {
          as: Fragment8,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ jsx46("div", { className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
        }
      ),
      /* @__PURE__ */ jsx46("div", { className: "fixed inset-0 z-10 w-screen overflow-y-auto", children: /* @__PURE__ */ jsx46("div", { className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0", children: /* @__PURE__ */ jsx46(
        Transition.Child,
        {
          as: Fragment8,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          enterTo: "opacity-100 translate-y-0 sm:scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
          leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          children: /* @__PURE__ */ jsxs38(Dialog.Panel, { className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6", children: [
            /* @__PURE__ */ jsx46("div", { className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block", children: /* @__PURE__ */ jsxs38(
              "button",
              {
                type: "button",
                className: "rounded-md bg-white text-gray-600 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                onClick: onBack,
                children: [
                  /* @__PURE__ */ jsx46("span", { className: "sr-only", children: "Close" }),
                  /* @__PURE__ */ jsx46(XMarkIcon, { className: "h-6 w-6", "aria-hidden": "true" })
                ]
              }
            ) }),
            /* @__PURE__ */ jsx46("div", { className: "sm:flex sm:items-start", children: /* @__PURE__ */ jsxs38("div", { className: "mt-3 flex-1 text-center sm:ml-4 sm:mt-0 sm:text-left", children: [
              /* @__PURE__ */ jsx46(
                Dialog.Title,
                {
                  as: "h3",
                  className: "text-base font-semibold leading-6 text-gray-900",
                  children: "Select Industry"
                }
              ),
              /* @__PURE__ */ jsx46("div", { className: "mt-2", children: /* @__PURE__ */ jsx46(Suspense21, { fallback: /* @__PURE__ */ jsx46(EdSkeleton12, {}), children: /* @__PURE__ */ jsx46(
                IndustrySearchList,
                {
                  name: "industry-search-list",
                  value: defaultValue,
                  onSelected: onSearchCompleted
                }
              ) }) })
            ] }) }),
            /* @__PURE__ */ jsx46("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse", children: /* @__PURE__ */ jsx46(
              "button",
              {
                type: "button",
                className: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto",
                onClick: onBack,
                children: "Back"
              }
            ) })
          ] })
        }
      ) }) })
    ] }) })
  ] });
};

// src/geo/countries/components/__generated__/GeoCountriesSearchBoxQuery.graphql.ts
var node34 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "displayOrder": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "GeoCountriesSearchBoxQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GeoCountriesSearchOptions_countries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "GeoCountriesSearchBoxQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "GeoCountriesConnection",
          "kind": "LinkedField",
          "name": "geoCountries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoCountriesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GeoCountry",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "iso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phone",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "GeoCountriesSearchOptions_geoCountries",
          "kind": "LinkedHandle",
          "name": "geoCountries"
        }
      ]
    },
    "params": {
      "cacheID": "6599361ac8b1480a8ff00a8ab05a885f",
      "id": null,
      "metadata": {},
      "name": "GeoCountriesSearchBoxQuery",
      "operationKind": "query",
      "text": "query GeoCountriesSearchBoxQuery(\n  $where: GeoCountryFilter!\n) {\n  ...GeoCountriesSearchOptions_countries\n}\n\nfragment GeoCountriesSearchOptions_countries on Query {\n  geoCountries(first: 10, order: [{displayOrder: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        iso3\n        name\n        currencyCode\n        currencyName\n        phone\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "254953f08ecede16be4b8f6c099a5b7e";
var GeoCountriesSearchBoxQuery_graphql_default = node34;

// src/geo/countries/components/GeoCountriesSearchBox.tsx
import {
  Suspense as Suspense22,
  useCallback as useCallback27,
  useEffect as useEffect5,
  useMemo as useMemo12,
  useState as useState12
} from "react";
import { useLazyLoadQuery as useLazyLoadQuery9 } from "react-relay";
import { ErrorBoundary as ErrorBoundary12 } from "react-error-boundary";
import { ChevronUpDownIcon as ChevronUpDownIcon4 } from "@heroicons/react/24/solid";
import { Combobox as Combobox8 } from "@headlessui/react";

// src/geo/countries/components/__generated__/GeoCountriesSearchOptionsPaginationQuery.graphql.ts
var node35 = /* @__PURE__ */ function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "displayOrder": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "GeoCountriesSearchOptionsPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "GeoCountriesSearchOptions_countries"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "GeoCountriesSearchOptionsPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "GeoCountriesConnection",
          "kind": "LinkedField",
          "name": "geoCountries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GeoCountriesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GeoCountry",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "iso3",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currencyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phone",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "GeoCountriesSearchOptions_geoCountries",
          "kind": "LinkedHandle",
          "name": "geoCountries"
        }
      ]
    },
    "params": {
      "cacheID": "b2844d3c93ee3e3ba97d6bfac2fc9c17",
      "id": null,
      "metadata": {},
      "name": "GeoCountriesSearchOptionsPaginationQuery",
      "operationKind": "query",
      "text": "query GeoCountriesSearchOptionsPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: GeoCountryFilter\n) {\n  ...GeoCountriesSearchOptions_countries_2HEEH6\n}\n\nfragment GeoCountriesSearchOptions_countries_2HEEH6 on Query {\n  geoCountries(first: $first, after: $after, order: [{displayOrder: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        iso3\n        name\n        currencyCode\n        currencyName\n        phone\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node35.hash = "a6ff947b07abe70f1042c51c38b11494";
var GeoCountriesSearchOptionsPaginationQuery_graphql_default = node35;

// src/geo/countries/components/__generated__/GeoCountriesSearchOptions_countries.graphql.ts
var node36 = /* @__PURE__ */ function() {
  var v0 = [
    "geoCountries"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": GeoCountriesSearchOptionsPaginationQuery_graphql_default
      }
    },
    "name": "GeoCountriesSearchOptions_countries",
    "selections": [
      {
        "alias": "geoCountries",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "displayOrder": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "GeoCountriesConnection",
        "kind": "LinkedField",
        "name": "__GeoCountriesSearchOptions_geoCountries_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeoCountriesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeoCountry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iso3",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencyCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencyName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node36.hash = "a6ff947b07abe70f1042c51c38b11494";
var GeoCountriesSearchOptions_countries_graphql_default = node36;

// src/geo/countries/components/GeoCountriesSearchOptions.tsx
import { useEffect as useEffect4, useMemo as useMemo11 } from "react";
import { usePaginationFragment as usePaginationFragment7 } from "react-relay";
import { CheckIcon as CheckIcon4 } from "@heroicons/react/24/solid";
import { Combobox as Combobox7 } from "@headlessui/react";
import { classNames as classNames5 } from "shared-ui";
import { Fragment as Fragment9, jsx as jsx47, jsxs as jsxs39 } from "react/jsx-runtime";
var fragmentDef9 = GeoCountriesSearchOptions_countries_graphql_default;
var GeoCountriesSearchOptions = ({
  searchTerm,
  fragmentRef
}) => {
  const where = useMemo11(() => {
    if (searchTerm) {
      return {
        isSupported: { eq: true },
        and: [{ name: { startsWith: searchTerm } }]
      };
    } else {
      return { isSupported: { eq: true } };
    }
  }, [searchTerm]);
  const { data, refetch } = usePaginationFragment7(fragmentDef9, fragmentRef);
  useEffect4(() => {
    refetch({ first: 10, where }, { fetchPolicy: "store-or-network" });
  }, [refetch, searchTerm, where]);
  const { geoCountries } = data;
  const rows = (geoCountries?.edges ?? []).map((edge) => edge.node);
  return /* @__PURE__ */ jsx47(Combobox7.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => /* @__PURE__ */ jsx47(
    Combobox7.Option,
    {
      value: result,
      className: ({ active }) => classNames5(
        "relative cursor-default select-none py-2 pl-3 pr-9",
        active ? "bg-info-600 text-white" : "text-gray-900"
      ),
      children: ({ active, selected }) => /* @__PURE__ */ jsxs39(Fragment9, { children: [
        /* @__PURE__ */ jsx47("div", { className: "flex", children: /* @__PURE__ */ jsx47(
          "span",
          {
            className: classNames5(
              "truncate",
              selected ? "font-semibold" : ""
            ),
            children: result ? result.name : ""
          }
        ) }),
        selected && /* @__PURE__ */ jsx47(
          "span",
          {
            className: classNames5(
              "absolute inset-y-0 right-0 flex items-center pr-4",
              active ? "bg-info-600 text-white" : "text-info-600"
            ),
            children: /* @__PURE__ */ jsx47(CheckIcon4, { className: "h-5 w-5", "aria-hidden": "true" })
          }
        )
      ] })
    },
    result.iso3
  )) });
};

// src/geo/countries/components/GeoCountriesSearchBox.tsx
import { jsx as jsx48, jsxs as jsxs40 } from "react/jsx-runtime";
var compareResults4 = (a, b) => a?.iso3.toLowerCase() === b?.iso3.toLowerCase();
var queryDef8 = GeoCountriesSearchBoxQuery_graphql_default;
var GeoCountriesSearchBox = ({
  name,
  onSelected,
  value
}) => {
  const [selected, setSelected] = useState12(value);
  const [searchTerm, setSearchTerm] = useState12("");
  const where = useMemo12(() => {
    if (searchTerm) {
      return {
        isSupported: { eq: true },
        and: [{ name: { startsWith: searchTerm } }]
      };
    } else {
      return { isSupported: { eq: true } };
    }
  }, [searchTerm]);
  const onQueryChangeHandler = useMemo12(
    () => debounce_default((q) => setSearchTerm(q), 500),
    []
  );
  useEffect5(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback27(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  const query = useLazyLoadQuery9(
    queryDef8,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx48(
    Combobox8,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected,
      onChange: onSetSelected,
      by: compareResults4,
      children: /* @__PURE__ */ jsxs40("div", { className: "relative", children: [
        /* @__PURE__ */ jsx48(
          Combobox8.Input,
          {
            className: "focus:border-primary-500 focus:ring-primary-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            placeholder: "Search Countries",
            "aria-label": "Search Countries",
            displayValue: (result) => {
              if (!result) {
                return "";
              }
              return result.name;
            },
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx48(
          Combobox8.Button,
          {
            className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
            "aria-label": "Country Search Box",
            children: /* @__PURE__ */ jsx48(
              ChevronUpDownIcon4,
              {
                className: "h-5 w-5 text-gray-600",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx48(ErrorBoundary12, { FallbackComponent: SearchErrorBoundaryFallback, children: /* @__PURE__ */ jsx48(Suspense22, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx48(
          GeoCountriesSearchOptions,
          {
            searchTerm,
            fragmentRef: query
          }
        ) }) })
      ] })
    }
  );
};

// src/geo/countries/components/GeoCountriesSearchBoxInput.tsx
import { Controller as Controller4 } from "react-hook-form";
import { jsx as jsx49 } from "react/jsx-runtime";
var GeoCountriesSearchBoxInput = ({
  name,
  control,
  onSelected
}) => {
  return /* @__PURE__ */ jsx49(
    Controller4,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        return /* @__PURE__ */ jsx49(
          GeoCountriesSearchBox,
          {
            name,
            onSelected: (result) => {
              onControllerChange(result);
              if (onSelected) {
                onSelected(result);
              }
            },
            value: value ?? null
          }
        );
      }
    }
  );
};

// src/geo/countries/components/GeoCountriesSearchContainer.tsx
import { useCallback as useCallback28, useState as useState13 } from "react";
import { jsx as jsx50 } from "react/jsx-runtime";
var GeoCountriesSearchContainer = ({
  name,
  value,
  onSearchCompleted
}) => {
  const [selectedResult, setSelectedResult] = useState13();
  const onSetSelected = useCallback28(
    (r) => {
      setSelectedResult(r);
      onSearchCompleted(r);
    },
    [selectedResult]
  );
  return /* @__PURE__ */ jsx50("div", { children: /* @__PURE__ */ jsx50(
    GeoCountriesSearchBox,
    {
      name: name || "geo-countries-search",
      value,
      onSelected: onSetSelected
    }
  ) });
};

// src/geo/locations/components/GeoLocationsEditor.tsx
import { useCallback as useCallback32, useEffect as useEffect10, useState as useState16 } from "react";

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
import { jsxs as jsxs41, jsx as jsx51 } from "react/jsx-runtime";
import { forwardRef, useContext as useContext3 } from "react";

// ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
import { createContext } from "react";
var MotionConfigContext = createContext({
  transformPagePoint: (p) => p,
  isStatic: false,
  reducedMotion: "never"
});

// ../../node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
import { createContext as createContext2 } from "react";
var MotionContext = createContext2({});

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
import { useContext, useRef, useInsertionEffect, useEffect as useEffect7 } from "react";

// ../../node_modules/framer-motion/dist/es/context/PresenceContext.mjs
import { createContext as createContext3 } from "react";
var PresenceContext = createContext3(null);

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
import { useLayoutEffect, useEffect as useEffect6 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-browser.mjs
var isBrowser = typeof document !== "undefined";

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect6;

// ../../node_modules/framer-motion/dist/es/context/LazyContext.mjs
import { createContext as createContext4 } from "react";
var LazyContext = createContext4({ strict: false });

// ../../node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.mjs
var camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

// ../../node_modules/framer-motion/dist/es/animation/optimized-appear/data-id.mjs
var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

// ../../node_modules/framer-motion/dist/es/utils/GlobalConfig.mjs
var MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};

// ../../node_modules/framer-motion/dist/es/frameloop/render-step.mjs
var Queue = class {
  constructor() {
    this.order = [];
    this.scheduled = /* @__PURE__ */ new Set();
  }
  add(process2) {
    if (!this.scheduled.has(process2)) {
      this.scheduled.add(process2);
      this.order.push(process2);
      return true;
    }
  }
  remove(process2) {
    const index2 = this.order.indexOf(process2);
    if (index2 !== -1) {
      this.order.splice(index2, 1);
      this.scheduled.delete(process2);
    }
  }
  clear() {
    this.order.length = 0;
    this.scheduled.clear();
  }
};
function createRenderStep(runNextFrame) {
  let thisFrame = new Queue();
  let nextFrame = new Queue();
  let numToRun = 0;
  let isProcessing = false;
  let flushNextFrame = false;
  const toKeepAlive = /* @__PURE__ */ new WeakSet();
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = false, immediate = false) => {
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.remove(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      nextFrame.clear();
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (let i = 0; i < numToRun; i++) {
          const callback = thisFrame.order[i];
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
          callback(frameData2);
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData2);
      }
    }
  };
  return step;
}

// ../../node_modules/framer-motion/dist/es/frameloop/batcher.mjs
var stepsOrder = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  const steps2 = stepsOrder.reduce((acc, key2) => {
    acc[key2] = createRenderStep(() => runNextFrame = true);
    return acc;
  }, {});
  const processStep = (stepId) => {
    steps2[stepId].process(state);
  };
  const processBatch = () => {
    const timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key2) => {
    const step = steps2[key2];
    acc[key2] = (process2, keepAlive = false, immediate = false) => {
      if (!runNextFrame)
        wake();
      return step.schedule(process2, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = (process2) => stepsOrder.forEach((key2) => steps2[key2].cancel(process2));
  return { schedule, cancel, state, steps: steps2 };
}

// ../../node_modules/framer-motion/dist/es/frameloop/microtask.mjs
var { schedule: microtask, cancel: cancelMicrotask } = createRenderBatcher(queueMicrotask, false);

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
function useVisualElement(Component2, visualState, props, createVisualElement) {
  const { visualElement: parent } = useContext(MotionContext);
  const lazyContext = useContext(LazyContext);
  const presenceContext = useContext(PresenceContext);
  const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  useInsertionEffect(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement)
      return;
    microtask.postRender(visualElement.render);
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect7(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
import { useCallback as useCallback29 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function isRefObject(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback29(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance);
      if (visualElement) {
        instance ? visualElement.mount(instance) : visualElement.unmount();
      }
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(instance);
        } else if (isRefObject(externalRef)) {
          externalRef.current = instance;
        }
      }
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
import { useContext as useContext2, useMemo as useMemo13 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/is-variant-label.mjs
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
function isAnimationControls(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}

// ../../node_modules/framer-motion/dist/es/render/utils/variant-props.mjs
var variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
];
var variantProps = ["initial", ...variantPriorityOrder];

// ../../node_modules/framer-motion/dist/es/render/utils/is-controlling-variants.mjs
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate) ? animate : void 0
    };
  }
  return props.inherit !== false ? context : {};
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext2(MotionContext));
  return useMemo13(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

// ../../node_modules/framer-motion/dist/es/motion/features/definitions.mjs
var featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
for (const key2 in featureProps) {
  featureDefinitions[key2] = {
    isEnabled: (props) => featureProps[key2].some((name) => !!props[name])
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/load-features.mjs
function loadFeatures(features) {
  for (const key2 in features) {
    featureDefinitions[key2] = {
      ...featureDefinitions[key2],
      ...features[key2]
    };
  }
}

// ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
import { createContext as createContext5 } from "react";
var LayoutGroupContext = createContext5({});

// ../../node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs
import { createContext as createContext6 } from "react";
var SwitchLayoutGroupContext = createContext6({});

// ../../node_modules/framer-motion/dist/es/motion/utils/symbol.mjs
var motionComponentSymbol = Symbol.for("motionComponentSymbol");

// ../../node_modules/framer-motion/dist/es/motion/index.mjs
function createMotionComponent({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component2 }) {
  preloadedFeatures2 && loadFeatures(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = {
      ...useContext3(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    };
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component2, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext3(SwitchLayoutGroupContext);
      const isStrict = useContext3(LazyContext).strict;
      if (context.visualElement) {
        MeasureLayout2 = context.visualElement.loadFeatures(
          // Note: Pass the full new combined props to correctly re-render dynamic feature components.
          configAndProps,
          isStrict,
          preloadedFeatures2,
          initialLayoutGroupConfig
        );
      }
    }
    return jsxs41(MotionContext.Provider, { value: context, children: [MeasureLayout2 && context.visualElement ? jsx51(MeasureLayout2, { visualElement: context.visualElement, ...configAndProps }) : null, useRender(Component2, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)] });
  }
  const ForwardRefComponent = forwardRef(MotionComponent);
  ForwardRefComponent[motionComponentSymbol] = Component2;
  return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext3(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}

// ../../node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs
function createMotionProxy(createConfig) {
  function custom(Component2, customMotionComponentConfig = {}) {
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  if (typeof Proxy === "undefined") {
    return custom;
  }
  const componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key2) => {
      if (!componentCache.has(key2)) {
        componentCache.set(key2, custom(key2));
      }
      return componentCache.get(key2);
    }
  });
}

// ../../node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs
function isSVGComponent(Component2) {
  if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 !== "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-")
  ) {
    return false;
  } else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component2) > -1 || /**
     * If it contains a capital letter, it's an SVG component
     */
    /[A-Z]/u.test(Component2)
  ) {
    return true;
  }
  return false;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
import { Fragment as Fragment10, useMemo as useMemo16, createElement } from "react";

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
import { useMemo as useMemo14 } from "react";

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/transform.mjs
var transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
];
var transformProps = new Set(transformPropOrder);

// ../../node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.mjs
function isForcedMotionValue(key2, { layout: layout2, layoutId }) {
  return transformProps.has(key2) || key2.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors[key2] || key2 === "opacity");
}

// ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var isMotionValue = (value) => Boolean(value && value.getVelocity);

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-transform.mjs
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = transformPropOrder.length;
function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true }, transformIsDefault, transformTemplate) {
  let transformString = "";
  for (let i = 0; i < numTransforms; i++) {
    const key2 = transformPropOrder[i];
    if (transform[key2] !== void 0) {
      const transformName = translateAlias[key2] || key2;
      transformString += `${transformName}(${transform[key2]}) `;
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.mjs
var checkStringStartsWith = (token) => (key2) => typeof key2 === "string" && key2.startsWith(token);
var isCSSVariableName = checkStringStartsWith("--");
var startsAsVariableToken = checkStringStartsWith("var(--");
var isCSSVariableToken = (value) => {
  const startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken)
    return false;
  return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.mjs
var getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};

// ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = (min, max, v) => {
  if (v > max)
    return max;
  if (v < min)
    return min;
  return v;
};

// ../../node_modules/framer-motion/dist/es/value/types/numbers/index.mjs
var number3 = {
  test: (v) => typeof v === "number",
  parse: parseFloat,
  transform: (v) => v
};
var alpha = {
  ...number3,
  transform: (v) => clamp(0, 1, v)
};
var scale = {
  ...number3,
  default: 1
};

// ../../node_modules/framer-motion/dist/es/value/types/utils.mjs
var sanitize = (v) => Math.round(v * 1e5) / 1e5;
var floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
var colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
var singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function isString(v) {
  return typeof v === "string";
}

// ../../node_modules/framer-motion/dist/es/value/types/numbers/units.mjs
var createUnitType = (unit) => ({
  test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit}`
});
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-int.mjs
var int = {
  ...number3,
  transform: Math.round
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/number.mjs
var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  backgroundPositionX: px,
  backgroundPositionY: px,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-styles.mjs
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  const { style, vars, transform, transformOrigin } = state;
  let hasTransform2 = false;
  let hasTransformOrigin = false;
  let transformIsNone = true;
  for (const key2 in latestValues) {
    const value = latestValues[key2];
    if (isCSSVariableName(key2)) {
      vars[key2] = value;
      continue;
    }
    const valueType = numberValueTypes[key2];
    const valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(key2)) {
      hasTransform2 = true;
      transform[key2] = valueAsType;
      if (!transformIsNone)
        continue;
      if (value !== (valueType.default || 0))
        transformIsNone = false;
    } else if (key2.startsWith("origin")) {
      hasTransformOrigin = true;
      transformOrigin[key2] = valueAsType;
    } else {
      style[key2] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform2 || transformTemplate) {
      style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
    } else if (style.transform) {
      style.transform = "none";
    }
  }
  if (hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
    style.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
var createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});

// ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs
function copyRawValuesOnly(target, source, props) {
  for (const key2 in source) {
    if (!isMotionValue(source[key2]) && !isForcedMotionValue(key2, props)) {
      target[key2] = source[key2];
    }
  }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
  return useMemo14(() => {
    const state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  const styleProp = props.style || {};
  const style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  return style;
}
function useHTMLProps(props, visualState, isStatic) {
  const htmlProps = {};
  const style = useStyle(props, visualState, isStatic);
  if (props.drag && props.dragListener !== false) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
  }
  if (props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style;
  return htmlProps;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(key2) {
  return key2.startsWith("while") || key2.startsWith("drag") && key2 !== "draggable" || key2.startsWith("layout") || key2.startsWith("onTap") || key2.startsWith("onPan") || key2.startsWith("onLayout") || validMotionProps.has(key2);
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/filter-props.mjs
var shouldForward = (key2) => !isValidMotionProp(key2);
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp)
    return;
  shouldForward = (key2) => key2.startsWith("on") ? !isValidMotionProp(key2) : isValidProp(key2);
}
try {
  loadExternalIsValidProp(__require("@emotion/is-prop-valid").default);
} catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key2 in props) {
    if (key2 === "values" && typeof props.values === "object")
      continue;
    if (shouldForward(key2) || forwardMotionProps === true && isValidMotionProp(key2) || !isDom && !isValidMotionProp(key2) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key2.startsWith("onDrag")) {
      filteredProps[key2] = props[key2];
    }
  }
  return filteredProps;
}

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
import { useMemo as useMemo15 } from "react";

// ../../node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.mjs
function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/path.mjs
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
  attrs.pathLength = 1;
  const keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = px.transform(-offset);
  const pathLength = px.transform(length);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.mjs
function buildSVGAttrs(state, {
  attrX,
  attrY,
  attrScale,
  originX,
  originY,
  pathLength,
  pathSpacing = 1,
  pathOffset = 0,
  // This is object creation, which we try to avoid per-frame.
  ...latest
}, options, isSVGTag2, transformTemplate) {
  buildHTMLStyles(state, latest, options, transformTemplate);
  if (isSVGTag2) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const { attrs, style, dimensions } = state;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (attrScale !== void 0)
    attrs.scale = attrScale;
  if (pathLength !== void 0) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs
var createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
});

// ../../node_modules/framer-motion/dist/es/render/svg/utils/is-svg-tag.mjs
var isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs
function useSVGProps(props, visualState, _isStatic, Component2) {
  const visualProps = useMemo15(() => {
    const state = createSvgRenderState();
    buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component2), props.transformTemplate);
    return {
      ...state.attrs,
      style: { ...state.style }
    };
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = { ...rawStyles, ...visualProps.style };
  }
  return visualProps;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs
function createUseRender(forwardMotionProps = false) {
  const useRender = (Component2, props, ref, { latestValues }, isStatic) => {
    const useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component2);
    const filteredProps = filterProps(props, typeof Component2 === "string", forwardMotionProps);
    const elementProps = Component2 !== Fragment10 ? { ...filteredProps, ...visualProps, ref } : {};
    const { children } = props;
    const renderedChildren = useMemo16(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement(Component2, {
      ...elementProps,
      children: renderedChildren
    });
  };
  return useRender;
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/render.mjs
function renderHTML(element, { style, vars }, styleProp, projection) {
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  for (const key2 in vars) {
    element.style.setProperty(key2, vars[key2]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.mjs
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);

// ../../node_modules/framer-motion/dist/es/render/svg/utils/render.mjs
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, void 0, projection);
  for (const key2 in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key2) ? camelToDash(key2) : key2, renderState.attrs[key2]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  var _a;
  const { style } = props;
  const newValues = {};
  for (const key2 in style) {
    if (isMotionValue(style[key2]) || prevProps.style && isMotionValue(prevProps.style[key2]) || isForcedMotionValue(key2, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key2)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== void 0) {
      newValues[key2] = style[key2];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.mjs
function scrapeMotionValuesFromProps2(props, prevProps, visualElement) {
  const newValues = scrapeMotionValuesFromProps(props, prevProps, visualElement);
  for (const key2 in props) {
    if (isMotionValue(props[key2]) || isMotionValue(prevProps[key2])) {
      const targetKey = transformPropOrder.indexOf(key2) !== -1 ? "attr" + key2.charAt(0).toUpperCase() + key2.substring(1) : key2;
      newValues[targetKey] = props[key2];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
import { useContext as useContext4 } from "react";

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-variants.mjs
function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  if (typeof definition === "function") {
    definition = definition(custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}

// ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
import { useRef as useRef2 } from "react";
function useConstant(init) {
  const ref = useRef2(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.mjs
var isKeyframesTarget = (v) => {
  return Array.isArray(v);
};

// ../../node_modules/framer-motion/dist/es/utils/resolve-value.mjs
var isCustomValue = (v) => {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = (v) => {
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

// ../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
function makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps3, createRenderState, onMount }, props, context, presenceContext) {
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps3),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = (instance) => onMount(props, instance, state);
  }
  return state;
}
var makeUseVisualState = (config) => (props, isStatic) => {
  const context = useContext4(MotionContext);
  const presenceContext = useContext4(PresenceContext);
  const make = () => makeState(config, props, context, presenceContext);
  return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  const values = {};
  const motionValues = scrapeMotionValues(props, {});
  for (const key2 in motionValues) {
    values[key2] = resolveMotionValue(motionValues[key2]);
  }
  let { initial, animate } = props;
  const isControllingVariants$1 = isControllingVariants(props);
  const isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === void 0)
      initial = context.initial;
    if (animate === void 0)
      animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach((definition) => {
      const resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      const { transitionEnd, transition, ...target } = resolved;
      for (const key2 in target) {
        let valueTarget = target[key2];
        if (Array.isArray(valueTarget)) {
          const index2 = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index2];
        }
        if (valueTarget !== null) {
          values[key2] = valueTarget;
        }
      }
      for (const key2 in transitionEnd)
        values[key2] = transitionEnd[key2];
    });
  }
  return values;
}

// ../../node_modules/framer-motion/dist/es/utils/noop.mjs
var noop = (any) => any;

// ../../node_modules/framer-motion/dist/es/frameloop/frame.mjs
var { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);

// ../../node_modules/framer-motion/dist/es/render/svg/config-motion.mjs
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2,
    createRenderState: createSvgRenderState,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch (e) {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      });
      frame.render(() => {
        buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
        renderSVG(instance, renderState);
      });
    }
  })
};

// ../../node_modules/framer-motion/dist/es/render/html/config-motion.mjs
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createHtmlRenderState
  })
};

// ../../node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs
function createDomMotionConfig(Component2, { forwardMotionProps = false }, preloadedFeatures2, createVisualElement) {
  const baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
  return {
    ...baseConfig,
    preloadedFeatures: preloadedFeatures2,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement,
    Component: Component2
  };
}

// ../../node_modules/framer-motion/dist/es/events/add-dom-event.mjs
function addDomEvent(target, eventName, handler, options = { passive: true }) {
  target.addEventListener(eventName, handler, options);
  return () => target.removeEventListener(eventName, handler);
}

// ../../node_modules/framer-motion/dist/es/events/utils/is-primary-pointer.mjs
var isPrimaryPointer = (event) => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    return event.isPrimary !== false;
  }
};

// ../../node_modules/framer-motion/dist/es/events/event-info.mjs
function extractEventInfo(event, pointType = "page") {
  return {
    point: {
      x: event[`${pointType}X`],
      y: event[`${pointType}Y`]
    }
  };
}
var addPointerInfo = (handler) => {
  return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

// ../../node_modules/framer-motion/dist/es/events/add-pointer-event.mjs
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

// ../../node_modules/framer-motion/dist/es/utils/pipe.mjs
var combineFunctions = (a, b) => (v) => b(a(v));
var pipe = (...transformers) => transformers.reduce(combineFunctions);

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/lock.mjs
function createLock(name) {
  let lock = null;
  return () => {
    const openLock = () => {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  let lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    const openHorizontal = globalHorizontalLock();
    const openVertical = globalVerticalLock();
    if (openHorizontal && openVertical) {
      lock = () => {
        openHorizontal();
        openVertical();
      };
    } else {
      if (openHorizontal)
        openHorizontal();
      if (openVertical)
        openVertical();
    }
  }
  return lock;
}
function isDragActive() {
  const openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}

// ../../node_modules/framer-motion/dist/es/motion/features/Feature.mjs
var Feature = class {
  constructor(node38) {
    this.isMounted = false;
    this.node = node38;
  }
  update() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/hover.mjs
function addHoverEvent(node38, isActive) {
  const eventName = isActive ? "pointerenter" : "pointerleave";
  const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
  const handleEvent = (event, info) => {
    if (event.pointerType === "touch" || isDragActive())
      return;
    const props = node38.getProps();
    if (node38.animationState && props.whileHover) {
      node38.animationState.setActive("whileHover", isActive);
    }
    const callback = props[callbackName];
    if (callback)
      callback(event, info);
  };
  return addPointerEvent(node38.current, eventName, handleEvent, {
    passive: !node38.getProps()[callbackName]
  });
}
var HoverGesture = class extends Feature {
  mount() {
    this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/focus.mjs
var FocusGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible = false;
    try {
      isFocusVisible = this.node.current.matches(":focus-visible");
    } catch (e) {
      isFocusVisible = true;
    }
    if (!isFocusVisible || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState)
      return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.mjs
var isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/press.mjs
function fireSyntheticPointerEvent(name, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
var PressGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removeStartListeners = noop;
    this.removeEndListeners = noop;
    this.removeAccessibleListeners = noop;
    this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps();
      const endPointerPress = (endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        !globalTapTarget && !isNodeOrChild(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
      };
      const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, {
        passive: !(props.onTap || props["onPointerUp"])
      });
      const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), {
        passive: !(props.onTapCancel || props["onPointerCancel"])
      });
      this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
      this.startPress(startEvent, startInfo);
    };
    this.startAccessiblePress = () => {
      const handleKeydown = (keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = (keyupEvent) => {
          if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
            return;
          fireSyntheticPointerEvent("up", (event, info) => {
            const { onTap } = this.node.getProps();
            if (onTap)
              onTap(event, info);
          });
        };
        this.removeEndListeners();
        this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
        fireSyntheticPointerEvent("down", (event, info) => {
          this.startPress(event, info);
        });
      };
      const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
      const handleBlur = () => {
        if (!this.isPressing)
          return;
        fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      };
      const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
      this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = true;
    const { onTapStart, whileTap } = this.node.getProps();
    if (whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", true);
    }
    if (onTapStart) {
      onTapStart(event, info);
    }
  }
  checkPressEnd() {
    this.removeEndListeners();
    this.isPressing = false;
    const props = this.node.getProps();
    if (props.whileTap && this.node.animationState) {
      this.node.animationState.setActive("whileTap", false);
    }
    return !isDragActive();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    if (onTapCancel)
      onTapCancel(event, info);
  }
  mount() {
    const props = this.node.getProps();
    const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(props.onTapStart || props["onPointerStart"])
    });
    const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners();
    this.removeEndListeners();
    this.removeAccessibleListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/observers.mjs
var observerCallbacks = /* @__PURE__ */ new WeakMap();
var observers = /* @__PURE__ */ new WeakMap();
var fireObserverCallback = (entry) => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
var fireAllObserverCallbacks = (entries) => {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root: root2, ...options }) {
  const lookupRoot = root2 || document;
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  const rootObservers = observers.get(lookupRoot);
  const key2 = JSON.stringify(options);
  if (!rootObservers[key2]) {
    rootObservers[key2] = new IntersectionObserver(fireAllObserverCallbacks, { root: root2, ...options });
  }
  return rootObservers[key2];
}
function observeIntersection(element, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/viewport/index.mjs
var thresholdNames = {
  some: 0,
  all: 1
};
var InViewFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const { viewport = {} } = this.node.getProps();
    const { root: root2, margin: rootMargin, amount = "some", once } = viewport;
    const options = {
      root: root2 ? root2.current : void 0,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    const onIntersectionUpdate = (entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting)
        return;
      this.isInView = isIntersecting;
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      const { onViewportEnter, onViewportLeave } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined")
      return;
    const { props, prevProps } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {
  }
};
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
  return (name) => viewport[name] !== prevViewport[name];
}

// ../../node_modules/framer-motion/dist/es/motion/features/gestures.mjs
var gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};

// ../../node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  const prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (let i = 0; i < prevLength; i++) {
    if (prev[i] !== next[i])
      return false;
  }
  return true;
}

// ../../node_modules/framer-motion/dist/es/render/utils/resolve-dynamic-variants.mjs
function getCurrent(visualElement) {
  const current = {};
  visualElement.values.forEach((value, key2) => current[key2] = value.get());
  return current;
}
function getVelocity(visualElement) {
  const velocity = {};
  visualElement.values.forEach((value, key2) => velocity[key2] = value.getVelocity());
  return velocity;
}
function resolveVariant(visualElement, definition, custom) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}

// ../../node_modules/framer-motion/dist/es/utils/time-conversion.mjs
var secondsToMilliseconds = (seconds) => seconds * 1e3;
var millisecondsToSeconds = (milliseconds) => milliseconds / 1e3;

// ../../node_modules/framer-motion/dist/es/animation/utils/default-transitions.mjs
var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
var criticallyDampedSpring = (target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
var getDefaultTransition = (valueKey, { keyframes: keyframes2 }) => {
  if (keyframes2.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring;
  }
  return ease;
};

// ../../node_modules/framer-motion/dist/es/animation/utils/transitions.mjs
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key2) {
  return transition[key2] || transition["default"] || transition;
}

// ../../node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
var instantAnimationState = {
  current: false
};

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
var isNotNull5 = (value) => value !== null;
function getFinalKeyframe(keyframes2, { repeat, repeatType = "loop" }, finalKeyframe) {
  const resolvedKeyframes = keyframes2.filter(isNotNull5);
  const index2 = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index2 || finalKeyframe === void 0 ? resolvedKeyframes[index2] : finalKeyframe;
}

// ../../node_modules/framer-motion/dist/es/frameloop/sync-time.mjs
var now2;
function clearTime() {
  now2 = void 0;
}
var time = {
  now: () => {
    if (now2 === void 0) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now2;
  },
  set: (newTime) => {
    now2 = newTime;
    queueMicrotask(clearTime);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/is-zero-value-string.mjs
var isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);

// ../../node_modules/framer-motion/dist/es/animation/utils/is-none.mjs
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  } else {
    return true;
  }
}

// ../../node_modules/framer-motion/dist/es/utils/errors.mjs
var warning = noop;
var invariant = noop;
if (process.env.NODE_ENV !== "production") {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/framer-motion/dist/es/utils/is-numerical-string.mjs
var isNumericalString = (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

// ../../node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.mjs
var splitCSSVariableRegex = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function parseCSSVariable(current) {
  const match = splitCSSVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token1, token2, fallback] = match;
  return [`--${token1 !== null && token1 !== void 0 ? token1 : token2}`, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
  invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token, fallback] = parseCSSVariable(current);
  if (!token)
    return;
  const resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  }
  return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.mjs
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]);
var isNumOrPxType = (v) => v === number3 || v === px;
var getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
var getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
  if (transform === "none" || !transform)
    return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/u);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter((key2) => !transformKeys.has(key2));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach((key2) => {
    const value = visualElement.getValue(key2);
    if (value !== void 0) {
      removedTransforms.push([key2, value.get()]);
      value.set(key2.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
  height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
  top: (_bbox, { top }) => parseFloat(top),
  left: (_bbox, { left }) => parseFloat(left),
  bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
  right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/test.mjs
var testValueType = (v) => (type) => type.test(v);

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.mjs
var auto = {
  test: (v) => v === "auto",
  parse: (v) => v
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.mjs
var dimensionValueTypes = [number3, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

// ../../node_modules/framer-motion/dist/es/render/utils/KeyframesResolver.mjs
var toResolve = /* @__PURE__ */ new Set();
var isScheduled = false;
var anyNeedsMeasurement = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
    const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
    const transformsToRestore = /* @__PURE__ */ new Map();
    elementsToMeasure.forEach((element) => {
      const removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length)
        return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
    elementsToMeasure.forEach((element) => {
      element.render();
      const restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(([key2, value]) => {
          var _a;
          (_a = element.getValue(key2)) === null || _a === void 0 ? void 0 : _a.set(value);
        });
      }
    });
    resolversToMeasure.forEach((resolver) => resolver.measureEndState());
    resolversToMeasure.forEach((resolver) => {
      if (resolver.suspendedScrollY !== void 0) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach((resolver) => resolver.complete());
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach((resolver) => {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  readAllKeyframes();
  measureAllKeyframes();
}
var KeyframeResolver = class {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2, element, isAsync = false) {
    this.isComplete = false;
    this.isAsync = false;
    this.needsMeasurement = false;
    this.isScheduled = false;
    this.unresolvedKeyframes = [...unresolvedKeyframes];
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue2;
    this.element = element;
    this.isAsync = isAsync;
  }
  scheduleResolve() {
    this.isScheduled = true;
    if (this.isAsync) {
      toResolve.add(this);
      if (!isScheduled) {
        isScheduled = true;
        frame.read(readAllKeyframes);
        frame.resolveKeyframes(measureAllKeyframes);
      }
    } else {
      this.readKeyframes();
      this.complete();
    }
  }
  readKeyframes() {
    const { unresolvedKeyframes, name, element, motionValue: motionValue2 } = this;
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (unresolvedKeyframes[i] === null) {
        if (i === 0) {
          const currentValue = motionValue2 === null || motionValue2 === void 0 ? void 0 : motionValue2.get();
          const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
          if (currentValue !== void 0) {
            unresolvedKeyframes[0] = currentValue;
          } else if (element && name) {
            const valueAsRead = element.readValue(name, finalKeyframe);
            if (valueAsRead !== void 0 && valueAsRead !== null) {
              unresolvedKeyframes[0] = valueAsRead;
            }
          }
          if (unresolvedKeyframes[0] === void 0) {
            unresolvedKeyframes[0] = finalKeyframe;
          }
          if (motionValue2 && currentValue === void 0) {
            motionValue2.set(unresolvedKeyframes[0]);
          }
        } else {
          unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
      }
    }
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = true;
    this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
    toResolve.delete(this);
  }
  cancel() {
    if (!this.isComplete) {
      this.isScheduled = false;
      toResolve.delete(this);
    }
  }
  resume() {
    if (!this.isComplete)
      this.scheduleResolve();
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/color/utils.mjs
var isColorString = (type, testProp) => (v) => {
  return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
};
var splitColor = (aName, bName, cName) => (v) => {
  if (!isString(v))
    return v;
  const [a, b, c, alpha2] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c),
    alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
  };
};

// ../../node_modules/framer-motion/dist/es/value/types/color/rgba.mjs
var clampRgbUnit = (v) => clamp(0, 255, v);
var rgbUnit = {
  ...number3,
  transform: (v) => Math.round(clampRgbUnit(v))
};
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hex.mjs
function parseHex(v) {
  let r = "";
  let g = "";
  let b = "";
  let a = "";
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};

// ../../node_modules/framer-motion/dist/es/value/types/color/hsla.mjs
var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/color/index.mjs
var color = {
  test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: (v) => {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: (v) => {
    return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/index.mjs
function test(v) {
  var _a, _b;
  return isNaN(v) && isString(v) && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var NUMBER_TOKEN = "number";
var COLOR_TOKEN = "color";
var VAR_TOKEN = "var";
var VAR_FUNCTION_TOKEN = "var(";
var SPLIT_TOKEN = "${}";
var complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const values = [];
  const indexes = {
    color: [],
    number: [],
    var: []
  };
  const types = [];
  let i = 0;
  const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types.push(COLOR_TOKEN);
      values.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types.push(VAR_TOKEN);
      values.push(parsedValue);
    } else {
      indexes.number.push(i);
      types.push(NUMBER_TOKEN);
      values.push(parseFloat(parsedValue));
    }
    ++i;
    return SPLIT_TOKEN;
  });
  const split = tokenised.split(SPLIT_TOKEN);
  return { values, split, indexes, types };
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  const { split, types } = analyseComplexValue(source);
  const numSections = split.length;
  return (v) => {
    let output = "";
    for (let i = 0; i < numSections; i++) {
      output += split[i];
      if (v[i] !== void 0) {
        const type = types[i];
        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }
    return output;
  };
}
var convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
  const parsed = parseComplexValue(v);
  const transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone
};

// ../../node_modules/framer-motion/dist/es/value/types/complex/filter.mjs
var maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [name, value] = v.slice(0, -1).split("(");
  if (name === "drop-shadow")
    return v;
  const [number4] = value.match(floatRegex) || [];
  if (!number4)
    return v;
  const unit = value.replace(number4, "");
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number4 !== value)
    defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /\b([a-z-]*)\(.*?\)/gu;
var filter = {
  ...complex,
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/defaults.mjs
var defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
};
var getDefaultValueType = (key2) => defaultValueTypes[key2];

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.mjs
function getAnimatableNone2(key2, value) {
  let defaultValueType = getDefaultValueType(key2);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/make-none-animatable.mjs
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
  let i = 0;
  let animatableTemplate = void 0;
  while (i < unresolvedKeyframes.length && !animatableTemplate) {
    if (typeof unresolvedKeyframes[i] === "string" && unresolvedKeyframes[i] !== "none" && unresolvedKeyframes[i] !== "0") {
      animatableTemplate = unresolvedKeyframes[i];
    }
    i++;
  }
  if (animatableTemplate && name) {
    for (const noneIndex of noneKeyframeIndexes) {
      unresolvedKeyframes[noneIndex] = getAnimatableNone2(name, animatableTemplate);
    }
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/DOMKeyframesResolver.mjs
var DOMKeyframesResolver = class extends KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue2) {
    super(unresolvedKeyframes, onComplete, name, motionValue2, motionValue2 === null || motionValue2 === void 0 ? void 0 : motionValue2.owner, true);
  }
  readKeyframes() {
    const { unresolvedKeyframes, element, name } = this;
    if (!element.current)
      return;
    super.readKeyframes();
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      const keyframe = unresolvedKeyframes[i];
      if (typeof keyframe === "string" && isCSSVariableToken(keyframe)) {
        const resolved = getVariableValue(keyframe, element.current);
        if (resolved !== void 0) {
          unresolvedKeyframes[i] = resolved;
        }
        if (i === unresolvedKeyframes.length - 1) {
          this.finalKeyframe = keyframe;
        }
      }
    }
    if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
      return this.resolveNoneKeyframes();
    }
    const [origin, target] = unresolvedKeyframes;
    const originType = findDimensionValueType(origin);
    const targetType = findDimensionValueType(target);
    if (originType === targetType)
      return;
    if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
      for (let i = 0; i < unresolvedKeyframes.length; i++) {
        const value = unresolvedKeyframes[i];
        if (typeof value === "string") {
          unresolvedKeyframes[i] = parseFloat(value);
        }
      }
    } else {
      this.needsMeasurement = true;
    }
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes, name } = this;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (isNone(unresolvedKeyframes[i])) {
        noneKeyframeIndexes.push(i);
      }
    }
    if (noneKeyframeIndexes.length) {
      makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
  }
  measureInitialState() {
    const { element, unresolvedKeyframes, name } = this;
    if (!element.current)
      return;
    if (name === "height") {
      this.suspendedScrollY = window.pageYOffset;
    }
    this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    unresolvedKeyframes[0] = this.measuredOrigin;
    const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
    if (measureKeyframe !== void 0) {
      element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
  }
  measureEndState() {
    var _a;
    const { element, name, unresolvedKeyframes } = this;
    if (!element.current)
      return;
    const value = element.getValue(name);
    value && value.jump(this.measuredOrigin, false);
    const finalKeyframeIndex = unresolvedKeyframes.length - 1;
    const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
    unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    if (finalKeyframe !== null && this.finalKeyframe === void 0) {
      this.finalKeyframe = finalKeyframe;
    }
    if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
      this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
        element.getValue(unsetTransformName).set(unsetTransformValue);
      });
    }
    this.resolveNoneKeyframes();
  }
};

// ../../node_modules/framer-motion/dist/es/utils/memo.mjs
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animatable.mjs
var isAnimatable = (value, name) => {
  if (name === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && // It's animatable if we have a string
  (complex.test(value) || value === "0") && // And it contains numbers and/or colors
  !value.startsWith("url(")) {
    return true;
  }
  return false;
};

// ../../node_modules/framer-motion/dist/es/animation/animators/utils/can-animate.mjs
function hasKeyframesChanged(keyframes2) {
  const current = keyframes2[0];
  if (keyframes2.length === 1)
    return true;
  for (let i = 0; i < keyframes2.length; i++) {
    if (keyframes2[i] !== current)
      return true;
  }
}
function canAnimate(keyframes2, name, type, velocity) {
  const originKeyframe = keyframes2[0];
  if (originKeyframe === null)
    return false;
  const targetKeyframe = keyframes2[keyframes2.length - 1];
  const isOriginAnimatable = isAnimatable(originKeyframe, name);
  const isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }
  return hasKeyframesChanged(keyframes2) || type === "spring" && velocity;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/BaseAnimation.mjs
var BaseAnimation = class {
  constructor({ autoplay = true, delay: delay2 = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", ...options }) {
    this.isStopped = false;
    this.hasAttemptedResolve = false;
    this.options = {
      autoplay,
      delay: delay2,
      type,
      repeat,
      repeatDelay,
      repeatType,
      ...options
    };
    this.updateFinishedPromise();
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    if (!this._resolved && !this.hasAttemptedResolve) {
      flushKeyframeResolvers();
    }
    return this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(keyframes2, finalKeyframe) {
    this.hasAttemptedResolve = true;
    const { name, type, velocity, delay: delay2, onComplete, onUpdate, isGenerator } = this.options;
    if (!isGenerator && !canAnimate(keyframes2, name, type, velocity)) {
      if (instantAnimationState.current || !delay2) {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        this.resolveFinishedPromise();
        return;
      } else {
        this.options.duration = 0;
      }
    }
    const resolvedAnimation = this.initPlayback(keyframes2, finalKeyframe);
    if (resolvedAnimation === false)
      return;
    this._resolved = {
      keyframes: keyframes2,
      finalKeyframe,
      ...resolvedAnimation
    };
    this.onPostResolved();
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((resolve) => {
      this.resolveFinishedPromise = resolve;
    });
  }
};

// ../../node_modules/framer-motion/dist/es/utils/velocity-per-second.mjs
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/velocity.mjs
var velocitySampleDuration = 5;
function calcGeneratorVelocity(resolveValue, t, current) {
  const prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/find.mjs
var safeMin = 1e-3;
var minDuration = 0.01;
var maxDuration = 10;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope;
  let derivative;
  warning(duration <= secondsToMilliseconds(maxDuration), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration = clamp(minDuration, maxDuration, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    envelope = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const a = exponentialDecay - velocity;
      const b = calcAngularFreq(undampedFreq2, dampingRatio);
      const c = Math.exp(-delta);
      return safeMin - a / b * c;
    };
    derivative = (undampedFreq2) => {
      const exponentialDecay = undampedFreq2 * dampingRatio;
      const delta = exponentialDecay * duration;
      const d = delta * velocity + velocity;
      const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
      const f = Math.exp(-delta);
      const g = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e) * f) / g;
    };
  } else {
    envelope = (undampedFreq2) => {
      const a = Math.exp(-undampedFreq2 * duration);
      const b = (undampedFreq2 - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = (undampedFreq2) => {
      const a = Math.exp(-undampedFreq2 * duration);
      const b = (velocity - undampedFreq2) * (duration * duration);
      return a * b;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/spring/index.mjs
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some((key2) => options[key2] !== void 0);
}
function getSpringOptions(options) {
  let springOptions = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: false,
    ...options
  };
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = {
      ...springOptions,
      ...derived,
      mass: 1
    };
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring({ keyframes: keyframes2, restDelta, restSpeed, ...options }) {
  const origin = keyframes2[0];
  const target = keyframes2[keyframes2.length - 1];
  const state = { done: false, value: origin };
  const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
    ...options,
    velocity: -millisecondsToSeconds(options.velocity || 0)
  });
  const initialVelocity = velocity || 0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else if (dampingRatio === 1) {
    resolveSpring = (t) => target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
  } else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = (t) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      const freqForT = Math.min(dampedAngularFreq * t, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: (t) => {
      const current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        let currentVelocity = initialVelocity;
        if (t !== 0) {
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
          } else {
            currentVelocity = 0;
          }
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/generators/inertia.mjs
function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = (v) => min !== void 0 && v < min || max !== void 0 && v > max;
  const nearestBoundary = (v) => {
    if (min === void 0)
      return max;
    if (max === void 0)
      return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - origin;
  const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
  const calcLatest = (t) => target + calcDelta(t);
  const applyFriction = (t) => {
    const delta = calcDelta(t);
    const latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  let timeReachedBoundary;
  let spring$1;
  const checkCatchBoundary = (t) => {
    if (!isOutOfBounds(state.value))
      return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: (t) => {
      let hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === void 0) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      if (timeReachedBoundary !== void 0 && t >= timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}

// ../../node_modules/framer-motion/dist/es/easing/cubic-bezier.mjs
var calcBezier = (t, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t + (3 * a2 - 6 * a1)) * t + 3 * a1) * t;
var subdivisionPrecision = 1e-7;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

// ../../node_modules/framer-motion/dist/es/easing/ease.mjs
var easeIn = cubicBezier(0.42, 0, 1, 1);
var easeOut = cubicBezier(0, 0, 0.58, 1);
var easeInOut = cubicBezier(0.42, 0, 0.58, 1);

// ../../node_modules/framer-motion/dist/es/easing/utils/is-easing-array.mjs
var isEasingArray = (ease2) => {
  return Array.isArray(ease2) && typeof ease2[0] !== "number";
};

// ../../node_modules/framer-motion/dist/es/easing/modifiers/mirror.mjs
var mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// ../../node_modules/framer-motion/dist/es/easing/modifiers/reverse.mjs
var reverseEasing = (easing) => (p) => 1 - easing(1 - p);

// ../../node_modules/framer-motion/dist/es/easing/circ.mjs
var circIn = (p) => 1 - Math.sin(Math.acos(p));
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circIn);

// ../../node_modules/framer-motion/dist/es/easing/back.mjs
var backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = reverseEasing(backOut);
var backInOut = mirrorEasing(backIn);

// ../../node_modules/framer-motion/dist/es/easing/anticipate.mjs
var anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

// ../../node_modules/framer-motion/dist/es/easing/utils/map.mjs
var easingLookup = {
  linear: noop,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
};
var easingDefinitionToFunction = (definition) => {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
    const [x1, y1, x2, y2] = definition;
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    invariant(easingLookup[definition] !== void 0, `Invalid easing type '${definition}'`);
    return easingLookup[definition];
  }
  return definition;
};

// ../../node_modules/framer-motion/dist/es/utils/progress.mjs
var progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/framer-motion/dist/es/utils/mix/number.mjs
var mixNumber = (from, to, progress2) => {
  return from + (to - from) * progress2;
};

// ../../node_modules/framer-motion/dist/es/utils/hsla-to-rgba.mjs
function hueToRgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha2
  };
}

// ../../node_modules/framer-motion/dist/es/utils/mix/color.mjs
var mixLinearColor = (from, to, v) => {
  const fromExpo = from * from;
  const expo = v * (to * to - fromExpo) + fromExpo;
  return expo < 0 ? 0 : Math.sqrt(expo);
};
var colorTypes = [hex, rgba, hsla];
var getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color2) {
  const type = getColorType(color2);
  invariant(Boolean(type), `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  let model = type.parse(color2);
  if (type === hsla) {
    model = hslaToRgba(model);
  }
  return model;
}
var mixColor = (from, to) => {
  const fromRGBA = asRGBA(from);
  const toRGBA = asRGBA(to);
  const blended = { ...fromRGBA };
  return (v) => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mixNumber(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};

// ../../node_modules/framer-motion/dist/es/utils/mix/complex.mjs
function mixImmediate(a, b) {
  return (p) => p > 0 ? b : a;
}
function mixNumber2(a, b) {
  return (p) => mixNumber(a, b, p);
}
function getMixer(a) {
  if (typeof a === "number") {
    return mixNumber2;
  } else if (typeof a === "string") {
    return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
  } else if (Array.isArray(a)) {
    return mixArray;
  } else if (typeof a === "object") {
    return color.test(a) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a, b) {
  const output = [...a];
  const numValues = output.length;
  const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
  return (p) => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a, b) {
  const output = { ...a, ...b };
  const blendValue = {};
  for (const key2 in output) {
    if (a[key2] !== void 0 && b[key2] !== void 0) {
      blendValue[key2] = getMixer(a[key2])(a[key2], b[key2]);
    }
  }
  return (v) => {
    for (const key2 in blendValue) {
      output[key2] = blendValue[key2](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  var _a;
  const orderedOrigin = [];
  const pointers = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < target.values.length; i++) {
    const type = target.types[i];
    const originIndex = origin.indexes[type][pointers[type]];
    const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
var mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
    return mixImmediate(origin, target);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/mix/index.mjs
function mix(from, to, p) {
  if (typeof from === "number" && typeof to === "number" && typeof p === "number") {
    return mixNumber(from, to, p);
  }
  const mixer = getMixer(from);
  return mixer(from, to);
}

// ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs
function createMixers(output, ease2, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || mix;
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i] || noop : ease2;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function interpolate(input, output, { clamp: isClamp = true, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  if (inputLength === 1)
    return () => output[0];
  if (inputLength === 2 && input[0] === input[1])
    return () => output[1];
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease2, mixer);
  const numMixers = mixers.length;
  const interpolator = (v) => {
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1])
          break;
      }
    }
    const progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/fill.mjs
function fillOffset(offset, remaining) {
  const min = offset[offset.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset.push(mixNumber(min, 1, offsetProgress));
  }
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/default.mjs
function defaultOffset(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}

// ../../node_modules/framer-motion/dist/es/utils/offsets/time.mjs
function convertOffsetToTimes(offset, duration) {
  return offset.map((o) => o * duration);
}

// ../../node_modules/framer-motion/dist/es/animation/generators/keyframes.mjs
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2);
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
    duration
  );
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: (t) => {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    }
  };
}

// ../../node_modules/framer-motion/dist/es/animation/generators/utils/calc-duration.mjs
var maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}

// ../../node_modules/framer-motion/dist/es/animation/animators/drivers/driver-frameloop.mjs
var frameloopDriver = (update) => {
  const passTimestamp = ({ timestamp }) => update(timestamp);
  return {
    start: () => frame.update(passTimestamp, true),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time.now()
  };
};

// ../../node_modules/framer-motion/dist/es/animation/animators/MainThreadAnimation.mjs
var generators = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
var percentToProgress = (percent2) => percent2 / 100;
var MainThreadAnimation = class extends BaseAnimation {
  constructor({ KeyframeResolver: KeyframeResolver$1 = KeyframeResolver, ...options }) {
    super(options);
    this.holdTime = null;
    this.startTime = null;
    this.cancelTime = null;
    this.currentTime = 0;
    this.playbackSpeed = 1;
    this.pendingPlayState = "running";
    this.state = "idle";
    const { name, motionValue: motionValue2, keyframes: keyframes2 } = this.options;
    const onResolved = (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    if (name && motionValue2 && motionValue2.owner) {
      this.resolver = motionValue2.owner.resolveKeyframes(keyframes2, onResolved, name, motionValue2);
    } else {
      this.resolver = new KeyframeResolver$1(keyframes2, onResolved, name, motionValue2);
    }
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes$1) {
    const { type = "keyframes", repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = this.options;
    const generatorFactory = generators[type] || keyframes;
    let mapPercentToKeyframes;
    let mirroredGenerator;
    if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
      if (process.env.NODE_ENV !== "production") {
        invariant(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`);
      }
      mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
      keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({ ...this.options, keyframes: keyframes$1 });
    if (repeatType === "mirror") {
      mirroredGenerator = generatorFactory({
        ...this.options,
        keyframes: [...keyframes$1].reverse(),
        velocity: -velocity
      });
    }
    if (generator.calculatedDuration === null) {
      generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const { calculatedDuration } = generator;
    const resolvedDuration = calculatedDuration + repeatDelay;
    const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    return {
      generator,
      mirroredGenerator,
      mapPercentToKeyframes,
      calculatedDuration,
      resolvedDuration,
      totalDuration
    };
  }
  onPostResolved() {
    const { autoplay = true } = this.options;
    this.play();
    if (this.pendingPlayState === "paused" || !autoplay) {
      this.pause();
    } else {
      this.state = this.pendingPlayState;
    }
  }
  tick(timestamp, sample = false) {
    const { resolved } = this;
    if (!resolved) {
      const { keyframes: keyframes3 } = this.options;
      return { done: true, value: keyframes3[keyframes3.length - 1] };
    }
    const { finalKeyframe, generator, mirroredGenerator, mapPercentToKeyframes, keyframes: keyframes2, calculatedDuration, totalDuration, resolvedDuration } = resolved;
    if (this.startTime === null)
      return generator.next(0);
    const { delay: delay2, repeat, repeatType, repeatDelay, onUpdate } = this.options;
    if (this.speed > 0) {
      this.startTime = Math.min(this.startTime, timestamp);
    } else if (this.speed < 0) {
      this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
    }
    if (sample) {
      this.currentTime = timestamp;
    } else if (this.holdTime !== null) {
      this.currentTime = this.holdTime;
    } else {
      this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
    }
    const timeWithoutDelay = this.currentTime - delay2 * (this.speed >= 0 ? 1 : -1);
    const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    this.currentTime = Math.max(timeWithoutDelay, 0);
    if (this.state === "finished" && this.holdTime === null) {
      this.currentTime = totalDuration;
    }
    let elapsed = this.currentTime;
    let frameGenerator = generator;
    if (repeat) {
      const progress2 = Math.min(this.currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: false, value: keyframes2[0] } : frameGenerator.next(elapsed);
    if (mapPercentToKeyframes) {
      state.value = mapPercentToKeyframes(state.value);
    }
    let { done } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
    }
    const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
    if (isAnimationFinished && finalKeyframe !== void 0) {
      state.value = getFinalKeyframe(keyframes2, this.options, finalKeyframe);
    }
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      this.finish();
    }
    return state;
  }
  get duration() {
    const { resolved } = this;
    return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
  }
  get time() {
    return millisecondsToSeconds(this.currentTime);
  }
  set time(newTime) {
    newTime = secondsToMilliseconds(newTime);
    this.currentTime = newTime;
    if (this.holdTime !== null || this.speed === 0) {
      this.holdTime = newTime;
    } else if (this.driver) {
      this.startTime = this.driver.now() - newTime / this.speed;
    }
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(newSpeed) {
    const hasChanged = this.playbackSpeed !== newSpeed;
    this.playbackSpeed = newSpeed;
    if (hasChanged) {
      this.time = millisecondsToSeconds(this.currentTime);
    }
  }
  play() {
    if (!this.resolver.isScheduled) {
      this.resolver.resume();
    }
    if (!this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver = frameloopDriver, onPlay } = this.options;
    if (!this.driver) {
      this.driver = driver((timestamp) => this.tick(timestamp));
    }
    onPlay && onPlay();
    const now3 = this.driver.now();
    if (this.holdTime !== null) {
      this.startTime = now3 - this.holdTime;
    } else if (!this.startTime || this.state === "finished") {
      this.startTime = now3;
    }
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    this.cancelTime = this.startTime;
    this.holdTime = null;
    this.state = "running";
    this.driver.start();
  }
  pause() {
    var _a;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused";
    this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle")
      return;
    this.teardown();
    const { onStop } = this.options;
    onStop && onStop();
  }
  complete() {
    if (this.state !== "running") {
      this.play();
    }
    this.pendingPlayState = this.state = "finished";
    this.holdTime = null;
  }
  finish() {
    this.teardown();
    this.state = "finished";
    const { onComplete } = this.options;
    onComplete && onComplete();
  }
  cancel() {
    if (this.cancelTime !== null) {
      this.tick(this.cancelTime);
    }
    this.teardown();
    this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle";
    this.stopDriver();
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    this.startTime = this.cancelTime = null;
    this.resolver.cancel();
  }
  stopDriver() {
    if (!this.driver)
      return;
    this.driver.stop();
    this.driver = void 0;
  }
  sample(time2) {
    this.startTime = 0;
    return this.tick(time2, true);
  }
};

// ../../node_modules/framer-motion/dist/es/easing/utils/is-bezier-definition.mjs
var isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/easing.mjs
function isWaapiSupportedEasing(easing) {
  return Boolean(!easing || typeof easing === "string" && easing in supportedWaapiEasing || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasingWithDefault(easing) {
  return mapEasingToNativeEasing(easing) || supportedWaapiEasing.easeOut;
}
function mapEasingToNativeEasing(easing) {
  if (!easing) {
    return void 0;
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map(mapEasingToNativeEasingWithDefault);
  } else {
    return supportedWaapiEasing[easing];
  }
}

// ../../node_modules/framer-motion/dist/es/animation/animators/waapi/index.mjs
function animateStyle(element, valueName, keyframes2, { delay: delay2 = 0, duration = 300, repeat = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease2);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay2,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}

// ../../node_modules/framer-motion/dist/es/animation/animators/AcceleratedAnimation.mjs
var supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
var acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
var sampleDelta = 10;
var maxDuration2 = 2e4;
function requiresPregeneratedKeyframes(options) {
  return options.type === "spring" || options.name === "backgroundColor" || !isWaapiSupportedEasing(options.ease);
}
function pregenerateKeyframes(keyframes2, options) {
  const sampleAnimation = new MainThreadAnimation({
    ...options,
    keyframes: keyframes2,
    repeat: 0,
    delay: 0,
    isGenerator: true
  });
  let state = { done: false, value: keyframes2[0] };
  const pregeneratedKeyframes = [];
  let t = 0;
  while (!state.done && t < maxDuration2) {
    state = sampleAnimation.sample(t);
    pregeneratedKeyframes.push(state.value);
    t += sampleDelta;
  }
  return {
    times: void 0,
    keyframes: pregeneratedKeyframes,
    duration: t - sampleDelta,
    ease: "linear"
  };
}
var AcceleratedAnimation = class extends BaseAnimation {
  constructor(options) {
    super(options);
    const { name, motionValue: motionValue2, keyframes: keyframes2 } = this.options;
    this.resolver = new DOMKeyframesResolver(keyframes2, (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue2);
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes2, finalKeyframe) {
    var _a;
    let { duration = 300, times, ease: ease2, type, motionValue: motionValue2, name } = this.options;
    if (!((_a = motionValue2.owner) === null || _a === void 0 ? void 0 : _a.current)) {
      return false;
    }
    if (requiresPregeneratedKeyframes(this.options)) {
      const { onComplete, onUpdate, motionValue: motionValue3, ...options } = this.options;
      const pregeneratedAnimation = pregenerateKeyframes(keyframes2, options);
      keyframes2 = pregeneratedAnimation.keyframes;
      if (keyframes2.length === 1) {
        keyframes2[1] = keyframes2[0];
      }
      duration = pregeneratedAnimation.duration;
      times = pregeneratedAnimation.times;
      ease2 = pregeneratedAnimation.ease;
      type = "keyframes";
    }
    const animation = animateStyle(motionValue2.owner.current, name, keyframes2, { ...this.options, duration, times, ease: ease2 });
    animation.startTime = time.now();
    if (this.pendingTimeline) {
      animation.timeline = this.pendingTimeline;
      this.pendingTimeline = void 0;
    } else {
      animation.onfinish = () => {
        const { onComplete } = this.options;
        motionValue2.set(getFinalKeyframe(keyframes2, this.options, finalKeyframe));
        onComplete && onComplete();
        this.cancel();
        this.resolveFinishedPromise();
      };
    }
    return {
      animation,
      duration,
      times,
      type,
      ease: ease2,
      keyframes: keyframes2
    };
  }
  get duration() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { duration } = resolved;
    return millisecondsToSeconds(duration);
  }
  get time() {
    const { resolved } = this;
    if (!resolved)
      return 0;
    const { animation } = resolved;
    return millisecondsToSeconds(animation.currentTime || 0);
  }
  set time(newTime) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.currentTime = secondsToMilliseconds(newTime);
  }
  get speed() {
    const { resolved } = this;
    if (!resolved)
      return 1;
    const { animation } = resolved;
    return animation.playbackRate;
  }
  set speed(newSpeed) {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.playbackRate = newSpeed;
  }
  get state() {
    const { resolved } = this;
    if (!resolved)
      return "idle";
    const { animation } = resolved;
    return animation.playState;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(timeline) {
    if (!this._resolved) {
      this.pendingTimeline = timeline;
    } else {
      const { resolved } = this;
      if (!resolved)
        return noop;
      const { animation } = resolved;
      animation.timeline = timeline;
      animation.onfinish = null;
    }
    return noop;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    if (animation.playState === "finished") {
      this.updateFinishedPromise();
    }
    animation.play();
  }
  pause() {
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation } = resolved;
    animation.pause();
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle")
      return;
    const { resolved } = this;
    if (!resolved)
      return;
    const { animation, keyframes: keyframes2, duration, type, ease: ease2, times } = resolved;
    if (animation.playState === "idle" || animation.playState === "finished") {
      return;
    }
    if (this.time) {
      const { motionValue: motionValue2, onUpdate, onComplete, ...options } = this.options;
      const sampleAnimation = new MainThreadAnimation({
        ...options,
        keyframes: keyframes2,
        duration,
        type,
        ease: ease2,
        times,
        isGenerator: true
      });
      const sampleTime = secondsToMilliseconds(this.time);
      motionValue2.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
    }
    this.cancel();
  }
  complete() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.finish();
  }
  cancel() {
    const { resolved } = this;
    if (!resolved)
      return;
    resolved.animation.cancel();
  }
  static supports(options) {
    const { motionValue: motionValue2, name, repeatDelay, repeatType, damping, type } = options;
    return supportsWaapi() && name && acceleratedValues.has(name) && motionValue2 && motionValue2.owner && motionValue2.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !motionValue2.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
  }
};

// ../../node_modules/framer-motion/dist/es/animation/interfaces/motion-value.mjs
var animateMotionValue = (name, value, target, transition = {}, element, isHandoff) => (onComplete) => {
  const valueTransition = getValueTransition(transition, name) || {};
  const delay2 = valueTransition.delay || transition.delay || 0;
  let { elapsed = 0 } = transition;
  elapsed = elapsed - secondsToMilliseconds(delay2);
  let options = {
    keyframes: Array.isArray(target) ? target : [null, target],
    ease: "easeOut",
    velocity: value.getVelocity(),
    ...valueTransition,
    delay: -elapsed,
    onUpdate: (v) => {
      value.set(v);
      valueTransition.onUpdate && valueTransition.onUpdate(v);
    },
    onComplete: () => {
      onComplete();
      valueTransition.onComplete && valueTransition.onComplete();
    },
    name,
    motionValue: value,
    element: isHandoff ? void 0 : element
  };
  if (!isTransitionDefined(valueTransition)) {
    options = {
      ...options,
      ...getDefaultTransition(name, options)
    };
  }
  if (options.duration) {
    options.duration = secondsToMilliseconds(options.duration);
  }
  if (options.repeatDelay) {
    options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
  }
  if (options.from !== void 0) {
    options.keyframes[0] = options.from;
  }
  let shouldSkip = false;
  if (options.type === false || options.duration === 0 && !options.repeatDelay) {
    options.duration = 0;
    if (options.delay === 0) {
      shouldSkip = true;
    }
  }
  if (instantAnimationState.current || MotionGlobalConfig.skipAnimations) {
    shouldSkip = true;
    options.duration = 0;
    options.delay = 0;
  }
  if (shouldSkip && !isHandoff && value.get() !== void 0) {
    const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
    if (finalKeyframe !== void 0) {
      frame.update(() => {
        options.onUpdate(finalKeyframe);
        options.onComplete();
      });
      return;
    }
  }
  if (!isHandoff && AcceleratedAnimation.supports(options)) {
    return new AcceleratedAnimation(options);
  } else {
    return new MainThreadAnimation(options);
  }
};

// ../../node_modules/framer-motion/dist/es/value/use-will-change/is.mjs
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

// ../../node_modules/framer-motion/dist/es/utils/array.mjs
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1)
    arr.push(item);
}
function removeItem(arr, item) {
  const index2 = arr.indexOf(item);
  if (index2 > -1)
    arr.splice(index2, 1);
}

// ../../node_modules/framer-motion/dist/es/utils/subscription-manager.mjs
var SubscriptionManager = class {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a, b, c) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a, b, c);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        const handler = this.subscriptions[i];
        handler && handler(a, b, c);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
};

// ../../node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message))
    return;
  console.warn(message);
  if (element)
    console.warn(element);
  warned.add(message);
}

// ../../node_modules/framer-motion/dist/es/value/index.mjs
var MAX_VELOCITY_DELTA = 30;
var isFloat = (value) => {
  return !isNaN(parseFloat(value));
};
var collectMotionValues = {
  current: void 0
};
var MotionValue = class {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init, options = {}) {
    this.version = "11.1.5";
    this.canTrackVelocity = false;
    this.events = {};
    this.updateAndNotify = (v, render = true) => {
      const currentTime = time.now();
      if (this.updatedAt !== currentTime) {
        this.setPrevFrameValue();
      }
      this.prev = this.current;
      this.setCurrent(v);
      if (this.current !== this.prev && this.events.change) {
        this.events.change.notify(this.current);
      }
      if (render && this.events.renderRequest) {
        this.events.renderRequest.notify(this.current);
      }
    };
    this.hasAnimated = false;
    this.setCurrent(init);
    this.canTrackVelocity = isFloat(this.current);
    this.owner = options.owner;
  }
  setCurrent(current) {
    this.current = current;
    this.updatedAt = time.now();
  }
  setPrevFrameValue(prevFrameValue = this.current) {
    this.prevFrameValue = prevFrameValue;
    this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v, render = true) {
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev, current, delta) {
    this.set(current);
    this.prev = void 0;
    this.prevFrameValue = prev;
    this.prevUpdatedAt = this.updatedAt - delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v, endAnimation = true) {
    this.updateAndNotify(v);
    this.prev = v;
    this.prevUpdatedAt = this.prevFrameValue = void 0;
    endAnimation && this.stop();
    if (this.stopPassiveEffect)
      this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    if (collectMotionValues.current) {
      collectMotionValues.current.push(this);
    }
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const currentTime = time.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
      return 0;
    }
    const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise((resolve) => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
};
function motionValue(init, options) {
  return new MotionValue(init, options);
}

// ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs
function setMotionValue(visualElement, key2, value) {
  if (visualElement.hasValue(key2)) {
    visualElement.getValue(key2).set(value);
  } else {
    visualElement.addValue(key2, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
  target = { ...target, ...transitionEnd };
  for (const key2 in target) {
    const value = resolveFinalValueInKeyframes(target[key2]);
    setMotionValue(visualElement, key2, value);
  }
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-target.mjs
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key2) {
  const shouldBlock = protectedKeys.hasOwnProperty(key2) && needsAnimating[key2] !== true;
  needsAnimating[key2] = false;
  return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay: delay2 = 0, transitionOverride, type } = {}) {
  var _a;
  let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
  const willChange = visualElement.getValue("willChange");
  if (transitionOverride)
    transition = transitionOverride;
  const animations2 = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key2 in target) {
    const value = visualElement.getValue(key2, (_a = visualElement.latestValues[key2]) !== null && _a !== void 0 ? _a : null);
    const valueTarget = target[key2];
    if (valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key2)) {
      continue;
    }
    const valueTransition = {
      delay: delay2,
      elapsed: 0,
      ...getValueTransition(transition || {}, key2)
    };
    let isHandoff = false;
    if (window.HandoffAppearAnimations) {
      const props = visualElement.getProps();
      const appearId = props[optimizedAppearDataAttribute];
      if (appearId) {
        const elapsed = window.HandoffAppearAnimations(appearId, key2);
        if (elapsed !== null) {
          valueTransition.elapsed = elapsed;
          isHandoff = true;
        }
      }
    }
    value.start(animateMotionValue(key2, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key2) ? { type: false } : valueTransition, visualElement, isHandoff));
    const animation = value.animation;
    if (animation) {
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key2);
        animation.then(() => willChange.remove(key2));
      }
      animations2.push(animation);
    }
  }
  if (transitionEnd) {
    Promise.all(animations2).then(() => {
      frame.update(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }
  return animations2;
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element-variant.mjs
function animateVariant(visualElement, variant, options = {}) {
  var _a;
  const resolved = resolveVariant(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
  let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  const getAnimation = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options)) : () => Promise.resolve();
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve();
  const { when } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
  const animations2 = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? (i = 0) => i * staggerChildren : (i = 0) => maxStaggerDuration - i * staggerChildren;
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i) => {
    child.notify("AnimationStart", variant);
    animations2.push(animateVariant(child, variant, {
      ...options,
      delay: delayChildren + generateStaggerDuration(i)
    }).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a, b) {
  return a.sortNodePosition(b);
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/visual-element.mjs
function animateVisualElement(visualElement, definition, options = {}) {
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations2 = definition.map((variant) => animateVariant(visualElement, variant, options));
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation.then(() => {
    frame.postRender(() => {
      visualElement.notify("AnimationComplete", definition);
    });
  });
}

// ../../node_modules/framer-motion/dist/es/render/utils/animation-state.mjs
var reversePriorityOrder = [...variantPriorityOrder].reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  const state = createState();
  let isInitialRender = true;
  const buildResolvedTypeValues = (type) => (acc, definition) => {
    var _a;
    const resolved = resolveVariant(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : void 0);
    if (resolved) {
      const { transition, transitionEnd, ...target } = resolved;
      acc = { ...acc, ...target, ...transitionEnd };
    }
    return acc;
  };
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  function animateChanges(changedActiveType) {
    const props = visualElement.getProps();
    const context = visualElement.getVariantContext(true) || {};
    const animations2 = [];
    const removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {};
    let removedVariantIndex = Infinity;
    for (let i = 0; i < numAnimationTypes; i++) {
      const type = reversePriorityOrder[i];
      const typeState = state[type];
      const prop = props[type] !== void 0 ? props[type] : context[type];
      const propIsVariant = isVariantLabel(prop);
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i;
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = { ...encounteredKeys };
      if (
        // If it isn't active and hasn't *just* been set as inactive
        !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
        !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
        isAnimationControls(prop) || typeof prop === "boolean"
      ) {
        continue;
      }
      const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
      if (activeDelta === false)
        resolvedValues = {};
      const { prevResolvedValues = {} } = typeState;
      const allKeys = {
        ...prevResolvedValues,
        ...resolvedValues
      };
      const markToAnimate = (key2) => {
        shouldAnimateType = true;
        if (removedKeys.has(key2)) {
          handledRemovedValues = true;
          removedKeys.delete(key2);
        }
        typeState.needsAnimating[key2] = true;
        const motionValue2 = visualElement.getValue(key2);
        if (motionValue2)
          motionValue2.liveStyle = false;
      };
      for (const key2 in allKeys) {
        const next = resolvedValues[key2];
        const prev = prevResolvedValues[key2];
        if (encounteredKeys.hasOwnProperty(key2))
          continue;
        let valueHasChanged = false;
        if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
          valueHasChanged = !shallowCompare(next, prev);
        } else {
          valueHasChanged = next !== prev;
        }
        if (valueHasChanged) {
          if (next !== void 0 && next !== null) {
            markToAnimate(key2);
          } else {
            removedKeys.add(key2);
          }
        } else if (next !== void 0 && removedKeys.has(key2)) {
          markToAnimate(key2);
        } else {
          typeState.protectedKeys[key2] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = { ...encounteredKeys, ...resolvedValues };
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
        animations2.push(...definitionList.map((animation) => ({
          animation,
          options: { type }
        })));
      }
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key2) => {
        const fallbackTarget = visualElement.getBaseTarget(key2);
        const motionValue2 = visualElement.getValue(key2);
        if (motionValue2)
          motionValue2.liveStyle = true;
        fallbackAnimation[key2] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
      });
      animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  function setActive(type, isActive) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations2 = animateChanges(type);
    for (const key2 in state) {
      state[key2].protectedKeys = {};
    }
    return animations2;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (Array.isArray(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive = false) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}

// ../../node_modules/framer-motion/dist/es/motion/features/animation/index.mjs
var AnimationFeature = class extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node38) {
    super(node38);
    node38.animationState || (node38.animationState = createAnimationState(node38));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    this.unmount();
    if (isAnimationControls(animate)) {
      this.unmount = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps();
    const { animate: prevAnimate } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animation/exit.mjs
var id = 0;
var ExitAnimationFeature = class extends Feature {
  constructor() {
    super(...arguments);
    this.id = id++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete } = this.node.presenceContext;
    const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/animations.mjs
var animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};

// ../../node_modules/framer-motion/dist/es/utils/distance.mjs
var distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
  const xDelta = distance(a.x, b.x);
  const yDelta = distance(a.y, b.y);
  return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

// ../../node_modules/framer-motion/dist/es/gestures/pan/PanSession.mjs
var PanSession = class {
  constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance2D(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point2 } = info2;
      const { timestamp: timestamp2 } = frameData;
      this.history.push({ ...point2, timestamp: timestamp2 });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info2);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info2);
    };
    this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2;
      this.lastMoveEventInfo = transformPoint(info2, this.transformPagePoint);
      frame.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin)
        resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info2, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (!isPrimaryPointer(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event);
    const initialInfo = transformPoint(info, this.transformPagePoint);
    const { point } = initialInfo;
    const { timestamp } = frameData;
    this.history = [{ ...point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame(this.updatePoint);
  }
};
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
  return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity2(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity2(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time2 = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time2 === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
  delta.origin = origin;
  delta.originPoint = mixNumber(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  if (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale))
    delta.scale = 1;
  delta.translate = mixNumber(target.min, target.max, delta.origin) - delta.originPoint;
  if (isNear(delta.translate) || isNaN(delta.translate))
    delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : void 0);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout2, parent) {
  target.min = layout2.min - parent.min;
  target.max = target.min + calcLength(layout2);
}
function calcRelativePosition(target, layout2, parent) {
  calcRelativeAxisPosition(target.x, layout2.x, parent.x);
  calcRelativeAxisPosition(target.y, layout2.y, parent.y);
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs
function applyConstraints(point, { min, max }, elastic) {
  if (min !== void 0 && point < min) {
    point = elastic ? mixNumber(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== void 0 && point > max) {
    point = elastic ? mixNumber(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== void 0 ? axis.min + min : void 0,
    max: max !== void 0 ? axis.max + max - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min = constraintsAxis.min - layoutAxis.min;
  let max = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min, max] = [max, min];
  }
  return { min, max };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcOrigin2(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source);
  const targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
function rebaseAxisConstraints(layout2, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout2.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout2.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic = defaultElastic) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/models.mjs
var createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
var createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
});
var createAxis = () => ({ min: 0, max: 0 });
var createBox = () => ({
  x: createAxis(),
  y: createAxis()
});

// ../../node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/conversion.mjs
function convertBoundingBoxToBox({ top, left, right, bottom }) {
  return {
    x: { min: left, max: right },
    y: { min: top, max: bottom }
  };
}
function convertBoxToBoundingBox({ x, y }) {
  return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
function transformBoxPoints(point, transformPoint2) {
  if (!transformPoint2)
    return point;
  const topLeft = transformPoint2({ x: point.left, y: point.top });
  const bottomRight = transformPoint2({ x: point.right, y: point.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}

// ../../node_modules/framer-motion/dist/es/projection/utils/has-transform.mjs
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
function hasScale({ scale: scale2, scaleX, scaleY }) {
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-apply.mjs
function scalePoint(point, scale2, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, { x, y }) {
  applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node38;
  let delta;
  for (let i = 0; i < treeLength; i++) {
    node38 = treePath[i];
    delta = node38.projectionDelta;
    const instance = node38.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node38.options.layoutScroll && node38.scroll && node38 !== node38.root) {
      transformBox(box, {
        x: -node38.scroll.offset.x,
        y: -node38.scroll.offset.y
      });
    }
    if (delta) {
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node38.latestValues)) {
      transformBox(box, node38.latestValues);
    }
  }
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale2) {
  if (Number.isInteger(scale2))
    return scale2;
  return scale2 > 1.0000000000001 || scale2 < 0.999999999999 ? scale2 : 1;
}
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2;
  axis.max = axis.max + distance2;
}
function transformAxis(axis, transforms, [key2, scaleKey, originKey]) {
  const axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  const originPoint = mixNumber(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms[key2], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys);
  transformAxis(box.y, transform, yKeys);
}

// ../../node_modules/framer-motion/dist/es/projection/utils/measure.mjs
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
function measurePageBox(element, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox(element, transformPagePoint);
  const { scroll } = rootProjectionNode2;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

// ../../node_modules/framer-motion/dist/es/utils/get-context-window.mjs
var getContextWindow = ({ current }) => {
  return current ? current.ownerDocument.defaultView : null;
};

// ../../node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs
var elementDragControls = /* @__PURE__ */ new WeakMap();
var VisualElementDragControls = class {
  constructor(visualElement) {
    this.openGlobalLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = { x: 0, y: 0 };
    this.constraints = false;
    this.hasMutatedConstraints = false;
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = false } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false)
      return;
    const onSessionStart = (event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo(event, "page").point);
      }
    };
    const onStart = (event, info) => {
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation) {
        if (this.openGlobalLock)
          this.openGlobalLock();
        this.openGlobalLock = getGlobalLock(drag2);
        if (!this.openGlobalLock)
          return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = void 0;
      }
      eachAxis((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length = calcLength(measuredAxis);
              current = length * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      if (onDragStart)
        onDragStart(event, info);
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset);
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      this.updateAxis("x", info.point, offset);
      this.updateAxis("y", info.point, offset);
      this.visualElement.render();
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis((axis) => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    if (onDragEnd)
      onDragEnd(event, info);
  }
  cancel() {
    this.isDragging = false;
    const { projection, animationState } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    if (!dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset) {
    const { drag: drag2 } = this.getProps();
    if (!offset || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next = this.originPoint[axis] + offset[axis];
    if (this.constraints && this.constraints[axis]) {
      next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next);
  }
  resolveConstraints() {
    var _a;
    const { dragConstraints, dragElastic } = this.getProps();
    const layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout2) {
        this.constraints = calcRelativeConstraints(layout2.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints) {
      eachAxis((axis) => {
        if (this.constraints !== false && this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints(layout2.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject(constraints))
      return false;
    const constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return false;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin)
        transition = { min: 0, max: 0 };
      const bounceStiffness = dragElastic ? 200 : 1e6;
      const bounceDamping = dragElastic ? 40 : 1e7;
      const inertia2 = {
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...dragTransition,
        ...transition
      };
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement));
  }
  stopAnimation() {
    eachAxis((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis((axis) => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = `_drag${axis.toUpperCase()}`;
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point) {
    eachAxis((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min, max } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mixNumber(min, max, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps();
    const { projection } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue && this.constraints !== false) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin2({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis);
      const { min, max } = this.constraints[axis];
      axisValue.set(mixNumber(min, max, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const element = this.visualElement.current;
    const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
      const { drag: drag2, dragListener = true } = this.getProps();
      drag2 && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const { dragConstraints } = this.getProps();
      if (isRefObject(dragConstraints)) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const { projection } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    measureDragConstraints();
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      if (this.isDragging && hasLayoutChanged) {
        eachAxis((axis) => {
          const motionValue2 = this.getAxisMotionValue(axis);
          if (!motionValue2)
            return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue2.set(motionValue2.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const { drag: drag2 = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true } = props;
    return {
      ...props,
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    };
  }
};
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset, lockThreshold = 10) {
  let direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/index.mjs
var DragGesture = class extends Feature {
  constructor(node38) {
    super(node38);
    this.removeGroupControls = noop;
    this.removeListeners = noop;
    this.controls = new VisualElementDragControls(node38);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
};

// ../../node_modules/framer-motion/dist/es/gestures/pan/index.mjs
var asyncHandler = (handler) => (event, info) => {
  if (handler) {
    handler(event, info);
  }
};
var PanGesture = class extends Feature {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd)
          onPanEnd(event, info);
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
import { jsx as jsx52 } from "react/jsx-runtime";
import { useContext as useContext6, Component } from "react";

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
import { useContext as useContext5, useId, useEffect as useEffect8 } from "react";
function usePresence() {
  const context = useContext5(PresenceContext);
  if (context === null)
    return [true, null];
  const { isPresent, onExitComplete, register } = context;
  const id3 = useId();
  useEffect8(() => register(id3), []);
  const safeToRemove = () => onExitComplete && onExitComplete(id3);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

// ../../node_modules/framer-motion/dist/es/projection/node/state.mjs
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-border-radius.mjs
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min)
    return 0;
  return pixels / (axis.max - axis.min) * 100;
}
var correctBorderRadius = {
  correct: (latest, node38) => {
    if (!node38.target)
      return latest;
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    const x = pixelsToPercent(latest, node38.target.x);
    const y = pixelsToPercent(latest, node38.target.y);
    return `${x}% ${y}%`;
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/scale-box-shadow.mjs
var correctBoxShadow = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest;
    const shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex.createTransformer(latest);
    const offset = typeof shadow[0] !== "number" ? 1 : 0;
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    const averageScale = mixNumber(xScale, yScale, 0.5);
    if (typeof shadow[2 + offset] === "number")
      shadow[2 + offset] /= averageScale;
    if (typeof shadow[3 + offset] === "number")
      shadow[3 + offset] /= averageScale;
    return template(shadow);
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs
var MeasureLayoutWithContext = class extends Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
    const { projection } = visualElement;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup.group)
        layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions({
        ...projection.options,
        onExitComplete: () => this.safeToRemove()
      });
    }
    globalProjectionState.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props;
    const projection = visualElement.projection;
    if (!projection)
      return null;
    projection.isPresent = isPresent;
    if (drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        frame.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      microtask.postRender(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
    const { projection } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group)
        layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister)
        promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
};
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence();
  const layoutGroup = useContext6(LayoutGroupContext);
  return jsx52(MeasureLayoutWithContext, { ...props, layoutGroup, switchLayoutGroup: useContext6(SwitchLayoutGroupContext), isPresent, safeToRemove });
}
var defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};

// ../../node_modules/framer-motion/dist/es/projection/animation/mix-values.mjs
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
var isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mixNumber(
      0,
      // TODO Reinstate this if only child
      lead.opacity !== void 0 ? lead.opacity : 1,
      easeCrossfadeIn(progress2)
    );
    target.opacityExit = mixNumber(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut(progress2));
  } else if (isOnlyMember) {
    target.opacity = mixNumber(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2);
  }
  for (let i = 0; i < numBorders; i++) {
    const borderLabel = `border${borders[i]}Radius`;
    let followRadius = getRadius(follow, borderLabel);
    let leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mixNumber(asNumber(followRadius), asNumber(leadRadius), progress2), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  if (follow.rotate || lead.rotate) {
    target.rotate = mixNumber(follow.rotate || 0, lead.rotate || 0, progress2);
  }
}
function getRadius(values, radiusName) {
  return values[radiusName] !== void 0 ? values[radiusName] : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, noop);
function compress(min, max, easing) {
  return (p) => {
    if (p < min)
      return 0;
    if (p > max)
      return 1;
    return easing(progress(min, max, p));
  };
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/copy.mjs
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/delta-remove.mjs
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mixNumber(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number")
    return;
  let originPoint = mixNumber(originAxis.min, originAxis.max, origin);
  if (axis === originAxis)
    originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, [key2, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta(axis, transforms[key2], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys2 = ["x", "scaleX", "originX"];
var yKeys2 = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys2, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0);
  removeAxisTransforms(box.y, transforms, yKeys2, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}

// ../../node_modules/framer-motion/dist/es/projection/geometry/utils.mjs
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
  return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function boxEqualsRounded(a, b) {
  return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}

// ../../node_modules/framer-motion/dist/es/projection/shared/stack.mjs
var NodeStack = class {
  constructor() {
    this.members = [];
  }
  add(node38) {
    addUniqueItem(this.members, node38);
    node38.scheduleRender();
  }
  remove(node38) {
    removeItem(this.members, node38);
    if (node38 === this.prevLead) {
      this.prevLead = void 0;
    }
    if (node38 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node38) {
    const indexOfNode = this.members.findIndex((member) => node38 === member);
    if (indexOfNode === 0)
      return false;
    let prevLead;
    for (let i = indexOfNode; i >= 0; i--) {
      const member = this.members[i];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node38, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node38 === prevLead)
      return;
    this.prevLead = prevLead;
    this.lead = node38;
    node38.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node38.scheduleRender();
      node38.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node38.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node38.snapshot = prevLead.snapshot;
        node38.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node38.root && node38.root.isUpdating) {
        node38.isLayoutDirty = true;
      }
      const { crossfade } = node38.options;
      if (crossfade === false) {
        prevLead.hide();
      }
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node38) => {
      const { options, resumingFrom } = node38;
      options.onExitComplete && options.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach((node38) => {
      node38.instance && node38.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = void 0;
    }
  }
};

// ../../node_modules/framer-motion/dist/es/projection/styles/transform.mjs
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform = "";
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
  if (xTranslate || yTranslate || zTranslate) {
    transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
  }
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
  }
  if (latestTransform) {
    const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
    if (transformPerspective)
      transform = `perspective(${transformPerspective}px) ${transform}`;
    if (rotate)
      transform += `rotate(${rotate}deg) `;
    if (rotateX)
      transform += `rotateX(${rotateX}deg) `;
    if (rotateY)
      transform += `rotateY(${rotateY}deg) `;
    if (skewX)
      transform += `skewX(${skewX}deg) `;
    if (skewY)
      transform += `skewY(${skewY}deg) `;
  }
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += `scale(${elementScaleX}, ${elementScaleY})`;
  }
  return transform || "none";
}

// ../../node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
var compareByDepth = (a, b) => a.depth - b.depth;

// ../../node_modules/framer-motion/dist/es/render/utils/flat-tree.mjs
var FlatTree = class {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/delay.mjs
function delay(callback, timeout) {
  const start = time.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}

// ../../node_modules/framer-motion/dist/es/debug/record.mjs
function record(data) {
  if (window.MotionDebug) {
    window.MotionDebug.record(data);
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-element.mjs
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}

// ../../node_modules/framer-motion/dist/es/animation/interfaces/single-value.mjs
function animateSingleValue(value, keyframes2, options) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes2, options));
  return motionValue$1.animation;
}

// ../../node_modules/framer-motion/dist/es/projection/node/create-projection-node.mjs
var transformAxes = ["", "X", "Y", "Z"];
var hiddenVisibility = { visibility: "hidden" };
var animationTarget = 1e3;
var id2 = 0;
var projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function resetDistortingTransform(key2, visualElement, values, sharedAnimationValues) {
  const { latestValues } = visualElement;
  if (latestValues[key2]) {
    values[key2] = latestValues[key2];
    visualElement.setStaticValue(key2, 0);
    if (sharedAnimationValues) {
      sharedAnimationValues[key2] = 0;
    }
  }
}
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  return class ProjectionNode {
    constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
      this.id = id2++;
      this.animationId = 0;
      this.children = /* @__PURE__ */ new Set();
      this.options = {};
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      this.isLayoutDirty = false;
      this.isProjectionDirty = false;
      this.isSharedProjectionDirty = false;
      this.isTransformDirty = false;
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      this.isUpdating = false;
      this.isSVG = false;
      this.needsReset = false;
      this.shouldResetTransform = false;
      this.treeScale = { x: 1, y: 1 };
      this.eventHandlers = /* @__PURE__ */ new Map();
      this.hasTreeAnimated = false;
      this.updateScheduled = false;
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
        this.nodes.forEach(propagateDirtyNodes);
        this.nodes.forEach(resolveTargetDelta);
        this.nodes.forEach(calcProjection);
        this.nodes.forEach(cleanDirtyNodes);
        record(projectionFrameData);
      };
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      this.sharedNodes = /* @__PURE__ */ new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this)
        this.nodes = new FlatTree();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name, ...args) {
      const subscriptionManager = this.eventHandlers.get(name);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(instance);
      this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout2 || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay(resizeUnblockUpdate, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      if (this.options.animate !== false && visualElement && (layoutId || layout2)) {
        this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
          if (this.isTreeAnimationBlocked()) {
            this.target = void 0;
            this.relativeTarget = void 0;
            return;
          }
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
          const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
          const targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = void 0;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = {
              ...getValueTransition(layoutTransition, "layout"),
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            };
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            if (!hasLayoutChanged) {
              finishAnimation(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = void 0;
      cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked())
        return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetSkewAndRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = true) {
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty)
        return;
      this.isLayoutDirty = true;
      for (let i = 0; i < this.path.length; i++) {
        const node38 = this.path[i];
        node38.shouldResetTransform = true;
        node38.updateScroll("snapshot");
        if (node38.options.layoutRoot) {
          node38.willUpdate(false);
        }
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty);
      }
      this.isUpdating = false;
      if (window.HandoffCancelAllAnimations) {
        window.HandoffCancelAllAnimations();
      }
      this.nodes.forEach(resetTransformStyle);
      this.nodes.forEach(updateLayout);
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      const now3 = time.now();
      frameData.delta = clamp(0, 1e3 / 60, now3 - frameData.timestamp);
      frameData.timestamp = now3;
      frameData.isProcessing = true;
      steps.update.process(frameData);
      steps.preRender.process(frameData);
      steps.render.process(frameData);
      frameData.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        microtask.read(() => this.update());
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance)
        return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance)
        return;
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i = 0; i < this.path.length; i++) {
          const node38 = this.path[i];
          node38.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = void 0;
      this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot: checkIsScrollRoot(this.instance),
          offset: measureScroll(this.instance)
        };
      }
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
      const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure(removeTransform = true) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox();
      const box = visualElement.measureViewportBox();
      const { scroll } = this.root;
      if (scroll) {
        translateAxis(box.x, scroll.offset.x);
        translateAxis(box.y, scroll.offset.y);
      }
      return box;
    }
    removeElementScroll(box) {
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      for (let i = 0; i < this.path.length; i++) {
        const node38 = this.path[i];
        const { scroll, options } = node38;
        if (node38 !== this.root && scroll && options.layoutScroll) {
          if (scroll.isRoot) {
            copyBoxInto(boxWithoutScroll, box);
            const { scroll: rootScroll } = this.root;
            if (rootScroll) {
              translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
              translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
            }
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x);
          translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = false) {
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i = 0; i < this.path.length; i++) {
        const node38 = this.path[i];
        if (!transformOnly && node38.options.layoutScroll && node38.scroll && node38 !== node38.root) {
          transformBox(withTransforms, {
            x: -node38.scroll.offset.x,
            y: -node38.scroll.offset.y
          });
        }
        if (!hasTransform(node38.latestValues))
          continue;
        transformBox(withTransforms, node38.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i = 0; i < this.path.length; i++) {
        const node38 = this.path[i];
        if (!node38.instance)
          continue;
        if (!hasTransform(node38.latestValues))
          continue;
        hasScale(node38.latestValues) && node38.updateSnapshot();
        const sourceBox = createBox();
        const nodeBox = node38.measurePageBox();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node38.latestValues, node38.snapshot ? node38.snapshot.layoutBox : void 0, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options) {
      this.options = {
        ...this.options,
        ...options,
        crossfade: options.crossfade !== void 0 ? options.crossfade : true
      };
    }
    clearMeasurements() {
      this.scroll = void 0;
      this.layout = void 0;
      this.snapshot = void 0;
      this.prevTransformTemplateValue = void 0;
      this.targetDelta = void 0;
      this.target = void 0;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent)
        return;
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta(forceRecalculation = false) {
      var _a;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!this.layout || !(layout2 || layoutId))
        return;
      this.resolvedRelativeTargetAt = frameData.timestamp;
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      if (!this.relativeTarget && !this.targetDelta)
        return;
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        copyBoxInto(this.target, this.layout.layoutBox);
      }
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = void 0;
        }
      }
      projectionFrameData.resolvedTargetDeltas++;
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
        return void 0;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      if (this.resolvedRelativeTargetAt === frameData.timestamp) {
        canSkip = false;
      }
      if (canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = void 0;
      }
      if (!this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
        lead.targetWithTransforms = createBox();
      }
      const { target } = lead;
      if (!target) {
        if (this.projectionTransform) {
          this.projectionDelta = createDelta();
          this.projectionTransform = "none";
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta) {
        this.projectionDelta = createDelta();
        this.projectionDeltaWithTransform = createDelta();
      }
      const prevProjectionTransform = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
      if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = false;
    }
    show() {
      this.isVisible = true;
    }
    scheduleRender(notifyAll = true) {
      this.options.scheduleRender && this.options.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = void 0;
      }
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = { ...this.latestValues };
      const targetDelta = createDelta();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = void 0;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox();
      const snapshotSource = snapshot ? snapshot.source : void 0;
      const layoutSource = this.layout ? this.layout.source : void 0;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2);
        mixAxisDelta(targetDelta.y, delta.y, progress2);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2);
          if (prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget)
            prevRelativeTarget = createBox();
          copyBoxInto(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress2;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame(this.pendingAnimation);
        this.pendingAnimation = void 0;
      }
      this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...options,
          onUpdate: (latest) => {
            this.mixTargetDelta(latest);
            options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete();
            this.completeAnimation();
          }
        });
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = void 0;
        this.resumingFrom.preserveOpacity = void 0;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = void 0;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!targetWithTransforms || !target || !layout2)
        return;
      if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
        target = this.target || createBox();
        const xLength = calcLength(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto(targetWithTransforms, target);
      transformBox(targetWithTransforms, latestValues);
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node38) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node38);
      const config = node38.options.initialPromotionConfig;
      node38.promote({
        transition: config ? config.transition : void 0,
        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node38) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const { layoutId } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      if (stack)
        stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = void 0;
        this.needsReset = true;
      }
      if (transition)
        this.setOptions({ transition });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetSkewAndRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasDistortingTransform = false;
      const { latestValues } = visualElement;
      if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) {
        hasDistortingTransform = true;
      }
      if (!hasDistortingTransform)
        return;
      const resetValues = {};
      if (latestValues.z) {
        resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
      }
      for (let i = 0; i < transformAxes.length; i++) {
        resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
        resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
      }
      visualElement.render();
      for (const key2 in resetValues) {
        visualElement.setStaticValue(key2, resetValues[key2]);
        if (this.animationValues) {
          this.animationValues[key2] = resetValues[key2];
        }
      }
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG)
        return void 0;
      if (!this.isVisible) {
        return hiddenVisibility;
      }
      const styles = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles.opacity = "";
        styles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles.transform = transformTemplate(valuesToRender, styles.transform);
      }
      const { x, y } = this.projectionDelta;
      styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
      if (lead.animationValues) {
        styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        styles.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      }
      for (const key2 in scaleCorrectors) {
        if (valuesToRender[key2] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors[key2];
        const corrected = styles.transform === "none" ? valuesToRender[key2] : correct(valuesToRender[key2], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i = 0; i < num; i++) {
            styles[applyTo[i]] = corrected;
          }
        } else {
          styles[key2] = corrected;
        }
      }
      if (this.options.layoutId) {
        styles.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node38) => {
        var _a;
        return (_a = node38.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(node38) {
  node38.updateLayout();
}
function notifyLayoutUpdate(node38) {
  var _a;
  const snapshot = ((_a = node38.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node38.snapshot;
  if (node38.isLead() && node38.layout && snapshot && node38.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node38.layout;
    const { animationType } = node38.options;
    const isShared = snapshot.source !== node38.layout.source;
    if (animationType === "size") {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(axisSnapshot);
        axisSnapshot.min = layout2[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout2)) {
      eachAxis((axis) => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(layout2[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
        if (node38.relativeTarget && !node38.currentAnimation) {
          node38.isProjectionDirty = true;
          node38.relativeTarget[axis].max = node38.relativeTarget[axis].min + length;
        }
      });
    }
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node38.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout2, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node38.resumeFrom) {
      const relativeParent = node38.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout2, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node38.relativeTarget = relativeLayout;
            node38.relativeTargetOrigin = relativeSnapshot;
            node38.relativeParent = relativeParent;
          }
        }
      }
    }
    node38.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node38.isLead()) {
    const { onExitComplete } = node38.options;
    onExitComplete && onExitComplete();
  }
  node38.options.transition = void 0;
}
function propagateDirtyNodes(node38) {
  projectionFrameData.totalNodes++;
  if (!node38.parent)
    return;
  if (!node38.isProjecting()) {
    node38.isProjectionDirty = node38.parent.isProjectionDirty;
  }
  node38.isSharedProjectionDirty || (node38.isSharedProjectionDirty = Boolean(node38.isProjectionDirty || node38.parent.isProjectionDirty || node38.parent.isSharedProjectionDirty));
  node38.isTransformDirty || (node38.isTransformDirty = node38.parent.isTransformDirty);
}
function cleanDirtyNodes(node38) {
  node38.isProjectionDirty = node38.isSharedProjectionDirty = node38.isTransformDirty = false;
}
function clearSnapshot(node38) {
  node38.clearSnapshot();
}
function clearMeasurements(node38) {
  node38.clearMeasurements();
}
function clearIsLayoutDirty(node38) {
  node38.isLayoutDirty = false;
}
function resetTransformStyle(node38) {
  const { visualElement } = node38.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node38.resetTransform();
}
function finishAnimation(node38) {
  node38.finishAnimation();
  node38.targetDelta = node38.relativeTarget = node38.target = void 0;
  node38.isProjectionDirty = true;
}
function resolveTargetDelta(node38) {
  node38.resolveTargetDelta();
}
function calcProjection(node38) {
  node38.calcProjection();
}
function resetSkewAndRotation(node38) {
  node38.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
  output.translate = mixNumber(delta.translate, 0, p);
  output.scale = mixNumber(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
  output.min = mixNumber(from.min, to.min, p);
  output.max = mixNumber(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
  mixAxis(output.x, from.x, to.x, p);
  mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node38) {
  return node38.animationValues && node38.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
var userAgentContains = (string6) => typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string6);
var roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop;
function roundAxis(axis) {
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout2), 0.2);
}

// ../../node_modules/framer-motion/dist/es/projection/node/DocumentProjectionNode.mjs
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});

// ../../node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs
var rootProjectionNode = {
  current: void 0
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({ layoutScroll: true });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed")
});

// ../../node_modules/framer-motion/dist/es/motion/features/drag.mjs
var drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
import { Fragment as Fragment11 } from "react";

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/state.mjs
var prefersReducedMotion = { current: null };
var hasReducedMotionListener = { current: false };

// ../../node_modules/framer-motion/dist/es/utils/reduced-motion/index.mjs
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser)
    return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

// ../../node_modules/framer-motion/dist/es/render/utils/motion-values.mjs
function updateMotionValuesFromProps(element, next, prev) {
  const { willChange } = next;
  for (const key2 in next) {
    const nextValue = next[key2];
    const prevValue = prev[key2];
    if (isMotionValue(nextValue)) {
      element.addValue(key2, nextValue);
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(key2);
      }
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "11.1.5", `Attempting to mix Framer Motion versions ${nextValue.version} with 11.1.5 may not work as expected.`);
      }
    } else if (isMotionValue(prevValue)) {
      element.addValue(key2, motionValue(nextValue, { owner: element }));
      if (isWillChangeMotionValue(willChange)) {
        willChange.remove(key2);
      }
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key2)) {
        const existingValue = element.getValue(key2);
        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        const latestValue = element.getStaticValue(key2);
        element.addValue(key2, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
      }
    }
  }
  for (const key2 in prev) {
    if (next[key2] === void 0)
      element.removeValue(key2);
  }
  return next;
}

// ../../node_modules/framer-motion/dist/es/render/store.mjs
var visualElementStore = /* @__PURE__ */ new WeakMap();

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/find.mjs
var valueTypes = [...dimensionValueTypes, color, complex];
var findValueType = (v) => valueTypes.find(testValueType(v));

// ../../node_modules/framer-motion/dist/es/render/VisualElement.mjs
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
var propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
var numVariantProps = variantProps.length;
function getClosestProjectingNode(visualElement) {
  if (!visualElement)
    return void 0;
  return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}
var VisualElement = class {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
    return {};
  }
  constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState }, options = {}) {
    this.resolveKeyframes = (keyframes2, onComplete, name, value) => {
      return new this.KeyframeResolver(keyframes2, onComplete, name, value, this);
    };
    this.current = null;
    this.children = /* @__PURE__ */ new Set();
    this.isVariantNode = false;
    this.isControllingVariants = false;
    this.shouldReduceMotion = null;
    this.values = /* @__PURE__ */ new Map();
    this.KeyframeResolver = KeyframeResolver;
    this.features = {};
    this.valueSubscriptions = /* @__PURE__ */ new Map();
    this.prevMotionValues = {};
    this.events = {};
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current)
        return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.scheduleRender = () => frame.render(this.render, false, true);
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues;
    this.baseTarget = { ...latestValues };
    this.initialValues = props.initial ? { ...latestValues } : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = /* @__PURE__ */ new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
    for (const key2 in initialMotionValues) {
      const value = initialMotionValues[key2];
      if (latestValues[key2] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key2], false);
        if (isWillChangeMotionValue(willChange)) {
          willChange.add(key2);
        }
      }
    }
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key2) => this.bindToMotionValue(key2, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent)
      this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    var _a;
    visualElementStore.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach((remove) => remove());
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key2 in this.events) {
      this.events[key2].clear();
    }
    for (const key2 in this.features) {
      (_a = this.features[key2]) === null || _a === void 0 ? void 0 : _a.unmount();
    }
    this.current = null;
  }
  bindToMotionValue(key2, value) {
    const valueIsTransform = transformProps.has(key2);
    const removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key2] = latestValue;
      this.props.onUpdate && frame.preRender(this.notifyUpdate);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(key2, () => {
      removeOnChange();
      removeOnRenderRequest();
      if (value.owner)
        value.stop();
    });
  }
  sortNodePosition(other) {
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures2, initialLayoutGroupConfig) {
    let ProjectionNodeConstructor;
    let MeasureLayout2;
    if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
      const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      renderedProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
    }
    for (let i = 0; i < numFeatures; i++) {
      const name = featureNames[i];
      const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = featureDefinitions[name];
      if (ProjectionNode)
        ProjectionNodeConstructor = ProjectionNode;
      if (isEnabled(renderedProps)) {
        if (!this.features[name] && FeatureConstructor) {
          this.features[name] = new FeatureConstructor(this);
        }
        if (MeasureLayoutComponent) {
          MeasureLayout2 = MeasureLayoutComponent;
        }
      }
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
      this.projection = new ProjectionNodeConstructor(this.latestValues, getClosestProjectingNode(this.parent));
      const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
      this.projection.setOptions({
        layoutId,
        layout: layout2,
        alwaysMeasureLayout: Boolean(drag2) || dragConstraints && isRefObject(dragConstraints),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout2 === "string" ? layout2 : "both",
        initialPromotionConfig: initialLayoutGroupConfig,
        layoutScroll,
        layoutRoot
      });
    }
    return MeasureLayout2;
  }
  updateFeatures() {
    for (const key2 in this.features) {
      const feature = this.features[key2];
      if (feature.isMounted) {
        feature.update();
      } else {
        feature.mount();
        feature.isMounted = true;
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key2) {
    return this.latestValues[key2];
  }
  setStaticValue(key2, value) {
    this.latestValues[key2] = value;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    for (let i = 0; i < propEventHandlers.length; i++) {
      const key2 = propEventHandlers[i];
      if (this.propEventSubscriptions[key2]) {
        this.propEventSubscriptions[key2]();
        delete this.propEventSubscriptions[key2];
      }
      const listenerName = "on" + key2;
      const listener = props[listenerName];
      if (listener) {
        this.propEventSubscriptions[key2] = this.on(key2, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(startAtParent = false) {
    if (startAtParent) {
      return this.parent ? this.parent.getVariantContext() : void 0;
    }
    if (!this.isControllingVariants) {
      const context2 = this.parent ? this.parent.getVariantContext() || {} : {};
      if (this.props.initial !== void 0) {
        context2.initial = this.props.initial;
      }
      return context2;
    }
    const context = {};
    for (let i = 0; i < numVariantProps; i++) {
      const name = variantProps[i];
      const prop = this.props[name];
      if (isVariantLabel(prop) || prop === false) {
        context[name] = prop;
      }
    }
    return context;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key2, value) {
    const existingValue = this.values.get(key2);
    if (value !== existingValue) {
      if (existingValue)
        this.removeValue(key2);
      this.bindToMotionValue(key2, value);
      this.values.set(key2, value);
      this.latestValues[key2] = value.get();
    }
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key2) {
    this.values.delete(key2);
    const unsubscribe = this.valueSubscriptions.get(key2);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key2);
    }
    delete this.latestValues[key2];
    this.removeValueFromRenderState(key2, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key2) {
    return this.values.has(key2);
  }
  getValue(key2, defaultValue) {
    if (this.props.values && this.props.values[key2]) {
      return this.props.values[key2];
    }
    let value = this.values.get(key2);
    if (value === void 0 && defaultValue !== void 0) {
      value = motionValue(defaultValue === null ? void 0 : defaultValue, { owner: this });
      this.addValue(key2, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key2, target) {
    var _a;
    let value = this.latestValues[key2] !== void 0 || !this.current ? this.latestValues[key2] : (_a = this.getBaseTargetFromProps(this.props, key2)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key2, this.options);
    if (value !== void 0 && value !== null) {
      if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
        value = parseFloat(value);
      } else if (!findValueType(value) && complex.test(target)) {
        value = getAnimatableNone2(key2, target);
      }
      this.setBaseTarget(key2, isMotionValue(value) ? value.get() : value);
    }
    return isMotionValue(value) ? value.get() : value;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key2, value) {
    this.baseTarget[key2] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key2) {
    var _a;
    const { initial } = this.props;
    let valueFromInitial;
    if (typeof initial === "string" || typeof initial === "object") {
      const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
      if (variant) {
        valueFromInitial = variant[key2];
      }
    }
    if (initial && valueFromInitial !== void 0) {
      return valueFromInitial;
    }
    const target = this.getBaseTargetFromProps(this.props, key2);
    if (target !== void 0 && !isMotionValue(target))
      return target;
    return this.initialValues[key2] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key2];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].notify(...args);
    }
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/DOMVisualElement.mjs
var DOMVisualElement = class extends VisualElement {
  constructor() {
    super(...arguments);
    this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(a, b) {
    return a.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key2) {
    return props.style ? props.style[key2] : void 0;
  }
  removeValueFromRenderState(key2, { vars, style }) {
    delete vars[key2];
    delete style[key2];
  }
};

// ../../node_modules/framer-motion/dist/es/render/html/HTMLVisualElement.mjs
function getComputedStyle(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "html";
  }
  readValueFromInstance(instance, key2) {
    if (transformProps.has(key2)) {
      const defaultType = getDefaultValueType(key2);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle(instance);
      const value = (isCSSVariableName(key2) ? computedStyle.getPropertyValue(key2) : computedStyle[key2]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, options, props) {
    buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps(props, prevProps, visualElement);
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const { children } = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on("change", (latest) => {
        if (this.current)
          this.current.textContent = `${latest}`;
      });
    }
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderHTML(instance, renderState, styleProp, projection);
  }
};

// ../../node_modules/framer-motion/dist/es/render/svg/SVGVisualElement.mjs
var SVGVisualElement = class extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
  }
  getBaseTargetFromProps(props, key2) {
    return props[key2];
  }
  readValueFromInstance(instance, key2) {
    if (transformProps.has(key2)) {
      const defaultType = getDefaultValueType(key2);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key2 = !camelCaseAttributes.has(key2) ? camelToDash(key2) : key2;
    return instance.getAttribute(key2);
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps2(props, prevProps, visualElement);
  }
  build(renderState, latestValues, options, props) {
    buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
var createDomVisualElement = (Component2, options) => {
  return isSVGComponent(Component2) ? new SVGVisualElement(options, { enableHardwareAcceleration: false }) : new HTMLVisualElement(options, {
    allowProjection: Component2 !== Fragment11,
    enableHardwareAcceleration: true
  });
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout.mjs
var layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs
var preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
};
var motion = /* @__PURE__ */ createMotionProxy((Component2, config) => createDomMotionConfig(Component2, config, preloadedFeatures, createDomVisualElement));

// src/geo/locations/components/GeoLocationsEditor.tsx
import { useLogger } from "shared-lib";
import { Button as Button12, ButtonList as ButtonList4 } from "shared-ui";

// src/geo/locations/components/GeoLocationsSearchContainer.tsx
import { useCallback as useCallback31, useState as useState15 } from "react";
import { Button as Button11, CheckBox } from "shared-ui";

// src/lib/DefaultCountry.ts
var DefaultGeoCountry = {
  iso3: "GBR",
  name: "United Kingdom",
  phone: "44"
};

// src/geo/locations/components/GeoLocationsSearchBox.tsx
import { useCallback as useCallback30, useEffect as useEffect9, useMemo as useMemo17, useState as useState14 } from "react";
import { ErrorBoundary as ErrorBoundary13 } from "react-error-boundary";
import { ChevronUpDownIcon as ChevronUpDownIcon5 } from "@heroicons/react/24/solid";
import { Combobox as Combobox10 } from "@headlessui/react";
import { Suspense as Suspense23 } from "shared-ui";

// src/geo/locations/components/__generated__/GeoLocationsSearchOptionsQuery.graphql.ts
var node37 = /* @__PURE__ */ function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "countryCode"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "adminLevel",
    "storageKey": null
  }, v6 = [
    {
      "alias": "locations",
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        },
        {
          "kind": "Variable",
          "name": "countryCode",
          "variableName": "countryCode"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "locationAutocomplete",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "osmId",
          "storageKey": null
        },
        v3,
        v4,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latitude",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "longitude",
          "storageKey": null
        },
        v5,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AddressEntry",
          "kind": "LinkedField",
          "name": "addressInfo",
          "plural": true,
          "selections": [
            v4,
            v3,
            v5
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "GeoLocationsSearchOptionsQuery",
      "selections": v6,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v2,
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "GeoLocationsSearchOptionsQuery",
      "selections": v6
    },
    "params": {
      "cacheID": "b354d1d8bb14077aa034d1f0f6bcaf9c",
      "id": null,
      "metadata": {},
      "name": "GeoLocationsSearchOptionsQuery",
      "operationKind": "query",
      "text": "query GeoLocationsSearchOptionsQuery(\n  $query: String!\n  $countryCode: String!\n  $count: Int!\n) {\n  locations: locationAutocomplete(query: $query, countryCode: $countryCode, count: $count) {\n    osmId\n    type\n    name\n    latitude\n    longitude\n    adminLevel\n    countryCode\n    addressInfo {\n      name\n      type\n      adminLevel\n    }\n  }\n}\n"
    }
  };
}();
node37.hash = "e003a786e864725ed03b4b960be77b16";
var GeoLocationsSearchOptionsQuery_graphql_default = node37;

// src/geo/locations/components/GeoLocationsSearchOptions.tsx
import { useLazyLoadQuery as useLazyLoadQuery10 } from "react-relay";
import { Combobox as Combobox9 } from "@headlessui/react";
import { CheckIcon as CheckIcon5 } from "@heroicons/react/24/solid";
import { isNotNull as isNotNull6 } from "shared-lib";
import { classNames as classNames6 } from "shared-ui";
import { Fragment as Fragment12, jsx as jsx53, jsxs as jsxs42 } from "react/jsx-runtime";
var queryDef9 = GeoLocationsSearchOptionsQuery_graphql_default;
var GeoLocationsSearchOptions = ({
  term,
  countryCode,
  count
}) => {
  const query = useLazyLoadQuery10(
    queryDef9,
    { query: term, countryCode, count: count || 10 },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { locations } = query;
  const rows = (locations ?? []).filter(isNotNull6);
  return /* @__PURE__ */ jsx53(Combobox9.Options, { className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: rows.map((result) => {
    const adminLevel = (level) => result.addressInfo.find((info) => info.adminLevel === level)?.name || "";
    return /* @__PURE__ */ jsx53(
      Combobox9.Option,
      {
        value: result,
        className: ({ active }) => classNames6(
          "relative cursor-default select-none py-2 pl-3 pr-9",
          active ? "bg-info-600 text-white" : "text-gray-900"
        ),
        children: ({ active, selected }) => /* @__PURE__ */ jsxs42(Fragment12, { children: [
          /* @__PURE__ */ jsx53("div", { className: "flex", children: /* @__PURE__ */ jsx53(
            "span",
            {
              className: classNames6(
                "truncate",
                selected ? "font-semibold" : ""
              ),
              children: result ? `${[
                result.name,
                adminLevel(5 /* COMBINED_AUTHORITIES */)
              ].filter((x) => x != "").join(", ")} (${[
                .../* @__PURE__ */ new Set([
                  adminLevel(4 /* STATE */),
                  result.countryCode
                ])
              ].join(", ")})` : ""
            }
          ) }),
          selected && /* @__PURE__ */ jsx53(
            "span",
            {
              className: classNames6(
                "absolute inset-y-0 right-0 flex items-center pr-4",
                active ? "bg-info-600 text-white" : "text-info-600"
              ),
              children: /* @__PURE__ */ jsx53(CheckIcon5, { className: "h-5 w-5", "aria-hidden": "true" })
            }
          )
        ] })
      },
      result.osmId.toString()
    );
  }) });
};

// src/geo/locations/components/GeoLocationsSearchBox.tsx
import { jsx as jsx54, jsxs as jsxs43 } from "react/jsx-runtime";
var compareResults5 = (a, b) => a?.osmId === b?.osmId;
var GeoLocationsSearchBox = ({
  name,
  placeholder,
  countryCode,
  onSelected,
  value
}) => {
  const [selected, setSelected] = useState14(value);
  const [searchTerm, setSearchTerm] = useState14("");
  const onQueryChangeHandler = useMemo17(
    () => debounce_default((q) => setSearchTerm(q), 500),
    []
  );
  useEffect9(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const onSetSelected = useCallback30(
    (result) => {
      setSelected(result);
      onSelected(result);
    },
    [onSelected]
  );
  return /* @__PURE__ */ jsx54(
    Combobox10,
    {
      as: "div",
      name,
      className: "w-full",
      value: selected ?? null,
      onChange: onSetSelected,
      by: compareResults5,
      children: /* @__PURE__ */ jsxs43("div", { className: "relative mt-2", children: [
        /* @__PURE__ */ jsx54(
          Combobox10.Input,
          {
            className: "focus:border-info-500 focus:ring-info-500 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
            onChange: (event) => onQueryChangeHandler(event.target.value),
            placeholder: placeholder || "Search Locations",
            displayValue: (result) => {
              if (!result) {
                return "";
              }
              return `${result.name} (${result.countryCode})`;
            },
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx54(
          Combobox10.Button,
          {
            className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
            "aria-label": "Search locations",
            children: /* @__PURE__ */ jsx54(
              ChevronUpDownIcon5,
              {
                className: "h-5 w-5 text-gray-600",
                "aria-hidden": "true"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx54(ErrorBoundary13, { FallbackComponent: SearchErrorBoundaryFallback, children: /* @__PURE__ */ jsx54(Suspense23, { fallback: "Searching...", children: searchTerm && /* @__PURE__ */ jsx54(
          GeoLocationsSearchOptions,
          {
            term: searchTerm,
            countryCode,
            count: 10
          }
        ) }) })
      ] })
    }
  );
};

// src/geo/locations/components/GeoLocationsSearchContainer.tsx
import { Controller as Controller5 } from "react-hook-form";
import { Fragment as Fragment13, jsx as jsx55, jsxs as jsxs44 } from "react/jsx-runtime";
var GeoLocationsSearchContainer = ({
  name,
  control,
  isRemoteLocation = false,
  placeholder,
  currentLocations,
  autoClearSelected,
  onSearchCompleted,
  onToggleRemoteLocation,
  onCountryChanged
}) => {
  const [countryName, setCountryName] = useState15(
    currentLocations?.[0]?.countryName || DefaultGeoCountry.name
  );
  const [countryCode, setCountryCode] = useState15(
    currentLocations?.[0]?.countryCode || DefaultGeoCountry.iso3
  );
  const [isChangingCountry, setIsChangingCountry] = useState15(false);
  const [selectedResult, setSelectedResult] = useState15(null);
  const changeCountry = useCallback31(
    (result) => {
      setCountryCode(result.iso3);
      setCountryName(result.name);
      setIsChangingCountry(false);
      if (onCountryChanged) {
        onCountryChanged(result);
      }
    },
    [onCountryChanged]
  );
  const onSetSelected = useCallback31(
    (result) => {
      if (autoClearSelected) {
        setSelectedResult(null);
      } else {
        setSelectedResult(result);
      }
      onSearchCompleted(result);
    },
    [autoClearSelected, onSearchCompleted]
  );
  return /* @__PURE__ */ jsxs44("div", { className: "", children: [
    /* @__PURE__ */ jsxs44("div", { className: "mb-2 flex items-center justify-between lg:mb-4", children: [
      /* @__PURE__ */ jsxs44("div", { className: "flex hidden flex-wrap items-center gap-1 text-sm text-gray-500 sm:flex", children: [
        /* @__PURE__ */ jsx55("p", { children: "Searching Locations in: " }),
        isChangingCountry ? /* @__PURE__ */ jsx55(
          motion.div,
          {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            children: /* @__PURE__ */ jsx55(
              GeoCountriesSearchContainer,
              {
                name: "location-country-search",
                onSearchCompleted: changeCountry
              }
            )
          }
        ) : /* @__PURE__ */ jsx55("span", { className: "py-2 font-bold text-black", children: countryName })
      ] }),
      /* @__PURE__ */ jsxs44("div", { className: "flex flex-wrap items-center gap-1 text-sm text-gray-500 sm:hidden ", children: [
        /* @__PURE__ */ jsx55("p", { children: "Searching Locations in: " }),
        /* @__PURE__ */ jsx55("span", { className: "py-2 font-bold text-black", children: countryName })
      ] }),
      /* @__PURE__ */ jsx55("div", { children: isChangingCountry ? /* @__PURE__ */ jsx55(
        Button11,
        {
          "aria-label": "Cancel",
          clicked: () => setIsChangingCountry(false),
          children: "Cancel"
        }
      ) : /* @__PURE__ */ jsx55(
        Button11,
        {
          "aria-label": "Change country",
          clicked: () => setIsChangingCountry(true),
          children: "Change"
        }
      ) })
    ] }),
    control && /* @__PURE__ */ jsxs44("div", { className: "flex items-center gap-2 space-x-4 lg:mb-4", children: [
      /* @__PURE__ */ jsx55("p", { className: "text-sm", children: "Remote Location" }),
      /* @__PURE__ */ jsx55("div", { className: "col-span-2", children: /* @__PURE__ */ jsx55(
        Controller5,
        {
          control,
          name: "isRemoteLocation",
          render: ({ field: { onChange, value } }) => /* @__PURE__ */ jsx55(
            CheckBox,
            {
              checked: value,
              onChanged: () => {
                onChange(!value);
                onToggleRemoteLocation && onToggleRemoteLocation(countryCode, countryName, !value);
              }
            },
            isChangingCountry.toString()
          )
        }
      ) })
    ] }),
    isChangingCountry && /* @__PURE__ */ jsx55(
      motion.div,
      {
        className: "mb-4 sm:hidden",
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        children: /* @__PURE__ */ jsx55(
          GeoCountriesSearchContainer,
          {
            name: "location-country-search",
            onSearchCompleted: changeCountry
          }
        )
      }
    ),
    !isRemoteLocation && /* @__PURE__ */ jsxs44(Fragment13, { children: [
      /* @__PURE__ */ jsx55("p", { children: "Location*" }),
      /* @__PURE__ */ jsx55(
        GeoLocationsSearchBox,
        {
          name: name || "geo-countries-search",
          placeholder,
          countryCode,
          onSelected: onSetSelected
        }
      )
    ] })
  ] });
};

// src/geo/locations/components/GeoLocationsEditor.tsx
import { jsx as jsx56, jsxs as jsxs45 } from "react/jsx-runtime";
function key(result) {
  return `${result.name}.${result.countryCode}.${result.latitude}.${result.longitude}`.toLowerCase();
}
function index(result) {
  return {
    ...result,
    id: key(result)
  };
}
var GeoLocationsEditor = ({
  name,
  locations,
  onChanged,
  control,
  onCountryChanged,
  isRemoteLocation = false
}) => {
  const [log] = useLogger();
  const [currentLocations, setCurrentLocations] = useState16(() => {
    if (locations) {
      return locations.map(index);
    }
    return [];
  });
  useEffect10(() => {
    onChanged(
      currentLocations.map((l) => ({
        countryCode: l.countryCode,
        latitude: l.latitude,
        longitude: l.longitude,
        name: l.name,
        entireCountry: l.entireCountry || false
      }))
    );
  }, [currentLocations, onChanged]);
  const onAddLocation = useCallback32((selected) => {
    const location = {
      countryCode: selected.countryCode,
      latitude: selected.latitude,
      longitude: selected.longitude,
      name: selected.name,
      entireCountry: false
    };
    setCurrentLocations((current) => {
      return [...current, index(location)];
    });
  }, []);
  const [selectedId, setSelectedId] = useState16(null);
  const selectedItem = currentLocations.find((l) => l.id === selectedId);
  const onSelect = useCallback32(
    (location) => {
      if (!location) {
        return;
      }
      log(`selected ${location.id}`);
      setSelectedId(location.id);
    },
    [log]
  );
  const onToggleRemoteLocation = useCallback32(
    (countryCode, countryName, isRemote) => {
      if (isRemote === true) {
        const location = {
          countryCode,
          name: countryName,
          latitude: 0,
          longitude: 0,
          entireCountry: true
        };
        setCurrentLocations && setCurrentLocations([index(location)]);
      } else {
        setCurrentLocations && setCurrentLocations([]);
      }
    },
    [setCurrentLocations]
  );
  const onRemove = useCallback32(
    (location) => {
      setCurrentLocations((current) => {
        return current.filter((l) => l.id !== location.id);
      });
      setSelectedId(null);
    },
    [setCurrentLocations]
  );
  const rows = currentLocations.map((location) => {
    return selectedItem && selectedItem.id === location.id ? /* @__PURE__ */ jsxs45(
      motion.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "rounded-lg border bg-orange-200 px-4 py-4 shadow",
        children: [
          /* @__PURE__ */ jsx56("div", { className: "py-2 font-medium text-gray-900", children: selectedItem.name }),
          /* @__PURE__ */ jsxs45(ButtonList4, { children: [
            /* @__PURE__ */ jsx56(
              Button12,
              {
                color: "gray",
                clicked: () => {
                  setSelectedId(null);
                },
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx56(
              Button12,
              {
                color: "warning",
                confirmMessage: "Remove, Are you sure?",
                clicked: () => {
                  onRemove(selectedItem);
                },
                children: "Remove"
              }
            )
          ] })
        ]
      }
    ) : /* @__PURE__ */ jsx56(
      "li",
      {
        className: "cursor-pointer",
        onClick: () => onSelect(location),
        children: /* @__PURE__ */ jsx56("div", { className: "flex flex-col rounded-xl border bg-white px-4 py-3", children: /* @__PURE__ */ jsx56("div", { className: "flex items-baseline justify-between text-sm", children: /* @__PURE__ */ jsx56("div", { className: "cursor-pointer font-medium text-gray-900 hover:bg-gray-50", children: `${location.name} (${location.countryCode})` }) }) })
      },
      location.id
    );
  });
  const placeholder = "Search Locations";
  return /* @__PURE__ */ jsxs45("div", { className: "relative flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx56("div", { className: "", children: /* @__PURE__ */ jsx56(
      GeoLocationsSearchContainer,
      {
        name: name || "location-search",
        placeholder,
        onSearchCompleted: onAddLocation,
        control,
        isRemoteLocation,
        currentLocations,
        onToggleRemoteLocation,
        onCountryChanged: () => {
          onCountryChanged();
          setCurrentLocations([]);
        }
      }
    ) }),
    !isRemoteLocation && rows.length > 0 && /* @__PURE__ */ jsx56("div", { className: "grid grid-cols-1 gap-2", children: /* @__PURE__ */ jsx56("div", { className: "py-2", children: /* @__PURE__ */ jsx56("ul", { role: "list", className: "flex flex-1 flex-col gap-2", children: rows }) }) })
  ] });
};

// src/geo/locations/components/GeoLocationsSearchBoxInput.tsx
import { Controller as Controller6 } from "react-hook-form";
import { jsx as jsx57 } from "react/jsx-runtime";
var GeoLocationsSearchBoxInput = ({
  name,
  countryCode,
  control,
  onSelected
}) => {
  return /* @__PURE__ */ jsx57(
    Controller6,
    {
      control,
      name,
      render: ({ field: { onChange: onControllerChange, value } }) => {
        return /* @__PURE__ */ jsx57(
          GeoLocationsSearchBox,
          {
            countryCode,
            name,
            onSelected: (result) => {
              onControllerChange(result);
              if (onSelected) {
                onSelected(result);
              }
            },
            value: value ?? null
          }
        );
      }
    }
  );
};
export {
  CompaniesSearchBox,
  CompaniesSearchBoxInput,
  CompaniesSearchContainer,
  DefaultGeoCountry,
  GeoCountriesSearchBox,
  GeoCountriesSearchBoxInput,
  GeoCountriesSearchContainer,
  GeoCountriesSearchOptions,
  GeoLocationsEditor,
  GeoLocationsSearchBox,
  GeoLocationsSearchBoxInput,
  GeoLocationsSearchContainer,
  GeoLocationsSearchOptions,
  Home,
  IndustrySearchBox2 as IndustrySearchBox,
  IndustrySearchBoxInput,
  IndustrySearchContainer,
  IndustrySearchListModal,
  Layout10 as Layout,
  SearchErrorBoundaryFallback,
  createCompaniesRoute,
  createDataManagementRoutes,
  index,
  industrySearchBoxQueryDef
};
/*! Bundled license information:

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.mjs.map